class FrameForestApp {
    constructor(collage) {
        this.state = this.createGlobalState(collage);
        this.initProperties(collage);

    }

    // Initializes all app-level properties, limits, UI state,
    async initProperties(collage = 5) {
        // --- 1. Static mappings and state ---
        this.uploadIndex = null;
        this._reordering = false;
        this.addToCartInProcess = false;
        this.sortable = null; 

        this.frames = [];
        this.blobs = new Map();      // url -> {id, blob, created, size}
        this.timers = new Set();     // timer IDs
        this.listeners = new Map();  // element -> [listeners]
        this.observers = new Set();  
        this.intervals = new Set();  
        this.animationFrames = new Set();

        this.IMAGE_STATUS = {
            PENDING: 'pending',
            UPLOADING: 'uploading',
            UPLOADED: 'uploaded',
            ERROR: 'error'
        };

        this.UPLOAD_QUEUE_STATUS = {
            WAITING: 'waiting',
            PROCESSING: 'processing',
            COMPLETED: 'completed',
            FAILED: 'failed'
        };

        this.limits = {
            maxBlobs: 100,
            maxBlobAge: 600000,      // 10 min
            maxMemoryMB: 500,        // 500 MB
            maxImageSize: 50 * 1024 * 1024, // 50 MB
            cleanupInterval: 300000  // 5 min
        };

        this.metrics = {
            totalBlobsCreated: 0,
            totalBlobsRevoked: 0,
            totalMemoryUsed: 0,
            totalCleanups: 0,
            memoryWarnings: 0,
            lastCleanup: null,
            peakMemoryUsage: 0
        };

        // --- 2. External / UI setup ---
        this.fileStack = filestack.init('Av52UkFmsQ1aDQgxjEjyrz');
        this.trimSpacing = 0.1;
        this.borderTBA = 0.2;
        this.frameBorder = 0.87;
        this.dpi = 300;

        // Device type detection
        this.dType = window.innerWidth <= 868 ? 'M' : 'D';
        this.eventType = this.dType === "D" ? "click" : "touchstart";
        this.boundHandlers = { zoomButtonHandlers: new Map() };
        this.handlersInitialized = false;
        this.ui = {};

        this.data= null;
        this.db= null;
        this.isSaving = false;
        this.queue = [];
        this.lastSaveTime = 0;
        this.minInterval = 500;
        this.isFallback= false;
        this.persistData = false;
        await this.init();

        this.updateCollageSize("Medium / Oak"); 
        
        this.initElements();
        this.render();
        window.Clg.State = this.state;

        this.setupEventListenersG();
        this.renderSizeOptions();
        this.renderStyleOptions();
        this.buildFramesSummary()
    }

    // Updates collage configuration when size or style changes.
    // Recalculates all layout, scaling, and rendering dimensions.
    updateCollageSize(newSize) {

        if(this.persistData) {
            newSize = `${this.collage.size} / ${this.collage.style}`;
        }

        this.collageVariantData = this.getVariantData(newSize);

        this.pu = this.getDefaultPu();

        // Update config based on new size
        this.config = this.formatCollageConfig(newSize);

        if(!this.collage){
            // Create a fresh collage object for new size
            this.collage = this.createCollageObject({
                collageId: this.generateCollageId(),
                layout: "grid",
                price: this.collageVariantData.price,
                size: newSize.split(" / ")[0],
                style: newSize.split(" / ")[1],
                width: this.config.canvas.width,
                height: this.config.canvas.height,
                variantID: this.collageVariantData.id,
                frames: []
            });
        }
        
        if(!this.photoLabels){
            this.photoLabels = Object.keys(this.config.windows).map((_, i) => `Photo ${i + 1}`);
        }
        if(!this.images){
            this.images = Array(Object.keys(this.config.windows).length).fill(null);
        }else {
            const winLen = Object.keys(this.config.windows).length;
            if (this.images.length > winLen) {
                this.images = this.images.slice(0, winLen);
            } else if (this.images.length < winLen) {
                this.images = [
                    ...this.images,
                    ...Array(winLen - this.images.length).fill(null)
                ];
            }
        }

        if(!this.posToIndex){
            this.posToIndex = {};
            for (let i = 0; i < Object.keys(this.config.windows).length; i++) {
                this.posToIndex[i] = i;
            }
        }
        // Recalculate scaling and dimensions
        this.calculateUIDimensions();
        this.scaledBeforeAdjustMent = this.calculateScaledDimensions(this.config);
        this.adjusted = this.adjustCollage2(this.config);
        this.scaled = this.calculateScaledDimensions(this.adjusted);
        this.full = this.calculatFullDimensions(this.adjusted);

        // Apply updated state
        this.updateGState({posToIndex: this.posToIndex, photoLabels: this.photoLabels, images: this.images, scaled: this.scaled, full: this.full,  Collage: this.collage  });
    }

    // Method to calculate and update UI dimensions
    calculateUIDimensions() {
        if (this.dType === "M") {
            const elHeight = selector => this.S$Q(selector)?.offsetHeight || 0;
            const bannerHeight = ['.cfp-h_banner'].reduce((sum, sel) => sum + elHeight(sel), 0);
            const headHeight = ['.cfp-h_banner', 'header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
            this.ui.galHeight = window.innerHeight - ['.cfp-h_banner', 'header.header', '.cl_sidebar', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
            this.ui.epuHeight = window.innerHeight - ['.cfp-h_banner', 'header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
            this.ui.epuBodyHeight = this.ui.epuHeight - 160;
            this.ui.epuFooterHeight = this.ui.epuHeight - this.ui.epuBodyHeight;
            this.S$Q(".cl_wrapper").style.height = this.ui.galHeight + "px";
            // this.S$Q(".cl_wrapper").style.height = "200" + "px";
            const navHeight = window.screen.height - window.innerHeight;
            // this.S$Q(".cl_sbmd").style.paddingBottom = navHeight + "px";
            // this.S$Q(".cl_epu-box").style.top = (headHeight - (bannerHeight * 0.35)) + "px";
            this.S$Q(".cl_delivery_info").style.top = (headHeight - bannerHeight) + "px";


            this.S$Q(".cl_epu-box").style.height = (this.ui.epuHeight + (bannerHeight * 0.35)) + "px";
            this.ui.editMidAreaAvail = ((this.ui.epuHeight + (bannerHeight * 0.35)) * 0.5)
            // this.S$Q(".cl_epu-body").style.maxHeight = this.ui.epuBodyHeight + "px";
            // this.S$Q(".cl_epu-body").style.height = this.ui.epuBodyHeight + "px";
            this.S$Q(".cl_epu-footer").style.height = this.ui.epuFooterHeight + "px";
            document.documentElement.style.setProperty(`--total-header-height`, `${headHeight}px`)
        }else{
            const elHeight = selector => this.S$Q(selector)?.offsetHeight || 0;
            this.ui.headHeight = ['.cfp-h_banner', 'header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
            this.ui.galHeight = window.innerHeight - ['.cfp-h_banner', 'header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
            this.ui.epuHeight = window.innerHeight - ['.cfp-h_banner', 'header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
            this.ui.epuBodyHeight = this.ui.epuHeight - 160;
            this.ui.epuFooterHeight = this.ui.epuHeight - this.ui.epuBodyHeight;
        }
        
    }
    
    // ================================================================
    // INITIALIZATION
    // ================================================================
    
    //  Dynamically loads the `idb` library if it is not already available. 
    async loadIdbLibrary() {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://unpkg.com/idb@7/build/umd.js';
            script.onload = () => {
                if (window.idb && typeof window.idb.openDB === 'function') {
                    resolve();
                } else {
                    reject(new Error('Failed to load idb library'));
                }
            };
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    // Initializes IndexedDB using the `idb` wrapper. 
    async initDB() {
          if (this.db || this.isFallback || window.db) {
            console.log('ℹ️ Database already initialized');
            return this.db || window.db || null;
          }

          console.log('🗄️ Pg.State: Initializing IndexedDB');

          try {
            
            if (!('indexedDB' in window)) throw new Error('IndexedDB not supported');
            // if (typeof window.idb?.openDB !== 'function') throw new Error('idb library not available');
            // Load idb library dynamically if not available
            if (!window.idb || typeof window.idb.openDB !== 'function') {
                await this.loadIdbLibrary();
            }

            this.db = await window.idb.openDB('pgStateDB', 3, {
                upgrade(db, oldVersion, newVersion) {
                    if (!db.objectStoreNames.contains('appState')) {
                        const store = db.createObjectStore('appState', { keyPath: 'id' }); 
                        store.createIndex('timestamp', 'timestamp');
                    }
                },
            });

            console.log('✅ IndexedDB initialized successfully');
          } catch (err) {
            console.log('⚠️ IndexedDB failed. ', err);
            this.isFallback = true;
          }

          return this.db || null;
      }

    // Initializes the application state. (Restores UI state when saved data exists)
    async init(initialData = {}) {
      console.log('🏗️ Initializing Products Gallery State...');
      
      await this.initDB();
      const savedState = await this.loadFromDB();
      if (savedState?.Collage?.frames?.length > 0) {
        console.log('📂 Loaded existing state');
        const collage = savedState.Collage;

        // const allImagesNull = images.every(img => img === null);
        const frames = [...savedState.Collage.frames];
        const images = [...(savedState.images || [])];

        // Build lookup maps by editPos (safe)
        const framesByEditPos = new Map();
        frames.forEach((frame, idx) => {
            if (frame?.editPos != null && !framesByEditPos.has(frame.editPos)) {
                framesByEditPos.set(frame.editPos, idx);
            }
        });

        const imagesByEditPos = new Map();
        images.forEach((img, idx) => {
            if (img?.editPos != null && !imagesByEditPos.has(img.editPos)) {
                imagesByEditPos.set(img.editPos, idx);
            }
        });

        framesByEditPos.forEach((frameIdx, editPos) => {
            if (!imagesByEditPos.has(editPos)) {
                frames[frameIdx] = null;
            }
        });

        imagesByEditPos.forEach((imgIdx, editPos) => {
            if (!framesByEditPos.has(editPos)) {
                images[imgIdx] = null;
            }
        });

        let orderMismatch = false;

        frames.forEach(frame => {
        if (!frame) return;
            const img = images.find(i => i?.editPos === frame.editPos);
            if (!img) orderMismatch = true;
        });

        images.forEach(img => {
        if (!img) return;
            const frame = frames.find(f => f?.editPos === img.editPos);
            if (!frame) orderMismatch = true;
        });

        const allImagesNull = images.every(img => img === null);
      
        if (orderMismatch) {

            this.persistData = false;
            this.data = this.state;

        } else {

            this.persistData = true;
            this.collage = savedState.Collage;
            this.frames = savedState.Collage.frames
            this.images = savedState.images;

            if (!allImagesNull) {
             this.posToIndex = savedState.posToIndex;
            }else{
                savedState.posToIndex = this.posToIndex;
            }

            this.state = savedState;
            // this._restoreUIFromState(savedState);
            this.data = savedState;
        }

      } else {
        console.log('🆕 Creating new state');
        this.persistData = false;
        this.data = this.state;
      }
      
      return this.data;
    }

    // ================================================================
    // PERSISTENCE
    // ================================================================
   
    //* Creates a safe, serializable copy of the application state , before persisting it to storage.
    sanitizeAppStateForStorage(state) {
      let clone;
      try {
        clone = typeof structuredClone === "function"
          ? structuredClone(state)
          : JSON.parse(JSON.stringify(state));
      } catch (e) {
        console.error("Error cloning app state:", e);
        return state;
      }

      clone.frames?.forEach(frame => {
        if (frame?.image?.file !== undefined) {
          delete frame.image.file;
        }
      });

      return clone;
    }

    // Persists application state to IndexedDB or localStorage.
    async saveToDB() {
        const data = this.data;
        if (!this.data) return false;

        // push a copy into the queue
        let dataToSave = data;
        if(this.isFallback) dataToSave = JSON.parse(JSON.stringify(data))
        this.queue.push(dataToSave);

        if (this.isSaving) return;

        this.isSaving = true;

        while (this.queue.length > 0) {
            const now = Date.now();
            const elapsed = now - this.lastSaveTime;

            // throttle
            if (elapsed < this.minInterval) {
                await new Promise(r => setTimeout(r, this.minInterval - elapsed));
            }

            const currentData = this.queue.shift(); 

            try {
                currentData.timestamp = Date.now();
                const safeData = this.sanitizeAppStateForStorage(currentData);
                const productKey = window.ProductId || 'default';

                if (this.isFallback) {
                    localStorage.setItem(`pgAppState_${productKey}`, JSON.stringify(safeData));
                } else {
                    const tx = this.db.transaction(['appState'], 'readwrite');
                    await tx.objectStore('appState').put({ id: productKey, ...safeData });
                    await tx.complete;
                }
            } catch (error) {
                console.error('❌ Failed to save state:', error);
            }
        }

        this.isSaving = false;
        return true;
    }

    // Clears persisted application state from storage and resets in-memory state tracking.
    async clearSavedState() {
        try {
            const productKey = window.ProductId || 'default';

            if (this.isFallback) {
                localStorage.removeItem(`pgAppState_${productKey}`);
            } else {
                const tx = this.db.transaction(['appState'], 'readwrite');
                await tx.objectStore('appState').delete(productKey);
                await tx.complete;
            }

            console.log(`🧹 Cleared saved state for key: ${productKey}`);
        } catch (error) {
            console.error('❌ Failed to clear saved state:', error);
        }

        // Also clear in-memory state
        this.data = null;
        this.queue = [];
        this.lastSaveTime = 0;
    }

    // Start uploads for frames that need uploading
    async startUploadsForFrames(frameIds = null) {
      if (!frameIds) {
        // Get all frames that need uploading
        const framesNeedingUpload = this.getFramesNeedingUpload();
        frameIds = framesNeedingUpload.map(f => f.id);
      }

      if (frameIds.length === 0) {
        console.log('ℹ️ No frames need uploading');
        return;
      }

      console.log(`📋 Adding ${frameIds.length} frames to upload queue`);
      
      // Add frames to upload queue
      frameIds.forEach(async frameId => {
        const frame = this.frames.find(f => f?.id === frameId);
        const i = this.frames.findIndex(f => f?.id === frameId);
        let orgI = this.images.findIndex(img => img?.originalPos == frame?.originalPos);

        const filestackUrl = await this.uploadFrameToFilestack(frame);

        if (orgI == -1) orgI = i;
        this.images[orgI] = {
            ...this.images[orgI],
            previewURL: filestackUrl,
            filestackUrl,
            status: this.IMAGE_STATUS.UPLOADED,
            file: null,
        };

        this.frames[i] = {
            ...this.frames[i],
            image: {
            ...this.frames[i].image,
                filestackUrl,
                previewURL: filestackUrl,
                status: this.IMAGE_STATUS.UPLOADED
            }
        };

        this.collage.frames[i] = {
            ...this.collage.frames[i],
            image: {
                ...this.collage.frames[i].image,
                filestackUrl,
                previewURL: filestackUrl,
                status: this.IMAGE_STATUS.UPLOADED
            }
        };

        this.updateGState({
            images: this.images,
            Collage: this.collage,
            Frames: this.frames
        });

        this.checkAllImagesUploaded();
      });
    }

    // Resume uploads on page load
    async resumeUploads() {
      // Check for frames that need uploading
      const framesNeedingUpload = this.getFramesNeedingUpload();
      
      if (framesNeedingUpload.length > 0) {
        console.log(`📋 Found ${framesNeedingUpload.length} frames needing upload`);
        await this.startUploadsForFrames();
      } else {
        console.log('✅ No uploads needed to resume');
      }
    }

     // Get frames that need to be uploaded (have file but no filestackUrl)
    getFramesNeedingUpload() {
      if (!this.data?.Frames) return [];
      
      return this.data.Frames.filter(frame => 
        frame && (frame?.image?.file || frame?.image?.previewURL) && 
        !frame?.image?.filestackUrl && 
        frame?.image?.status !== this.IMAGE_STATUS.UPLOADED
      );
    }
    
    // Loads persisted application state from storage.
    async loadFromDB() {

        const productKey = window.ProductId || 'default';

        try {
            let savedState = null;

            if (this.isFallback) {
                const raw = localStorage.getItem(`pgAppState_${productKey}`);
                savedState = raw ? JSON.parse(raw) : null;
                console.log(`📂 Loaded state from localStorage for product ${productKey}`);
            } else {
                const tx = this.db.transaction(['appState'], 'readonly');
                savedState = await tx.objectStore('appState').get(productKey);
                console.log(`📂 Loaded state from IndexedDB for product ${productKey}`);
            }

            if (savedState) {
                 // this.clearError('database');
            }

            // Resume uploads if there are frames that need uploading
            setTimeout(() => {
                if (Array.isArray(savedState?.images) &&
                savedState.images.some(i => i !== null) && typeof this.resumeUploads === 'function') {
                    this.resumeUploads();
                }
            }, 2000);

            return savedState;
        } catch (error) {
            console.error('❌ Failed to load state:', error);
            // this.setError('database', `Load failed: ${error.message}`);
            throw error;
        }
    }
      
    // Clears persisted application state for a specific product.
    async clearDB(productId = window.ProductId || 'default') {
        if (this.isFallback) {
            localStorage.removeItem(`pgAppState_${productId}`);
            console.log(`🗑️ Cleared state from localStorage for product ${productId}`);
            return true;
        }

        const tx = this.db.transaction(['appState'], 'readwrite');
        await tx.objectStore('appState').delete(productId);
        await tx.complete;
        console.log(`🗑️ Cleared state from IndexedDB for product ${productId}`);
        return true;
    }

    // Create the global state object
    createGlobalState(collage = 5) {
        const configMap = this.getConfigMap();
        const config = configMap[collage] || configMap[1];
        const windowCount = Object.keys(config.windows).length;

        return {
            // Configuration
            // config: config,
            // configMap: configMap,

            // Images and editing
            images: null,
            posToIndex: null,
            scaled: null,
            full: null,
            // UI state
            photoLabels: null,
            dType: window.innerWidth <= 800 ? 'M' : window.innerWidth <= 868 ? 'M' : 'D',
        };
    }

    getConfigMap() {
        return {
            1: { // 3 horizontal
                canvas: { width: 21.084, height: 10.056 },
                windows: {
                    1: { width: 5, height: 6, top: 2.028, left: 2.028 },
                    2: { width: 5, height: 6, top: 2.028, left: 8.042 },
                    3: { width: 5, height: 6, top: 2.028, left: 14.056 }
                }
            },
            2: { // 2 horizontal
                canvas: { width: 21.084, height: 10.056 },
                windows: {
                    1: { width: 8.007, height: 6, top: 2.028, left: 2.028 },
                    2: { width: 8.007, height: 6, top: 2.028, left: 11.049 },
                }
            },
            3: { // 3 vertical
                canvas: { width: 10.88, height: 31.32 },
                windows: {
                    1: { width: 6, height: 8, top: 2.44, left: 2.5 },
                    2: { width: 6, height: 8, top: 11.66, left: 2.5 },
                    3: { width: 6, height: 8, top: 20.88, left: 2.5 }
                },
            },
            4: { // 2 vertical
                canvas: { width: 10.82, height: 22 },
                windows: {
                    1: { width: 6, height: 8, top: 2.4, left: 2.41 },
                    2: { width: 6, height: 8, top: 11.6, left: 2.41 },
                },
            },
            5: { // 4-image grid
                canvas: { width: 14.27, height: 14.27 },
                windows: {
                    1: { width: 4.6, height: 4.6, top: 2.028, left: 2.028 },
                    2: { width: 4.6, height: 4.6, top: 2.028, left: 7.642 },
                    3: { width: 4.6, height: 4.6, top: 7.642, left: 2.028 },
                    4: { width: 4.6, height: 4.6, top: 7.642, left: 7.642 }
                },
            },
        };
    }
    formatCollageConfig(format) {
        const data = this.getVariantData(format).collageConfig;
       
        return {
                canvas: {
                    width: data.canvas.width || 14.27,
                    height: data.canvas.height || 14.27
                },
                windows: data.windows.reduce((acc, win, idx) => {
                    acc[idx + 1] = {
                        width: win.width.value,
                        height: win.height.value,
                        top: win.top.value,
                        left: win.left.value
                    };
                    return acc;
                }, {})
            };
    }

    // Resolves variant data from the product map using a normalized variant name.
    getVariantData(variantName) {
        let key =
            variantName // "Small / Oak"   
            .replace(/ /g, "_")  // → "Small_/_Oak"
            .replace(/\//g, "")  // → "Small__Oak"
            .replace(/\(/g, "_")  
            .replace(/\)/g, "")
            .replace(/_+/g, "_"); // → collapse "_+" → "Small_Oak

        return prdctmap[key] || null;
    }

    // Generate random ID
    makeId(length = 8) {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      return Array.from({ length }, () => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
    }

    async generateFrameId() {
      const makeId = this?.makeId || (() => Math.random().toString(36).substr(2, 8));
      return `frame_${Date.now()}_${makeId(6)}`;
    }

    // Generate frame ID
    generateCollageId() {
      const makeId = this?.makeId || (() => Math.random().toString(36).substr(2, 8));
      return `collage_${Date.now()}_${makeId(6)}`;
    }
    
    processSizes(item) {
        const size = item.option1;
        const price = item.price;
        const wihi = size.split('x');
        const mwidth = parseFloat(wihi[0]);
        const mhight = parseFloat(wihi[1]);

        const sizes = [];

        // Always add the original size
        sizes.push({
            size: size,
            price: price,
            width: mwidth,
            height: mhight
        });

        // Add the rotated size if it's different
        if (mwidth !== mhight) {
            sizes.push({
                size: `${wihi[1]}x${wihi[0]}`,
                price: price,
                width: mhight,
                height: mwidth
            });
        }

        return sizes;
    }

    formatPrice(priceInCents) {
        const price = priceInCents / 100;
        
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
            .format(price)
            .replace(/\.00$/, ''); 
    }

    // Renders size options for the currently selected frame.
    renderSizeOptions(containerSelector = ".cl_vp__size-box .cl_vp__content") {
        const wrapper = document.querySelector(containerSelector + ' .swiper-wrapper');
        if (!wrapper) return;

        const uniqueSizes = styleSizeMap.sizes;

        wrapper.innerHTML = "";
        
        // check if this.collage.style exists in available list
            const selectedSize = uniqueSizes.some(({ size }) => size === this.collage.size)
                ? this.collage.size
                : uniqueSizes[0]?.size; 

        uniqueSizes.forEach(({ size, price }, index) => {
                const isSelected = size === selectedSize;
                const slideHTML = `
                    <div class="swiper-slide">
                        <div
                            class="cl_vp__size-box__item cl_vp__item ${isSelected ? 'selected' : ''}"
                            data-value="${size}"
                        >
                            <div class="cl_vp__item-box">
                                <div class="cl_vp__item-shape-box">
                                    <div
                                        class="cl_vp__item-shape ${size}"
                                        style="${size}"
                                    ></div>
                                </div>
                                <label class="f12 w6">${size}</label>
                                <label class="f10">${this.formatPrice(price)} Each</label>
                            </div>
                        </div>
                    </div>
                `;
                wrapper.insertAdjacentHTML("beforeend", slideHTML);
        });
        document.querySelector("#collageFrame").dataset.frameSize = selectedSize;
    }

    // Renders style options for the currently selected frame.
    renderStyleOptions(containerSelector = ".cl_vp__style-box .cl_vp__content") {
        const wrapper = document.querySelector(containerSelector + ' .swiper-wrapper');
        if (!wrapper) return;

        const uniqueSizes = styleSizeMap.styles;
        wrapper.innerHTML = "";

        // check if this.collage.style exists in available list
        const selectedStyle = uniqueSizes.some(({ style }) => style === this.collage.style)
            ? this.collage.style
            : uniqueSizes[0]?.style; // fallback to first

        Array.from(uniqueSizes).forEach(({ style, image }) => {
            const isSelected = style === selectedStyle;
            const slideHTML = `
                <div class="swiper-slide" data-style="${style}">
                    <div
                    class="cl_vp__style-box__item cl_vp__item ${isSelected ? 'selected' : ''}"
                    data-value="${style}"
                    >
                    <div class="cl_vp__item-box">
                        <div class="cl_vp__item-shape-box">
                        <img src="${image || 'https://cdn.shopify.com/s/files/1/0879/7264/3112/files/oak.png?v=1756906104'}" alt="${style}" class="cl_vp__item-shape-img" />
                        </div>
                        <p class="f12">${style}</p>
                    </div>
                    </div>
                </div>
            `;
            wrapper.insertAdjacentHTML("beforeend", slideHTML);
        });
        document.querySelector("#collageFrame").dataset.frameStyle = selectedStyle;
    }


    // Updates a frame’s nested properties using dot notation 
    updateFrameState(frameId, pathOrUpdates, valueIfSingle) {
        const frameIndex = this.frames.findIndex(f => f?.id === frameId);
        if (frameIndex === -1) return; 

        let updatedFrame = structuredClone(this.frames[frameIndex]); 

        // If updating multiple paths at once (object form)
        if (typeof pathOrUpdates === "object" && !Array.isArray(pathOrUpdates)) {
            Object.entries(pathOrUpdates).forEach(([path, value]) => {
                updatedFrame = this.deepUpdate(updatedFrame, path, value);
            });
        } 
        // If updating a single path
        else if (typeof pathOrUpdates === "string") {
            updatedFrame = this.deepUpdate(updatedFrame, pathOrUpdates, valueIfSingle);
        }

        this.frames[frameIndex] = updatedFrame;
        this.updateGState({ Frames: this.frames }, false);
    }

    //  Immutably modifies a nested object path (e.g., styles.width) without mutation.
    deepUpdate(obj, path, value) {
        const keys = path.split(".");
        const lastKey = keys.pop();
        const newObj = structuredClone(obj);
        let ref = newObj;
        keys.forEach(k => {
            ref[k] = { ...ref[k] }; 
            ref = ref[k];
        });
        ref[lastKey] = value;
        return newObj;
    }

    // Validates whether a frame with the given ID exists
    validateFrame(frameId) {
        return this.collage?.frames?.some(f => f?.id === frameId);
    }

    //  Creates a debounced version of a function.
    debounce(func, delay) {
        let timer;
        return function(...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }

    // Creates a throttled function using requestAnimationFrame.
    throttleWithRaf(fn) {
        let scheduled = false;
        let lastArgs, lastContext;

        return function (...args) {
            lastArgs = args;
            lastContext = this;

            if (!scheduled) {
            scheduled = true;
            requestAnimationFrame(() => {
                scheduled = false;
                fn.apply(lastContext, lastArgs);
            });
            }
        };
    }
    /**
         * updateCollageState
         *
         * Handles updates at 3 levels:
         *
         * 1️⃣ Single-frame update (unchanged)
         *    Example:
         *    this.updateCollageState({ "cssStyles.left": 100 }, null, "frame123");
         *
         * 2️⃣ Multi-frame batch update
         *    Example:
         *    this.updateCollageState({
         *      frame123: { "cssStyles.left": 10, "cssStyles.top": 20 },
         *      frame456: { "cssStyles.left": 100, "cssStyles.top": 200 }
         *    });
         *
         * 3️⃣ Collage-level update (unchanged)
         *    Example:
         *    this.updateCollageState({ "title": "My Collage" });
         *
         * Notes:
         * - Internally clones `this.collage` to keep state immutable.
         * - Updates frame.modified or collage.modified timestamp.
         * - Calls saveToDB() and updateGState() after applying changes.
     */
    updateCollageState(pathOrUpdates, valueIfSingle, frameId = null) {
        const timestamp = Date.now();
        let updatedCollage = structuredClone(this.collage);

        // === 1. Multi-frame batch update ===
        // Example: { frameId1: { "cssStyles.left": 10 }, frameId2: {...} }
        if (
            typeof pathOrUpdates === "object" &&
            !Array.isArray(pathOrUpdates) &&
            !frameId &&
            Object.values(pathOrUpdates).every(v => typeof v === "object")
        ) {
            Object.entries(pathOrUpdates).forEach(([fid, updates]) => {
                const frameIndex = updatedCollage.frames.findIndex(f => f?.id === fid);
                if (frameIndex === -1) return;

                let updatedFrame = structuredClone(updatedCollage.frames[frameIndex]);
                Object.entries(updates).forEach(([path, value]) => {
                    updatedFrame = this.deepUpdate(updatedFrame, path, value);
                });
                updatedFrame.modified = timestamp;
                updatedCollage.frames[frameIndex] = updatedFrame;

                // Also keep per-frame state in sync
                this.updateFrameState(fid, { ...updatedFrame });
            });
        }

        // === 2. Single-frame update (original branch) ===
        else if (frameId) {
            if (!this.validateFrame(frameId)) {
                console.error(`Frame ${frameId} not found`);
                return;
            }
            const frameIndex = updatedCollage.frames.findIndex(f => f?.id === frameId);
            if (frameIndex === -1) return;

            let updatedFrame = structuredClone(updatedCollage.frames[frameIndex]);

            if (typeof pathOrUpdates === "object" && !Array.isArray(pathOrUpdates)) {
                Object.entries(pathOrUpdates).forEach(([path, value]) => {
                    updatedFrame = this.deepUpdate(updatedFrame, path, value);
                });
            } else if (typeof pathOrUpdates === "string") {
                updatedFrame = this.deepUpdate(updatedFrame, pathOrUpdates, valueIfSingle);
            }

            updatedFrame.modified = timestamp;
            updatedCollage.frames[frameIndex] = updatedFrame;
            this.updateFrameState(frameId, { ...updatedFrame });
        }

        // === 3. Collage-level update (unchanged) ===
        else {
            if (typeof pathOrUpdates === "object" && !Array.isArray(pathOrUpdates)) {
                Object.entries(pathOrUpdates).forEach(([path, value]) => {
                    updatedCollage = this.deepUpdate(updatedCollage, path, value);
                });
            } else if (typeof pathOrUpdates === "string") {
                updatedCollage = this.deepUpdate(updatedCollage, pathOrUpdates, valueIfSingle);
            }
        }

        updatedCollage.modified = timestamp;
        this.collage = updatedCollage;

        // Attach to state
        this.data = this.data || {};
        // this.saveToDB();
        this.updateGState({ Collage: updatedCollage });
    }

    // Generates a new collage with defaults (ID, style, timestamps).
    createCollageObject({
        collageId,
        title = "",
        width,
        height,
        style = "oak",
        price = null,
        size = null,
        frames = [],
        fullImg = null,
        s3Img = null,
        variantID = null
    } = {}) {
        const timestamp = Date.now();

        return {
            id: collageId,
            title,
            width,
            height,
            style,
            price, 
            size,
            fullImg,
            s3Img,
            variantID,
            created: timestamp,
            modified: timestamp,
            frames 
        };
    }

    // Creates a frame object with preset image/styling defaults (size, crop, position).
    createFrameObject({
        frameId,
        sizeVariant = "17x25",
        size = "25x17",
        width = null,
        height = null,
        previewURL = null,
        filestackUrl = null,
        status = "pending",
        crop = "",
        visableCrop = "",
        scale = "",
        minScale = "false",
        naturalWidth = null,
        naturalHeight = null,
        cssStyles = {
            height: null,
            width: null,
            x: 0,
            y: 0,
        },
        imgStyles = {
            left: null,
            top: null,
            scale: null,
            width: null, 
            height: null,
            rotation: 0
        },
        variantID = null,
        originalPos= 0,
        editPos= 0,
        file = null,
    } = {}) {

    const timestamp = Date.now();

        return {
            id: frameId,
            originalPos,
            editPos,
            size: {
                variant: sizeVariant,
                size,
                width,
                height
            },
            image: {
                previewURL,
                filestackUrl,
                file,
                status,
                crop,
                visableCrop,
                scale,
                imgStyles,
                minScale,
                naturalWidth,
                naturalHeight,
                modified: timestamp,
            },
            cssStyles,
            created: timestamp,
            modified: timestamp,
            variantID,
            positionIndex: editPos + 1,
        };
    }

    // DOM Helper Methods
    S$Q = document.querySelector.bind(document);
    S$$ = document.querySelectorAll.bind(document);
    S$G = document.getElementById.bind(document);

    // Convert inches to pixels using the configured DPI.
    toPx(inch) {
        return inch * this.dpi;
    }

     // Returns the default Photo Upload (PU) state object.
    getDefaultPu() {
        return {
            ceF: null, ceB: null, ceI: null,
            cuF: null, cuB: null, cuI: null,
            ceHeight: null, ceWidth: null,
            cuHeight: null, cuWidth: null,
            ceLeft: null, ceTop: null,
            cuLeft: null, cuTop: null,
            ceScale: null, cuScale: null,
            ceBW: null, cuBW: null,
            ceSize: null, cuSize: null,
            ceSizeVariant: null, cuSizeVariant: null,
            ceStyle: null, cuStyle: null,
            ceBorder: null, cuBorder: null,
            ceAcrylic: null, cuAcrylic: null,
            ceNW: 0, ceNH: 0,
            isOpen: true, SoPchanged: false,
            SoRchanged: false, SoCchanged: false,
            posrotation: "h", rotation: 0,
            zmSlider: null, image: null
        };
    }

    // Update method for the global state
    updateGState(updates, save = true) {
        const deepMerge = (target, source) => {
            for (const key in source) {
                if (source[key] instanceof Object && !Array.isArray(source[key])) {
                    if (!target[key]) target[key] = {};
                    deepMerge(target[key], source[key]);
                } else {
                    target[key] = source[key];
                }
            }
            return target;
        };

        deepMerge(this.state, updates);
         // Attach to state
        this.data = this.data || {};
        this.data = this.state;
        if(save){
            this.saveToDB();
        }
        return this.state;
    }

    updatePopupState(updates = {}) {
        Object.assign(this.pu, updates);
    }

    // Initialization Methods
    calculateScaledDimensions(config) {
        const totalOuterWidthInches = config.canvas.width;
        const totalOuterHeightInches = config.canvas.height;
        const totalOuterWidthPx = this.toPx(totalOuterWidthInches + (this.frameBorder * 2));
        const totalOuterHeightPx = this.toPx(totalOuterHeightInches + (this.frameBorder * 2));
        const totalWidthPx = this.toPx(totalOuterWidthInches);
        const totalHeightPx = this.toPx(totalOuterHeightInches);

        const wrapper = document.querySelector(".cl_main.bg1");
        const { height: maxFrameHeight, width: maxFrameWidth } = config.canvas;
        const { maxHeight, maxWidth } =  this.dType === "M"
            ? {
              maxHeight:
                (this.ui.galHeight || window.innerHeight - 160) * 0.8,
              maxWidth: window.innerWidth * 0.8,
            } : { maxHeight: parseFloat(this.ui.galHeight) * 0.7, maxWidth: parseFloat(wrapper.getBoundingClientRect().width) * 0.7 };
        const heightInInches = maxFrameHeight;
        const widthInInches = maxFrameWidth;

        let widthPx, heightPx, scp;
        const ratio = widthInInches / heightInInches;
        if (maxWidth / maxHeight > ratio) {
            heightPx = maxHeight;
            widthPx = maxHeight * ratio;
        } else {
            widthPx = maxWidth;
            heightPx = maxWidth / ratio;
        }
        scp = heightPx / parseInt(totalOuterHeightPx);
        this.scalledValue = scp;

        const scaledWindows = {};
        Object.keys(config.windows).forEach(key => {
            const window = config.windows[key];
            scaledWindows[key] = {
                width: this.toPx(window.width) * scp,
                height: this.toPx(window.height) * scp,
                top: this.toPx(window.top) * scp,
                left: this.toPx(window.left) * scp
            };
        });

        return {
            frameOuterWidth: totalOuterWidthPx * scp,
            frameOuterHeight: totalOuterHeightPx * scp,
            canvasWidth: totalWidthPx * scp,
            canvasHeight: totalHeightPx * scp,
            border: this.toPx(this.frameBorder) * scp,
            scaleToCal: scp,
            // padding: [this.toPx(config.padding[0]) * scp, this.toPx(config.padding[1]) * scp],
            windows: scaledWindows
        };
    }

    adjustCollage2(config) {
        const windows = {};

        for (const key in config.windows) {
            if (config.windows.hasOwnProperty(key)) {
                const orig = config.windows[key];

                windows[key] = {
                    width: +(orig.width + (this.trimSpacing * 2)).toFixed(3),
                    height: +(orig.height + (this.trimSpacing * 2)).toFixed(3),
                    top: +(orig.top - this.trimSpacing).toFixed(3),
                    left: +(orig.left - this.trimSpacing).toFixed(3)
                };
            }
        }

        return {
            canvas: config.canvas,
            windows,
            cli: config.cli
        };
    }

    calculatFullDimensions(config) {
        const totalOuterWidthInches = config.canvas.width;
        const totalOuterHeightInches = config.canvas.height;
        const totalOuterWidthPx = this.toPx(totalOuterWidthInches + (this.borderTBA * 2));
        const totalOuterHeightPx = this.toPx(totalOuterHeightInches + (this.borderTBA * 2));

        const scale = 1;

        const scaledWindows = {};
        Object.keys(config.windows).forEach(key => {
            const window = config.windows[key];
            scaledWindows[key] = {
                width: this.toPx(window.width) * scale,
                height: this.toPx(window.height) * scale,
                top: this.toPx(window.top) * scale,
                left: this.toPx(window.left) * scale
            };
        });

        return {
            frameOuterWidth: totalOuterWidthPx * scale,
            frameOuterHeight: totalOuterHeightPx * scale,
            canvasWidth: this.toPx(config.canvas.width) * scale,
            canvasHeight: this.toPx(config.canvas.height) * scale,
            border: this.toPx(this.borderTBA) * scale,
            // padding: [this.toPx(config.padding[0]) * scale, this.toPx(config.padding[1]) * scale],
            windows: scaledWindows
        };
    }

    // DOM Element Initialization
    initElements() {
        // Collage frame setup
        const collage = this.S$G('collageFrame');
        this.S$Q(".collageFrameLoading").style.display = "none"
        collage.style.display = "block";
        collage.style.width = `${this.scaled.frameOuterWidth}px`;
        collage.style.height = `${this.scaled.frameOuterHeight}px`;
        collage.style.borderWidth = `${this.scaled.border}px`;
        collage.style.setProperty('--frame-size', `${this.scaled.border}px`);
        // Grid setup
        const grid = this.S$G('collageGrid');

        grid.style.width = `${this.scaled.canvasWidth}px`;
        grid.style.height = `${this.scaled.canvasHeight}px`;
        // grid.style.padding = `${this.scaled.padding[0]}px ${this.scaled.padding[1]}px`;

        // Slot setup
        document.querySelectorAll('.frame').forEach(slot => {
            slot.style.width = '100%';
            slot.style.height = '100%';
        });

        // Main elements
        this.photoSlotsContainer = this.S$G('collageGrid');
        this.photoList = document.querySelector('.cl_vp__photo-box .cl_photo_content');
        this.sizeOptions = this.S$G('size-options');
        this.remainingPhotos = this.S$G('remaining-photos');

        // Edit modal elements
        this.rotateLeft = this.S$G('rotate-left');
        this.rotateRight = this.S$G('rotate-right');
        this.blackWhite = this.S$G('black-white');
        this.fileInputs = [];
    }

    // Restore UI From Saved State
    setupEventListenersG() {
        document.addEventListener('click', (e) => {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            var actionElement = e.target.hasAttribute('data-action') ? e.target : e.target.closest('[data-action]');
            if (!actionElement) return;
            var action = actionElement.getAttribute('data-action');

            if (action === 'sidebar-selection') {
                const target = e.target.closest('[data-value]');
                const container = e.target.closest('[data-category]');
                if (!target || !container) return;

                const category = container.getAttribute('data-category');
                const value = target.getAttribute('data-value');

                // Disable ATC button immediately on size/style/border/acrylic clicks
                if (['size', 'style', 'border'].includes(category)) {
                    this.S$Q('.cl_st__atc-btn')?.classList.add('disa');
                    setTimeout(() => {
                        // this.S$Q('.cl_st__atc-btn')?.classList.remove('disa');
                        this.checkAllImagesUploaded();
                    }, 1000);
                }

                if(S$$(".collage-frame")?.length !== 0 && value == S$Q(".collage-frame").getAttribute('data-frame-' + category)){
                    console.warn(`skipping because value (${value}) and selected ${category} is same (${S$Q(".collage-frame").getAttribute('data-frame-' + category)}) for all`)
                    return;
                }
                // if (this.checkFC(category)) {
                this.updateSelectedValue(container, target, category, value);
                // } else {
                //     this.changeAllWarningShow(container, target, category, value);
                // }
            } else if (action === 'popup-menu') {
                return;
                const target = e.target.closest('[data-value]');
                const value = target.getAttribute('data-value');
                if (value == "delete") {
                    var epopup = this.S$Q('.cl_epu');
                    var eframe = this.S$Q('.cl_epu-body .frame');
                    var ftu = this.S$Q('.img-thumbs .frame[data-frame-index="' + epopup.dataset.editIndex + '"]').parentElement;
                    var frameId = ftu.querySelector('.framefh')?.dataset.frameId;
                    ftu.remove();
                    epopup.style.display = "none";
                    eframe.remove();
                    Pg.State?.removeFrame(frameId);
                    Pg.Frames.setFID();
                    var frames = this.S$$('.frame');
                    Pg.Frames.updateFrameSizes("size");
                    Pg.Frames.handleSwiper(frames);
                    Pg.Cart?.buildFramesSummary?.();
                    Pg.Popup.current.isOpen = false;
                    if (this.S$$('.framefh').length == 0) {
                        this.S$Q('.cl_st__atc-btn').classList.add('disa');
                    }
                } else {
                    var p = "cl_epu-f" + value;
                    actionElement.parentElement.parentElement.parentElement.querySelector('.cl_epu-fcurrent').classList.remove('cl_epu-fcurrent');
                    this.S$Q('.cl_epu-footer').dataset.active = p;
                    actionElement.parentElement.parentElement.parentElement.querySelector('.' + p).classList.add('cl_epu-fcurrent');
                    if (p === "cl_epu-facrylic") {
                        const frame = actionElement.parentElement.parentElement.parentElement.querySelector('.' + p)?.closest('.cl_epu-box')?.querySelector('.frame.framefh');
                        this.S$G('epuacr').checked = frame?.getAttribute('data-frame-acrylic') === "true";
                    }
                };
            } else if (action === 'popup-selection') {
                const target = e.target.closest('[data-value]');
                const container = e.target.closest('[data-category]');
                if (!target || !container) return;

                const category = container.getAttribute('data-category');
                const value = target.getAttribute('data-value');
                this.updateSelectedValue(container, target, category, value);
            } else if (action === 'popup-selection-done') {
                this.S$Q('.cl_epu-fcurrent').classList.remove('cl_epu-fcurrent');
                this.S$Q('.cl_epu-fmain').classList.add('cl_epu-fcurrent');
                this.S$Q('.cl_epu-footer').dataset.active = "cl_epu-fmain";
                this.loadImageForEditing();
            } else if (action === 'popup-done') {
                this.endSEdit();
            } else if (action === 'edit-item') {
                this.S$Q('.cl_eupu').classList.remove("cl_eupu-open");
                this.S$Q(
                    `foreignObject[data-index="${this.uploadIndex}"] .cl_eb`
                ).click();
            } else if (action === 'change-item') {
                this.S$Q('.cl_eupu').classList.remove("cl_eupu-open");
                this.S$Q('.cl_upu')?.classList.add(`cl_upu-open`);
            }else if(action === 'popup-cancel') {
                this.S$Q('.cl_epu-fcurrent').classList.remove('cl_epu-fcurrent');
                this.S$Q('.cl_epu-fmain').classList.add('cl_epu-fcurrent');
                this.S$Q('.cl_epu-footer').dataset.active = "cl_epu-fmain";
                // this.S$Q('.cl_epu').style.display = "none";
                // this.S$Q('.cl_epu-body .frame').remove();
                this.removePopupListeners();
                this.pu.isOpen = false;
                this.closePopupAnimation(true);
            }
        });
        // Upload popup listeners
        this.S$Q('.cl_upu')?.addEventListener('click', function (event) {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            event.currentTarget.classList.remove("cl_upu-open");
        });

        this.S$Q(".cl_fub__container")?.addEventListener('click', function () {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            document.querySelector('.cl_upu')?.classList.add("cl_upu-open");
        });

        this.S$Q(".cl_upu-option.upload-img")?.addEventListener('click', function () {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            this.fileInputs[this.uploadIndex].click();
        }.bind(this));

        // this.S$Q(".download-collage")?.addEventListener('click', function () {
        //     if (this.addToCartInProcess) {
        //         console.warn("add to cart is in process");
        //         return;
        //     }
        //     this.downloadSVG(true);
        // }.bind(this));

        // this.S$Q(".download-collage-vizual")?.addEventListener('click', function () {
        //     if (this.addToCartInProcess) {
        //         console.warn("add to cart is in process");
        //         return;
        //     }
        //     this.downloadSVG(false);
        // }.bind(this));

        // this.S$Q(".clear-storage")?.addEventListener('click', function () {
        //     this.clearSavedState();
        //     setTimeout(() => {
        //         window.location.reload()
        //     }, 100);
        // }.bind(this));

        // Delivery info listeners
        this.S$$('.cl_sbmd__view_del').forEach(el => {
          el.addEventListener('click', () => {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            this.S$Q('.cl_delivery_info').classList.add('cl_delivery_info-open');
            if (this.dType === "D") this.S$G("background-overlay").style.display = "block";
          });
        });

        this.S$$('.cl_delinfo-close').forEach(el => {
          el.addEventListener('click', () => {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            this.S$Q('.cl_delivery_info').classList.remove('cl_delivery_info-open');
            this.dType === "D" ? this.S$G("background-overlay").style.display = "none" : this.S$Q('.cl_sbmd').classList.remove('cl_sbmd-open'), this.S$G('global-overlay').classList.remove('go-active');
          });
        });

        this.S$$('.cl_delinfo-back').forEach(el => {
          el.addEventListener('click', () => {
            this.S$Q('.cl_delivery_info').classList.remove('cl_delivery_info-open');
          });
        });
        
        var a2cbtn = this.S$Q('.cl_st__atc-btn');
        if (a2cbtn) {
            a2cbtn.addEventListener('click', this.performAddToCart.bind(this));
        }
        this.setupFilestackUploaclanels();

        this.S$Q('.cl_eupu-cancel').addEventListener("click", () =>{ this.S$Q('.cl_eupu').classList.remove("cl_eupu-open")});

        if(this.dType === "M") {
            ["gesturestart", "gesturechange", "gestureend"].forEach(evt => {
                document.addEventListener(evt, e => {
                e.preventDefault();
                }, { passive: false });
            });
            this.S$Q(".collage-frame").removeEventListener('touchstart', (e) => this.pinchZoom(e), {passive: false});
            this.S$Q(".collage-frame").addEventListener('touchstart', (e) => this.pinchZoom(e), {passive: false});
        };
    }

    // check add to cart state
    checkAddtoCartInProcess = ()=> {
        if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
    }
    
    // Add loading class to a specific img-box
    addLoadingClass(index) {
        const imgBox = document.querySelector(`#collageGrid foreignObject[data-index="${index}"] .img-box`);
        if (imgBox) imgBox.classList.add('cimg-loading');
        this.S$Q('.cl_st__atc-btn')?.classList.add('disa');
    }

    // Remove loading class from a specific img-box
    removeLoadingClass(index, frameId) {
        if(index){
            const imgBox = document.querySelector(`#collageGrid foreignObject[data-index="${index}"] .img-box`);
            if (imgBox) imgBox.classList.remove('cimg-loading');
        }else if(frameId){
            const imgBox = document.querySelector(`#collageGrid .frame[data-frame-id="${frameId}"] .img-box`);
             if (imgBox) imgBox.classList.remove('cimg-loading');
        }
        // this.S$Q('.cl_st__atc-btn')?.classList.remove('disa');
        this.checkAllImagesUploaded();
    }

    // This function is responsible for the entire external image upload flow.
    setupFilestackUploaclanels() {
        document.querySelectorAll('.cl_upu-upanel').forEach(panel => {
            panel.addEventListener('click', (e) => {
                const client = this.fileStack;

                const fileInput = document.querySelector(
                    `#collageGrid foreignObject[data-index="${this.uploadIndex}"] .img-upload`
                );
                
                if (!fileInput) return;

                const allowMultiple = fileInput.multiple;
                const maxLimit = this.images.length;
                
                const source = e.currentTarget.classList.contains("open_fb")
                    ? ["facebook", "googlephotos"]
                    : e.currentTarget.classList.contains("open_ig")
                        ? ["facebook", "googlephotos"]
                        : ["googlephotos", "facebook"];

                const options = {
                    maxFiles: allowMultiple ? maxLimit : 1,
                    uploadInBackground: false,
                    fromSources: source,
                    onOpen: () => console.log('opened!'),
                    onUploadDone: async (res) => {
                        const files = res.filesUploaded || [];

                        // figure out slot mapping ahead of time
                        const maxUploadLength = Math.min(this.images.length, files.length);
                        const emptySlots = this.getEmptySlots();
                        for (let i = 0; i < maxUploadLength; i++) {
                            if(files.length > 1) {
                                this.addLoadingClass(emptySlots[i]);
                            }else{
                                 this.addLoadingClass(this.uploadIndex);
                            }
                        }

                        for (let i = 0; i < files.length; i++) {
                            const slotIndex = (files.length > 1) 
                                ? emptySlots[i] 
                                : this.uploadIndex;

                            if (slotIndex === undefined) continue;

                            const f = files[i];
                            let attempt = 0;
                            let success = false;

                            while (attempt < 2 && !success) {
                                try {
                                    attempt++;

                                    const response = await client.download(f.handle);
                                    const blob = response instanceof Blob ? response : response?.data;
                                    if (!blob) throw new Error("Invalid blob from download");

                                    // ✅ Step 1: Resize before doing anything else
                                    let processedFile = blob;
                                    if (blob instanceof File || blob instanceof Blob) {
                                        try {
                                            processedFile = await this.resizeImageToMaxSize(blob);
                                            // processedFile = await this.compressImage(blob, 4000);
                                        } catch (err) {
                                            console.error("Image resize failed, using original file:", err);
                                            processedFile = blob;
                                        }
                                    }

                                    const timestamp = Date.now().toString(36);
                                    const randomId = this?.makeId?.(8) || Math.random().toString(36).substr(2, 8);
                                    const extension = processedFile.type.split("/")[1] || "jpg";
                                    const filename = `f_f-${new Date().getMonth()+1}_${new Date().getFullYear()}-${timestamp}${randomId}.${extension}`;

                                    let fileToUpload = processedFile instanceof File 
                                        ? processedFile 
                                        : new File([processedFile], filename, { type: processedFile.type });

                                    const reuploadRes = await client.upload(fileToUpload);

                                    const dataUrl = await this.toBase64(processedFile);

                                    f.dataUrl = dataUrl;
                                    f.reuploadHandle = reuploadRes.handle;
                                    f.reuploadUrl = reuploadRes.url;

                                    success = true;

                                    this.handleFileSelect(slotIndex, { filesUploaded: [f] });

                                } catch (fileErr) {
                                    console.warn(`Upload attempt ${attempt} failed for file ${f.filename}:`, fileErr);
                                    if (attempt >= 2) {
                                        console.error("Failed after retry:", fileErr);

                                        f.dataUrl = f.dataUrl || null;
                                        f.reuploadHandle = f.reuploadHandle || null;
                                        f.reuploadUrl = f.reuploadUrl || null;

                                        this.handleFileSelect(slotIndex, { filesUploaded: [f] });
                                    }
                                }
                            }
                        }
                    },
                };
                client.picker(options).open();
            });
        });
    }

    //  Handles selection changes for size, style, and frame options.
    updateSelectedValue(container, target, category, value) {
        container.querySelector('.selected')?.classList.remove('selected');
        target.classList.add('selected');
        container.setAttribute('data-selected-value', value);
        switch (category) {
            case 'size':
                const [width, height] = value.split('x');
                this.updateAllFramesSizes(value);
                // Pg.Frames.updateAllFramesInches(parseInt(width), parseInt(height));
                break;
            case 'style':
                this.updateAllFramesStyles(value);
                break;
            default:
                break;
        }
    }

    // Update all frames to a new style
    updateAllFramesSizes(size) {
        console.log(`🎨 Pg.Frames: Updating all frames to size: ${size}`);

        // Validate inputs
        if (!size || typeof size !== "string") {
            throw new Error("Invalid style name provided");
        }

        // Update all existing frames
        const collages = document.querySelectorAll(".collage-frame");

        collages.forEach((collage, index) => {
            try {
                collage.dataset.frameSize = size;
                const frameId = collage.dataset.frameId;
                this.updateCollageState("size", size);
                this.buildFramesSummary();
            } catch (error) {
                console.error(`❌ Error updating frame ${index}:`, error);
            }
        });
    }

    // Update all frames to a new style
    updateAllFramesStyles(style) {
        console.log(`🎨 Pg.Frames: Updating all frames to style: ${style}`);

        // Validate inputs
        if (!style || typeof style !== "string") {
            throw new Error("Invalid style name provided");
        }

        // Update all existing frames
        const collages = document.querySelectorAll(".collage-frame");

        collages.forEach((collage, index) => {
            try {
                collage.dataset.frameStyle = style;
                const frameId = collage.dataset.frameId;
                this.updateCollageState("style", style);
                this.buildFramesSummary();
            } catch (error) {
                console.error(`❌ Error updating frame ${index}:`, error);
            }
        });
    }

    // Creates a photo upload or edit row for a given slot index.
    createPhotoUploadBox(i, image) {
        // Create main container
        const row = document.createElement("div");
        row.className = "photo-upload-row";
        row.dataset.index = i;
        // Left side container
        const leftDiv = document.createElement("div");
        leftDiv.innerHTML = `
            <svg  class="drag-svg" xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
            <path d="M0.814453 1H16.9996" stroke="black" stroke-width="2"/>
            <path d="M0.814453 6.53699H16.9996" stroke="black" stroke-width="2"/>
            <path d="M0.814453 12.5H16.9996" stroke="black" stroke-width="2"/>
            </svg>
            <span class="label">Photo ${i + 1}</span>
        `;

        // Append children
        row.appendChild(leftDiv);
        if (!image) {
            // Right side container
            const uploadBtn = document.createElement("div");
            uploadBtn.className = "upload-btn";
            uploadBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
            <path d="M4.65438 8.81911V3.62507L2.9425 5.41612L1.65688 4.06209L5.56875 0L9.47375 4.06925L8.18812 5.42328L6.47625 3.63224V8.82627H4.65438V8.81911ZM11 12H0V10.1301H11V12Z" fill="white"/>
            </svg>
            <span>Upload</span>
        `;

            uploadBtn.addEventListener('click', (e) => {
                const key = Object.entries(this.posToIndex).find(([k, v]) => v === i)?.[0];
                this.uploadIndex = key;
                document.querySelector('.cl_upu')?.classList.add(`cl_upu-open`);
            });
            // this.fileInputs[i].click()
            row.appendChild(uploadBtn);

        } else {
            // row.draggable = true;
            const wrapper = document.createElement("div");
            const changeBtn = document.createElement("div");
            changeBtn.className = "change-btn";
            changeBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                <g clip-path="url(#clip0_834_6601)">
                <path d="M5.14044 11C4.42131 10.9306 3.74479 10.7438 3.12155 10.4449C2.49298 10.146 1.94964 9.75643 1.49153 9.27074C1.03341 8.78506 0.66586 8.22465 0.399516 7.58952C0.133172 6.94905 0 6.25522 0 5.49733C0 4.73945 0.138499 4.04027 0.420823 3.38379C0.703148 2.72732 1.08668 2.15623 1.57676 1.66521H0.372881V0.256186H4.07506V3.96555H2.66344V2.59922C2.27458 2.96215 1.97094 3.38913 1.74722 3.88549C1.52349 4.38185 1.41162 4.92091 1.41162 5.50267C1.41162 6.5541 1.76852 7.46676 2.48232 8.22999C3.19613 8.99854 4.08039 9.44687 5.14044 9.5803V11ZM6.92494 10.7438V7.03445H8.33656V8.40078C8.72542 8.03785 9.02906 7.60553 9.25278 7.11451C9.47651 6.61815 9.58838 6.08443 9.58838 5.50267C9.58838 4.45124 9.23148 3.53857 8.51768 2.77535C7.80387 2.00679 6.91961 1.55847 5.85956 1.42504V0C7.30847 0.144105 8.52833 0.736536 9.51913 1.77729C10.5099 2.81805 11 4.05628 11 5.50267C11 6.25522 10.8615 6.95973 10.5792 7.61621C10.2969 8.27268 9.91332 8.84377 9.42325 9.33479H10.6271V10.7492H6.92494V10.7438Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0_834_6601">
                <rect width="11" height="11" fill="white"/>
                </clipPath>
                </defs>
                </svg>
            <span>Change</span>
        `;
            const editBtn = document.createElement("div");
            editBtn.className = "edit-btn";
            editBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M1.00284 12.9931L2.03182 9.28116C2.07079 9.14088 2.14508 9.01307 2.24822 8.9102L9.80129 1.35713C10.2775 0.880956 11.0493 0.880956 11.5252 1.35713L12.7303 2.56224C13.2065 3.03842 13.2065 3.81022 12.7303 4.28614L5.17696 11.8392C5.07409 11.9421 4.94628 12.0166 4.806 12.0556L1.09402 13.0846C1.03843 13.0999 0.987251 13.0487 1.00284 12.9931Z" stroke="white" stroke-width="1.2" stroke-miterlimit="10"/>
            <path d="M8.64111 2.48486L11.5701 5.41387" stroke="white" stroke-width="1.2" stroke-miterlimit="10"/>
            <path d="M2.25244 8.87378L5.18145 11.8028" stroke="white" stroke-width="1.2" stroke-miterlimit="10"/>
            </svg>
            <span>Edit</span>
        `;
            changeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation()
                const key = Object.entries(this.posToIndex).find(([k, v]) => v === i)?.[0];
                this.uploadIndex = key;
                document.querySelector('.cl_upu')?.classList.add(`cl_upu-open`);
            }, true);

            editBtn.addEventListener('click', () => {
                const key = Object.entries(this.posToIndex).find(([k, v]) => v === i)?.[0];
                const targetElement = document.querySelector(`#collageGrid foreignObject[data-index="${key}"] .cl_eb`);
                if (targetElement) {
                    const clickEvent = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });
                    targetElement.dispatchEvent(clickEvent);
                } else {
                    console.error('Target element not found');
                }
            });
            wrapper.appendChild(changeBtn);
            wrapper.appendChild(editBtn);
            row.appendChild(wrapper)
        }

        return row;
    }

    // Attaches core event listeners for the image edit popup.
    initPopupEventListeners() {
        // Modal controls
        this.S$G('rotate-left').addEventListener('click', this.boundHandlers.rotateLeft, true);
        this.S$G('rotate-right').addEventListener('click', this.boundHandlers.rotateRight, true);
        this.S$G('black-white').addEventListener('click', this.boundHandlers.blackWhite, true);
    }

    // Cleans up all popup-related event listeners and UI locks.
    removePopupListeners() {
        const eventType = this.dType === "D" ? "click" : "touchstart";
        this.boundHandlers.zoomButtonHandlers.forEach((handler, button) => {
            button.removeEventListener(eventType, handler);
        });
        this.boundHandlers.zoomButtonHandlers.clear();

        if(this?.pu && this?.pu?.zmSlider) this.pu.zmSlider.removeEventListener("input", this.boundHandlers.zoomInput);

        if(this?.pu?.ceF){
            const ceF = this?.pu?.ceF;
            const zmSlider = this?.pu?.zmSlider;
            ceF.removeEventListener('mousedown', this.boundHandlers.onStartMouse);
            ceF.removeEventListener('touchstart', this.boundHandlers.onStartTouch);
            ceF.removeEventListener('wheel', this.boundHandlers.onWheel);
            if (zmSlider) zmSlider.removeEventListener('wheel', this.boundHandlers.onWheel);

        }

        this.S$Q(".cfp").classList.remove("body-lock");

        this.S$G('rotate-left').removeEventListener('click', this.boundHandlers.rotateLeft, true);
        this.S$G('rotate-right').removeEventListener('click', this.boundHandlers.rotateRight, true);
        this.S$G('black-white').removeEventListener('click', this.boundHandlers.blackWhite, true);
    }

    // Main render entry point for the photo list UI.
    render() {

        this.renderPhotoSlots();
        this.renderPhotoList();
        this.checkAllImagesUploaded();
    }

     //  Renders the photo slots.
    renderPhotoSlots() {
        this.photoSlotsContainer.innerHTML = '';
        this.fileInputs = [];

        this.photoSlotsContainer.style.display = 'block';
        this.photoSlotsContainer.style.position = 'relative';
        // this.photoSlotsContainer.style.width = `${this.scaled.canvasWidth}px`;
        // this.photoSlotsContainer.style.height = `${this.scaled.canvasHeight}px`;

        if(this.dType === "M"){
            const available = this.ui.galHeight - this.scaled.canvasHeight;
            const ratio = available / this.scaled.canvasHeight;

            if (ratio > 0.3) { 
                const extraHeight = this.scaled.canvasHeight * Math.min(ratio, 0.5); 
                const newHeight = this.scaled.canvasHeight + extraHeight;

                this.S$Q(".cl_wrapper").style.height = Math.min(newHeight, this.ui.galHeight) + "px";

                const leftover = this.ui.galHeight - newHeight;
                if (leftover > 0) {
                    const leftoverVh = (leftover / window.innerHeight) * 100;
                    if((leftoverVh + 25) < 65) this.S$Q(".cl_sidebar.bg2").style.height = (25 + leftoverVh) + "vh";
                }
            }
        }

            this.photoSlotsContainer.innerHTML = "";

            Object.entries(this.posToIndex).map(([pos, editIndex]) => ({
                pos: Number(pos),
                editIndex: Number(editIndex)
            })).sort((a, b) => a.editIndex - b.editIndex).forEach(({ pos, editIndex }) => {

                const windowConfig = this.scaled.windows[pos + 1];
                const originalConfig = this.config.windows[pos + 1];

                const slotContainer = this.createSlotContainer(editIndex,windowConfig,originalConfig,pos);
                this.photoSlotsContainer.appendChild(slotContainer);
            });
    }

    //create slot logic
    createSlotContainer(index, windowConfig, originalConfig, is) {
        const foreignObject = document.createElementNS("http://www.w3.org/2000/svg", "foreignObject");
        // const valX = windowConfig.left - this.scaled.padding[1];
        // const valY = windowConfig.top - this.scaled.padding[0];
        // const valX = windowConfig.left;
        // const valY = windowConfig.top;
        // const valW = windowConfig.width;
        // const valH = windowConfig.height;
        // foreignObject.setAttribute("x", valX);
        // foreignObject.setAttribute("y", valY);
        // // foreignObject.setAttribute("y", windowConfig.top);
        // foreignObject.setAttribute("width", valW);
        // foreignObject.setAttribute("height", valH);
        foreignObject.dataset.index = is !== undefined ? is : index;

        const containerDiv = document.createElement('div');
        containerDiv.setAttribute("xmlns", "http://www.w3.org/1999/xhtml");
        containerDiv.className = 'absolute';
        containerDiv.style.width = '100%';
        containerDiv.style.height = '100%';
        containerDiv.dataset.widthInInches = `${originalConfig.width}`;
        containerDiv.dataset.heightInInches = `${originalConfig.height}`;

        const editButton = document.createElement("span");
        editButton.className = "cl_eb";
        editButton.addEventListener('click', (e) => {
            e.stopPropagation(); 
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            this.editpu(e)
        });

        const changeButton = document.createElement("span");
        changeButton.className = "cl_cb";
        changeButton.addEventListener('click', (e) => {
            e.stopPropagation();
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            this.uploadIndex = e.target.closest("[data-index]").getAttribute("data-index");
            document.querySelector('.cl_upu')?.classList.add(`cl_upu-open`);
        });

        const lowResolutionButton = document.createElement("span");
        lowResolutionButton.className = "cl_lr";
        lowResolutionButton.innerHTML = `<b>!</b> &nbsp;&nbsp; Low Resolution`;
        lowResolutionButton.addEventListener('click', (e) => {
            e.stopPropagation();
            console.log("📷 Low resolution warning clicked");
        });

        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';
        fileInput.className = 'img-upload hidden';
        fileInput.dataset.slot = index;
        fileInput.multiple = true;
        fileInput.addEventListener('change', (e) => this.handleFileSelect(index, e));
        this.fileInputs.push(fileInput);

        const {slot, frameId} = this.createSlot(index, containerDiv, false, foreignObject, windowConfig);
        const slotWrapper = document.createElement('div');
        slotWrapper.className = 'img-bevel';
        slotWrapper.appendChild(slot);
        containerDiv.appendChild(editButton);
        containerDiv.appendChild(changeButton);
        containerDiv.appendChild(lowResolutionButton);
        containerDiv.appendChild(fileInput);
        containerDiv.appendChild(slotWrapper);

        foreignObject.appendChild(containerDiv);

        return foreignObject;
    }

    createSlot(index, containerDiv, resize, foreignObject, windowConfig) {
        const slot = document.createElement('div');
        slot.className = 'img-box cimg-loading';
        slot.style.width = '100%';
        slot.style.height = '100%';
        let frame = null;
        let frameId = null;
        const imageIndex = this.images.findIndex(img => img?.originalPos == index);

        if (this.images[imageIndex] && (this.images[imageIndex]?.file || this.images[imageIndex]?.filestackUrl)) {
            if(containerDiv) containerDiv.classList.add("frame");
            this.allowSingleUpload();

            containerDiv.addEventListener("click", this.frameClickHandler)
            
            if (!containerDiv.dataset.frameId) {
                 const currentEditPos = this.images[imageIndex]?.editPos;

                frame = this.frames.find(f => {
                    return f?.id && f?.editPos !== undefined && String(f.editPos) === String(currentEditPos);
                });

                if (frame) {
                    containerDiv.dataset.frameId = frame.id;
                }
            }
            frameId = containerDiv.dataset.frameId;
            const img = document.createElement('img');
            img.src = this.images[imageIndex].previewURL;
            img.className = 'preview-img';
            img.dataset.scale = frame ? frame?.image?.scale : "min";
            // img.dataset.scale = "min";
            img.style.display = "block";

            // Wait for actual image load before removing loading class
            img.onload = () => {
                this.updateImgPosition(index, undefined, this.persistData);
                this.removeLoadingClass(frameId ? null : index, frameId);
            };

            img.onerror = () => this.handleImageError(index, slot);

            slot.appendChild(img);
            // this.updateGState({ images: this.images })
        } else {
            const emptySlot = this.createEmptySlot(index);
            slot.appendChild(emptySlot);
            slot.classList.remove("cimg-loading");
        }

        this.photoSlotsContainer.style.width = `${this.scaled.canvasWidth}px`;
        this.photoSlotsContainer.style.height = `${this.scaled.canvasHeight}px`;
        const valX = windowConfig.left;
        const valY = windowConfig.top;
        const valW = windowConfig.width;
        const valH = windowConfig.height;

        foreignObject.setAttribute("x", valX);
        foreignObject.setAttribute("y", valY);
        foreignObject.setAttribute("width", valW);
        foreignObject.setAttribute("height", valH);
        containerDiv.style.width = valW + "px";
        containerDiv.style.height = windowConfig.height + "px";
        requestAnimationFrame(() => {
            const frameContainer = this.S$Q(".frame-container");
            const target = frameContainer || this.S$Q(".cl_wrapper") || this.S$Q(".collage-frame-wrapper");

            if (target) {
                target.classList.add("frame_container-visible");
            }else{
                const frameWrapper = this.S$Q(".collage-frame");
                if (frameWrapper) {
                    frameWrapper.style.scale = "1";
                    frameWrapper.style.opacity = "1";
                    frameWrapper.style.pointerEvents = "auto";
                }
            }
        });
        return {slot, frameId};
    }

    createEmptySlot(index) {
        const emptySlot = document.createElement('div');
        emptySlot.className = 'img-box-empty';

        emptySlot.addEventListener('click', (e) => {
            //  this.fileInputs[index].click()
            this.uploadIndex = e.target.closest("[data-index]").getAttribute("data-index");
            document.querySelector('.cl_upu')?.classList.add(`cl_upu-open`);
        });

        return emptySlot;
    }

    //  Renders the full list of photo upload slots.
    renderPhotoList() {
        this.photoList.innerHTML = '';
        let draggedItem = null;
        if(!this.persistData){
            Object.keys(this.config.windows).forEach((key, i) => {
                const item = this.createPhotoItem(i);
                this.photoList.appendChild(item);
            });
        }else{
             // Use persisted order from posToIndex
            Object.keys(this.posToIndex).forEach((pos) => {
                const originalIndex = this.posToIndex[pos];
                const item = this.createPhotoItem(originalIndex);
                this.photoList.appendChild(item);
            });
        }
        
    }

    // Creates a single photo upload item for a given slot index.
    createPhotoItem(i) {
        let item = null;

        let orgI = this.images.findIndex(img => img?.originalPos == i);
        if (this.images[orgI]) {
            const uploadBox = this.createPhotoUploadBox(i, this.images[orgI]);
            if (this.images.every(img => img != null) && !this.sortable){

                this.sortable = new Sortable(this.photoList, {
                    animation: 150,  
                    handle: this.dType === "M" ? ".drag-svg" : ".photo-upload-row",
                    ghostClass: 'opacity-50',  
                    chosenClass: 'bg-gray-100',
                    dragClass: 'dragging',    
                    group: {
                        name: 'shared',
                        pull: true,   
                        put: true 
                    },
                    sort: true, 
                    onEnd: (evt) => {
                        if (this.addToCartInProcess) {
                            console.warn("add to cart is in process");
                            return;
                        }
                        const fromIndex = evt.oldIndex;
                        const toIndex = evt.newIndex;
                        setTimeout(() => {
                            this.handleDrop(evt.item, fromIndex, toIndex);
                        }, 0);
                    }
                });
            }
            
            this.handleDrop = (draggedItem, fromIndex, toIndex) => {
                if (!this.images.every(img => img != null)) return;
                if (fromIndex === toIndex) return;

                //  // Manual reorder (like your handleDrop)
                // const allItems = Array.from(this.photoList.children);
                // const toItem = allItems[toIndex];

                // if (fromIndex < toIndex) {
                //     this.photoList.insertBefore(draggedItem, toItem?.nextSibling || null);
                // } else {
                //     this.photoList.insertBefore(draggedItem, toItem);
                // }

                // Update mapping
                this.posToIndex = Array.from(this.photoList.children).reduce((acc, el, i) => {
                    acc[i] = parseInt(el.dataset.index);
                    return acc;
                }, {});

                // this.updateGState({ posToIndex: this.posToIndex });
                this.swapPhotos(fromIndex, toIndex);
            };
            item = uploadBox;

        } else {

            const uploadBox = this.createPhotoUploadBox(i);
            item = uploadBox;

        }

        return item;
    }

    /**
     * Swaps photos in the collage grid and updates state
     * @param {number} fromIndex - Original position index
     * @param {number} toIndex - Target position index
     */
    async swapPhotos(fromIndex, toIndex) {
        const svg = this.S$G('collageGrid');
        if (!svg) {
            console.warn('Collage SVG element not found');
            return;
        }

        // Validate indices
        if (fromIndex === toIndex || 
            fromIndex < 0 || 
            toIndex < 0 || 
            fromIndex >= this.images.length || 
            toIndex >= this.images.length) {
            console.warn('Invalid indices for swap');
            return;
        }

        // Get all frame elements
        const foreignObjects = Array.from(svg.querySelectorAll('foreignObject[data-index]'));
        if (foreignObjects.length === 0) return;

        // Swap DOM elements
        await this.swapDOMElements(foreignObjects, fromIndex, toIndex);

        // Update images array
        await this.swapArrayElements(fromIndex, toIndex);

        // Sync positions with state
        await this.syncFramePositions(foreignObjects);
        
    }

    // Helper: Swap DOM element positions and attributes
    async swapDOMElements(elements, fromIndex, toIndex) {
        const direction = fromIndex < toIndex ? 1 : -1;
        
        for (let i = fromIndex; i !== toIndex; i += direction) {
            const current = elements.find(el => parseInt(el.dataset.index) === i);
            const next = elements.find(el => parseInt(el.dataset.index) === i + direction);
            
            if (!current || !next) continue;

            // Swap geometry attributes
            ['x', 'y', 'width', 'height'].forEach(attr => {
                const temp = current.getAttribute(attr);
                current.setAttribute(attr, next.getAttribute(attr));
                next.setAttribute(attr, temp);
            });
            // Update indexes
            current.dataset.index = i + direction;
            next.dataset.index = i;
        }
        return true
    }

    // // Helper: Swap array elements and update positions
    async swapArrayElements(fromIndex, toIndex) {
        if (!this.posToIndex) return false;

        const reordered = [];
        
        Object.entries(this.posToIndex).forEach(([pos, orgIndx]) => {
            const img = this.images.find(i => i.originalPos == orgIndx);
            if (img) {
                img.editPos = parseInt(pos);
                reordered.push(img);
            }
        });
        // reordered.sort((a, b) => a.editPos - b.editPos);
        // this.images = reordered;
        this.updateGState({ posToIndex: this.posToIndex, images: this.images });

        return true;
    }

    // Helper: Sync frame positions with state
    async syncFramePositions(foreignObjects) {
        const batchedUpdates = {};

        foreignObjects.forEach(fo => {
            const frameId = fo.querySelector(".frame").dataset.frameId;
            if (!frameId) return;

            batchedUpdates[frameId] = {
                "cssStyles.left": parseFloat(fo.getAttribute("x")) || 0,
                "cssStyles.top": parseFloat(fo.getAttribute("y")) || 0,
                "cssStyles.width": parseFloat(fo.getAttribute("width")) || 0,
                "cssStyles.height": parseFloat(fo.getAttribute("height")) || 0,
                "editPos": parseInt(fo.dataset.index),
                "positionIndex": parseInt(fo.dataset.index) + 1,
            };
            // const updates = {
            //     "cssStyles.left": parseFloat(fo.getAttribute('x')) || 0,
            //     "cssStyles.top": parseFloat(fo.getAttribute('y')) || 0,
            //     "cssStyles.width": parseFloat(fo.getAttribute('width')) || 0,
            //     "cssStyles.height": parseFloat(fo.getAttribute('height')) || 0,
            //     "editPos": parseInt(fo.dataset.index),
            //     "positionIndex": parseInt(fo.dataset.index) + 1
            // };

            // this.updateCollageState(updates, null, frameId);
        });
        this.updateCollageState(batchedUpdates);
        return true;
    }

    updateAllItemIndices() {
        const items = this.photoList.querySelectorAll('[data-index]');
        items.forEach((item, i) => {
            item.dataset.index = i;
            const label = item.querySelector('span');
            if (label) {
                label.textContent = `Photo ${i + 1}`;
            }
        });
    }

    // catches when error occurs during process
    handleImageError(index, slot) {
        console.warn(`❌ Image failed to load at index ${index}`);
        if(!slot) slot = document.querySelector(`#collageGrid [data-index="${index}"] .img-box`);
        if(!slot) return;

         const frameEl = slot.closest(".frame");
        if (frameEl) {
            frameEl.classList.remove("frame"); 
            frameEl.classList.remove("low-ppi"); 
        }

        let orgI = this.frames?.findIndex((f) => f?.editPos == index);
        if (orgI == -1) orgI = index;
        this.images[index] = null;
        if (this.frames[orgI]) this.frames[orgI] = null;
        if (this.collage?.frames) this.collage.frames[orgI] = null;
        
        slot.innerHTML = "";
        const emptySlot = this.createEmptySlot(index);
        slot.appendChild(emptySlot);

        const listItem = this.photoList.querySelector(`[data-index="${orgI}"]`);
        if (listItem) {
            const emptyListItem = this.createPhotoUploadBox(orgI); 
            this.photoList.replaceChild(emptyListItem, listItem);
        }

        // Update persisted state
        this.updateGState({
            images: this.images,
            Collage: this.collage,
            Frames: this.frames,
        });

        slot.classList.remove("cimg-loading");
        this.checkAllImagesUploaded();
    }

    // Resizes an uploaded image while preserving quality and aspect ratio.
    resizeImageToMaxSize(file, maxSize = 2999) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const url = URL.createObjectURL(file);
            img.onload = () => {
                let { width, height } = img;

                if (width < maxSize && height < maxSize) {
                    // URL.revokeObjectURL(url);
                    // return resolve(file); 
                    const newWidth = width;
                    const newHeight = height;
                    const canvas = document.createElement("canvas");
                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, newWidth, newHeight);

                    canvas.toBlob((blob) => {
                        if (!blob) return reject("Canvas export failed");
                        const resizedFile = new File([blob], file.name, { type: file.type });
                        console.log("Same Size Image on canvas")
                        URL.revokeObjectURL(url);
                        resolve(resizedFile);
                    }, file.type, 0.95);
                }else{
                    const scale = Math.min(maxSize / width, maxSize / height);
                    const newWidth = Math.round(width * scale);
                    const newHeight = Math.round(height * scale);
                    
                    // ✅ calculate old vs new sizes in MB  
                    console.log(`Original Width X Height: ${width} X ${height}`);
                    console.log(`resized  Width X Height: ${newWidth} X ${newHeight}`);

                    const canvas = document.createElement("canvas");
                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, newWidth, newHeight);

                    canvas.toBlob((blob) => {
                        if (!blob) return reject("Canvas export failed");
                        const resizedFile = new File([blob], file.name, { type: file.type });

                        const oldSizeMB = (file.size / (1024 * 1024)).toFixed(2);
                        const newSizeMB = (resizedFile.size / (1024 * 1024)).toFixed(2);
                        console.log(`Original size: ${oldSizeMB} MB`);
                        console.log(`Compressed size: ${newSizeMB} MB`);
                        console.log(`Compression ratio: ${(100 - (resizedFile.size / file.size) * 100).toFixed(1)}% smaller`);

                        URL.revokeObjectURL(url);
                        resolve(resizedFile);
                    }, file.type, 0.95);
                }
            };

            img.onerror = (err) => {
                URL.revokeObjectURL(url);
                reject(err);
            };

            img.src = url;
        });
    }

    // Image Handling Methods
    async handleFileSelect(i, event) {
        try {
            // Determine source type
            let files = [];

            if (event?.filesUploaded) {
                files = event.filesUploaded.map(f => ({
                        ...f,
                        type: f.mimetype
                    }));
            } 
            else if (event?.target?.files) {
                files = Array.from(event.target.files)
            }

            if (!files.length) return;

            // Check if any images are already uploaded
            // const hasUploadedImages = this.images.some(img => img !== null);

            const maxUploadLength = Math.min(this.images.length, files.length);
            const emptySlots = this.getEmptySlots();
            for (let j = 0; j < maxUploadLength; j++) {
                if(files.length > 1) {
                    if (emptySlots[j] !== undefined) {
                        this.addLoadingClass(emptySlots[j]);
                    }
                }else{
                    this.addLoadingClass(i);
                }
            }

            if (files.length > 1) {
                this.handleMultiUpload(files);
            } else {
                this.handleImageUpload(i, files[0]);
            }

            if (event?.target) {
                event.target.value = '';
            }
        } catch (error) {
            console.error(error, "--err--");
            this.removeLoadingClass(i);
        }
    }


    // New method for handling initial multi-upload
    async handleMultiUpload(files) {
        const imageFiles = files.filter(file => file.type.startsWith('image/'));
        const emptySlots = this.getEmptySlots();
        const filesToUpload = imageFiles.slice(0, emptySlots.length);

        const results = await Promise.allSettled(
            filesToUpload.map((file, index) => {
                const slotIndex = emptySlots[index];
                return this.handleImageUpload(slotIndex, file);
            })
        );

        // Now that all frames should exist
        // emptySlots.forEach(index => this.updateSingleSlot(index, "first"));

        const successfulUploads = results.filter(r => r.status === 'fulfilled').length;
        if (successfulUploads > 0) {
            this.showToast(`Uploaded ${successfulUploads} images`);
        }
    }


    // Helper to get indices of empty slots
    getEmptySlots() {

        const emptySlots = [];
        for (let i = 0; i < this.images.length; i++) {
            if (!this.images[i]) {
                emptySlots.push(i);
            }
        }
        return emptySlots;
    }   

    // Restricts all image upload inputs to accept only a single file.
    allowSingleUpload() {
        S$$("input.img-upload").forEach(f => f.multiple = false);
    }

    // Enables multiple file selection on all image upload inputs.
    allowMultiUpload() {
        S$$("input.img-upload").forEach(f => f.multiple = true);
    }

    // Evaluates the current upload state of all image slots and updates the UI.
    checkAllImagesUploaded() {
        this.images = this.images.map(img => {
            if (img?.filestackUrl && !img.status) {
                return {
                    ...img,
                    status: this.IMAGE_STATUS.UPLOADED
                };
            }
            return img;
        });

        this.frames = this.frames.map(frame => {
            if (frame?.image?.filestackUrl && !frame.image.status) {
                return {
                    ...frame,
                    image: {
                        ...frame.image,
                        status: this.IMAGE_STATUS.UPLOADED
                    }
                };
            }
            return frame;
        });
        
        this.collage = {
            ...this.collage,
            frames: this.frames
        };

        this.updateGState({
            images: this.images,
            Collage: this.collage,
            Frames: this.frames,
        });

        const totalCount = this.images.length;
        const uploadedCount = this.images.filter(img => img && img.status === this.IMAGE_STATUS.UPLOADED).length;
        const uploadingCount = this.images.filter(img => img && img.status === this.IMAGE_STATUS.UPLOADING).length;
        const remaining = totalCount - uploadedCount;

        if (remaining !== totalCount) {
            this.allowSingleUpload();
        } else if (remaining === totalCount) {
            this.allowMultiUpload();
        }

        const allUploaded = totalCount > 0 && remaining === 0;

        const uploadMsg = document.querySelector(".cl_vp__photo-box .upload-msg");
        if (uploadMsg) {
            if (!allUploaded) {
                uploadMsg.innerText = `${remaining} Photos Remaining to Upload`;
            } else {
                uploadMsg.innerText = "";
            }
        }

        const atcBtn = document.querySelector(".cl_st__atc-btn");
        if (atcBtn) {
            if (totalCount === remaining && uploadingCount == 0 && uploadedCount == 0) {
                atcBtn.innerText = "Add to Cart";
                atcBtn.classList.add("disa");
                atcBtn.classList.remove("uploading");
            } else if (!allUploaded) {
                const currentCount = uploadedCount + uploadingCount;
                atcBtn.innerText = `${uploadingCount > 0 ? "Uploading" : "Uploaded"} (${currentCount}/${totalCount})`;
                atcBtn.classList.add("uploading", "disa");
            } else {
                atcBtn.innerText = "Add to Cart";
                atcBtn.classList.remove("uploading", "disa");
            }
        }

        // Manage other buttons (download, etc.)
        // const allUploadedWithoutFileStack = totalCount > 0 && remaining === 0;
        // if (allUploadedWithoutFileStack) {
        //     this.S$Q(".download-collage")?.classList?.remove("disa");
        //     this.S$Q(".download-collage-vizual")?.classList?.remove("disa");
        // } else {
        //     this.S$Q(".download-collage")?.classList?.add("disa");
        //     this.S$Q(".download-collage-vizual")?.classList?.add("disa");
        // }
    }

    // Check PPI for all frames
    checkPPI(frame = null) {
      const PPIObject = { PPI: [] };

      const frames = frame ? [frame] : this.S$$(".frame");

      frames.forEach((frame) => {
        const frameSizeW = frame.dataset.widthInInches;
        const frameSizeH = frame.dataset.heightInInches;
        const ceB = frame.querySelector(".img-box");
        const ceI = frame.querySelector(".img-box img");
        const {scale } = this.getScaleAndRotation(ceI);
        const ceSc = scale;
        const ceNW = ceI.naturalWidth;
        const paperDiagonalInches = Math.sqrt(
          frameSizeW ** 2 + frameSizeH ** 2
        );
        const imageDiagonal = Math.sqrt(
          (parseFloat(window.getComputedStyle(ceB).width) * (1 / ceSc)) ** 2 +
          (parseFloat(window.getComputedStyle(ceB).height) * (1 / ceSc)) ** 2
        );
        const currentPPI = imageDiagonal / paperDiagonalInches;
        PPIObject.PPI.push(currentPPI);
        if (currentPPI <= 70) {
          frame.classList.add("low-ppi");
        } else {
          frame.classList.remove("low-ppi");
        }
      });
      console.groupCollapsed("PPI Per Frame:");
      console.table(PPIObject);
      console.groupEnd();
    }

    // Handles a single image upload for a given slot index.
    async handleImageUpload(i, file) {
        const type = file.type || file.mimetype || file.filetype || "";

        if (!type.startsWith("image/")) return;

        let processedFile = file;
        if (file instanceof File || file instanceof Blob) {
            try {
                processedFile = await this.resizeImageToMaxSize(file);
                // processedFile = await this.compressImage(file, 4000);
            } catch (err) {
                console.error("Image resize failed, using original file:", err);
                processedFile = file;
            }
        }

        const loadImage = (src, alreadyUploaded = false) => {
            const img = new Image();
            img.onload = async () => {
            const frameId = await this.generateFrameId();
            const slotContainer = document.querySelector(
                `#collageGrid [data-index="${i}"] div`
            );
            this.addLoadingClass(i);

            let orgF = this.frames?.find((f) => f?.editPos == i);
            let orgI = orgF?.originalPos;
            if (!orgF) {
                orgI = i;
                console.warn(`No frame found at editPos ${i}`);
            }
            const tempImage = {
                previewURL: processedFile?.reuploadUrl || src,
                filestackUrl: alreadyUploaded ? processedFile?.reuploadUrl || src : null,
                frameId,
                status: alreadyUploaded
                ? this.IMAGE_STATUS.UPLOADED
                : this.IMAGE_STATUS.UPLOADING,
                scale: 1,
                rotation: 0,
                x: 0,
                y: 0,
                originalPos: orgI,
                editPos: i,
                naturalWidth: img.naturalWidth,
                naturalHeight: img.naturalHeight,
                file: processedFile,
            };

            if (!this.collage) {
                this.collage = this.createCollageObject({
                collageId: this.generateCollageId(),
                layout: "grid",
                frames: [],
                });
            }

            const newFrame = this.createFrameObject({
                ...tempImage,
                image: {
                previewURL: processedFile?.reuploadUrl || src,
                filestackUrl: alreadyUploaded
                    ? processedFile?.reuploadUrl || src
                    : null,
                naturalWidth: img.naturalWidth,
                naturalHeight: img.naturalHeight,
                status: tempImage.status,
                },
                cssStyles: {
                width: parseFloat(slotContainer.parentElement.getAttribute("width")),
                height: parseFloat(slotContainer.parentElement.getAttribute("height")),
                top: parseFloat(slotContainer.parentElement.getAttribute("y")),
                left: parseFloat(slotContainer.parentElement.getAttribute("x")),
                },
            });

            this.images[orgI] = tempImage;
            orgI = this.frames?.findIndex((f) => f?.originalPos == orgI);
            if (orgI == -1) orgI = i;
            this.collage.frames[orgI] = newFrame;
            this.frames[orgI] = newFrame;

            this.updateGState({
                images: this.images,
                Collage: this.collage,
                Frames: this.frames,
            });

            if (slotContainer) slotContainer.dataset.frameId = frameId;
            this.updateSingleSlot(i, "PageLoad");

            // If it's already uploaded (Filestack URL), skip upload
            if (alreadyUploaded) {
                this.checkAllImagesUploaded();
                return;
            }

            try {
                const filestackUrl = await this.uploadFrameToFilestack({
                    image: tempImage,
                });

                this.images[orgI] = {
                    ...this.images[orgI],
                    previewURL: filestackUrl,
                    filestackUrl: filestackUrl,
                    file: null,
                    status: this.IMAGE_STATUS.UPLOADED,
                };

                orgI = this.frames?.findIndex((f) => f?.originalPos == orgI);
                if (orgI == -1) orgI = i;

                this.frames[orgI] = {
                    ...this.frames[orgI],
                    image: {
                        ...this.frames[orgI].image,
                        filestackUrl,
                        previewURL: filestackUrl,
                        status: this.IMAGE_STATUS.UPLOADED,
                    },
                };

                this.collage.frames[orgI] = {
                    ...this.collage.frames[orgI],
                    image: {
                        ...this.collage.frames[orgI].image,
                        filestackUrl,
                        previewURL: filestackUrl,
                        status: this.IMAGE_STATUS.UPLOADED,
                    },
                };
                this.checkAllImagesUploaded();
            } catch (error) {
                console.error(`Upload failed for image ${i}:`, error);
                this.images[i].status = this.IMAGE_STATUS.FAILED;
                this.frames[i].image.status = this.IMAGE_STATUS.FAILED;
                this.collage.frames[i].image.status = this.IMAGE_STATUS.FAILED;
            }

            this.updateGState({
                images: this.images,
                Collage: this.collage,
                Frames: this.frames,
            });
            };

            img.src = src;
        };

        if (processedFile instanceof File || processedFile instanceof Blob) {
            // Local file
            // const reader = new FileReader();
            // reader.onload = (e) => loadImage(e.target.result, false);
            // reader.readAsDataURL(file);
            const blobUrl = URL.createObjectURL(processedFile);
            loadImage(blobUrl, false);
        } else if (processedFile.url) {
            // Filestack object
            loadImage(processedFile.url, true);
        } else {
            console.error("Unsupported file format", processedFile);
        }
    }

    // Handles drag-and-drop image upload.
    handleDrop(i, event) {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type.startsWith('image/')) {
            this.handleImageUpload(i, file);
        }
    }

    // Calculates rotation, minimum scale, and new position so the same visible center point remains centered after rotation without exposing gaps.
    applyRotationWithMinScaleAndCenter(ceI, ceB, newTransform, oldRotation) {
        const result = {
            rotation: newTransform.rotation,
            scale: newTransform.scale,
            left: parseFloat(ceI.style.left) || 0,
            top: parseFloat(ceI.style.top) || 0
        };

        /* FRAME CENTER */
        const boxRect = ceB.getBoundingClientRect();
        const frameCX = boxRect.left + boxRect.width / 2;
        const frameCY = boxRect.top + boxRect.height / 2;

        /* IMAGE CENTER */
        const imgRectBefore = ceI.getBoundingClientRect();
        const imgCX = imgRectBefore.left + imgRectBefore.width / 2;
        const imgCY = imgRectBefore.top + imgRectBefore.height / 2;

        const vx = frameCX - imgCX;
        const vy = frameCY - imgCY;

        /* MIN SCALE */
        const natW = ceI.naturalWidth;
        const natH = ceI.naturalHeight;

        const boxW = ceB.clientWidth;
        const boxH = ceB.clientHeight;

        const rot = Math.abs(newTransform.rotation % 180);
        const vertical = rot === 90;

        const imgW = vertical ? natH : natW;
        const imgH = vertical ? natW : natH;

        const minScaleX = (boxW * 1.02) / imgW;
        const minScaleY = (boxH * 1.02) / imgH;

        const minScale = Math.max(minScaleX, minScaleY);

        result.scale = Math.max(newTransform.scale, minScale);

        /* ROTATE VECTOR */
        const delta = (newTransform.rotation - oldRotation) * Math.PI / 180;
        const rx = vx * Math.cos(delta) - vy * Math.sin(delta);
        const ry = vx * Math.sin(delta) + vy * Math.cos(delta);

        /* NEW POSITION */
        result.left += (vx - rx);
        result.top += (vy - ry);

        return result;
    }

    //  Updates the current image's transform (scale/rotation) in the editor.
    async updateImageTransform(updates = {}) {

        if (!this.pu.ceI) return;
        const { performedRotate } = updates;
        const pu = this.pu;
        const f = pu.ceF;
        f.classList.add("no-transition");
        const ceI = this.pu.ceI;
        const ceB = this.pu.ceB;

        const { scale, rotate } = this.getScaleAndRotation(ceI);

        const current = {
            rotation: rotate,
            scale: scale
        };

        const newTransform = { ...current, ...updates };

        if (performedRotate) {
            // run rotation-specific logic
            const result = this.applyRotationWithMinScaleAndCenter(
                this.pu.ceI,
                this.pu.ceB,
                newTransform,
                rotate
            );

            newTransform.scale = result.scale;
            this.pu.ceI.dataset.scale = "more";
            this.pu.ceI.style.left = `${result.left}px`;
            this.pu.ceI.style.top = `${result.top}px`;
        }

        this.pu.ceI.style.transform = `rotate(${newTransform.rotation}deg) scale(${newTransform.scale})`;

        this.sizeAdjustPosition({frame: this.pu.ceF, Ra4Sc: 1, action: "PageLoad"});

        this.loadImageForEditing();
        f.classList.remove("no-transition");
    }

    // Rotates the currently selected image by a given number of degrees.
    rotateImage(degrees) {
        if (!this.pu.ceI) {
            console.warn('No image element selected for rotation');
            return;
        }

        // Get current rotation from dataset or parse from transform
        const { rotate } = this.getScaleAndRotation(this.pu.ceI);
        const newRotation = rotate + degrees;
        this.pu.rotation = newRotation;
        this.pu.SoRchanged = true;
        this.updateImageTransform({ rotation: newRotation , performedRotate: true});
    }

    // Toggles grayscale (black & white) filter on the current image.
    applyBlackWhite() {
        const img = this.pu.ceI;
        if (!img) return;

        const isGrayscale = img.style.filter?.includes('grayscale');
        if (isGrayscale) {
            this.updatePopupState({ ceBW: true });
            img.style.filter = 'none';
            img.style.webkitFilter = 'none';
        } else {
            this.updatePopupState({ ceBW: false });
            img.style.filter = 'grayscale(100%)';
            img.style.webkitFilter = 'grayscale(100%)';
        }
        this.pu.SoCchanged = true;
        // img.style.filter = isGrayscale ? 'none' : 'grayscale(100%)';
    }

    // Position and Scaling Methods
    updateSingleSlot(index, action) {
        const slotContainer = document.querySelector(`#collageGrid [data-index="${index}"] div`);
        if (!slotContainer) return;

        const imgBox = slotContainer.querySelector('.img-box');
        this.addLoadingClass(index);

        imgBox.innerHTML = '';
        let imageIndex = this.images.findIndex(img => img?.editPos == index);
        if (this.images[imageIndex]) {
            slotContainer.classList.add("frame");
            slotContainer.removeEventListener("click", this.frameClickHandler);
            slotContainer.addEventListener("click", this.frameClickHandler);
            const img = document.createElement('img');
            img.src = this.images[imageIndex].previewURL;
            img.className = 'preview-img';
            img.dataset.scale = "min";
            img.style.display = "block";
            imgBox.appendChild(img);
            this.updateSingleImagePosition(index, action);
            this.updateGState({ images: this.images })
        } else {
            const emptySlot = this.createEmptySlot(index);
            imgBox.appendChild(emptySlot);
            imgBox.classList.remove("cimg-loading");
        }
        let orgI = this.images[index]?.originalPos || index;
        // this.renderPhotoList();
        this.updatePhotoItem(orgI);
    }

    updatePhotoItem(i) {
        const oldItem = this.photoList.querySelector(`div[data-index="${i}"]`);
        if (!oldItem) return;

        const newItem = this.createPhotoItem(i);
        this.photoList.replaceChild(newItem, oldItem);
    }

    // Get tallest frame dimensions
    getWstAndTstFrameD(frames) {

        let maxFrameHeight = 0;
      let maxFrameWidth = 0;
      Object.values(frames).forEach((frame) => {
        const width = parseInt(frame.width, 10);
        const height = parseInt(frame.height, 10);

        if (width > maxFrameWidth) {
          maxFrameWidth = width;
        }
        if (height > maxFrameHeight) {
          maxFrameHeight = height;
        }
      });

      return { maxFrameHeight, maxFrameWidth };
    }

    updateSingleImagePosition(i, action) {
        const frame = document.querySelector(`#collageGrid [data-index="${i}"] div`);
        if (!frame) return;

        // const { maxFrameHeight, maxFrameWidth } = { maxFrameHeight: this.config.width, maxFrameWidth: 8 };

        const { maxFrameHeight, maxFrameWidth } = this.getWstAndTstFrameD(this.config.windows);

        const { height: maxHeight, width: maxWidth } = this.scaled.windows[`${i + 1}`];

        const hr = maxFrameHeight / maxHeight;
        const wr = maxFrameWidth / maxWidth;
        const a2c = hr > wr ? "h" : "window";

        try {
            this.updateFrameSize(frame, maxFrameHeight, maxHeight, maxFrameWidth, maxWidth, a2c, action);
        } catch (frameError) {
            this.handleImageError(i)
            console.error(`❌ Error updating frame ${i}:`, frameError);
        }
    }

    updateImgPosition(i, i2s, isPersist = false) {
        i = parseInt(i, 10);
        const frame = document.querySelector(`#collageGrid [data-index="${i}"] div`);
        if (!frame) return;
        const { maxFrameHeight, maxFrameWidth } = this.getWstAndTstFrameD(this.config.windows);;
        const { height: maxHeight, width: maxWidth } = this.scaled.windows[`${i + 1}`];

        const hr = maxFrameHeight / maxHeight;
        const wr = maxFrameWidth / maxWidth;
        const a2c = hr > wr ? "h" : "window";
        // const a2c = hr;
        const action = "PageLoad";
        const images = document.querySelectorAll(".img-box img");
     
        // const frames = Array.from(images).map(img => img.closest(".frame"));
        // frames.forEach((frame, i) => {
        try {
            this.updateFrameSize(frame, maxFrameHeight, maxHeight, maxFrameWidth, maxWidth, a2c, action, i2s, isPersist);
        } catch (frameError) {
             this.handleImageError(i)
            console.error(`❌ Error updating frame ${i}:`, frameError);
        }
        // });
    }

    async updateFrameSize(frame, maxFrameHeight, maxHeight, maxFrameWidth, maxWidth, a2c, action, i2s, isPersist = false) {
        if (frame.querySelector(".img-box-empty")) return;

        const ceB = frame.querySelector(".img-box");
        const ceI = frame.querySelector(".img-box img");
        if (!ceI) return;
        if (!ceI || !ceI.complete || ceI.naturalWidth === 0) {
            return new Promise((resolve) => {
                ceI.addEventListener(
                    "load",
                    async () => {
                        await this.updateFrameSize(frame, maxFrameHeight, maxHeight, maxFrameWidth, maxWidth, a2c, action, i2s, isPersist);
                        resolve();
                    },
                    { once: true }
                );
            });
        }

        if (frame.querySelectorAll(".img-box").length > 0) {
            var oldBW = ceB.clientWidth;
            var oldBH = ceB.clientHeight;
            const natW = ceI.naturalWidth;
            const natH = ceI.naturalHeight;

            const CLeft = ceI.offsetLeft;
            const CTop = ceI.offsetTop;

            const elWCe = (natW - oldBW) / 2;
            const elHCe = (natH - oldBH) / 2;

            var bigLeft = -elWCe;
            var bigTop = -elHCe;

            var oldWdiFC = CLeft - bigLeft;
            var oldHdiFC = CTop - bigTop;
        }

        const borderInInches = 0;
        const bII = 0;
        const widthInInches = parseInt(frame.getAttribute("data-width-in-inches"), 10);
        const heightInInches = parseInt(frame.getAttribute("data-height-in-inches"), 10);
        const heightRatio = heightInInches / maxFrameHeight;
        const widthRatio = widthInInches / maxFrameWidth;


        let Ra4Sc = heightRatio;
        let adjustedHeight, adjustedWidth;

        if (a2c == "h") {
            adjustedHeight = heightRatio * maxHeight;
            adjustedWidth = (widthInInches / heightInInches) * adjustedHeight;
            if (adjustedWidth > maxWidth) {
                const widthRatio = maxWidth / adjustedWidth;
                adjustedWidth = maxWidth;
                adjustedHeight *= widthRatio;
            }
        } else {
            Ra4Sc = widthRatio;
            adjustedWidth = widthRatio * maxWidth;
            adjustedHeight = (heightInInches / widthInInches) * adjustedWidth;
            if (adjustedHeight > maxHeight) {
                const heightRatio = maxHeight / adjustedHeight;
                adjustedHeight = maxHeight;
                adjustedWidth *= heightRatio;
            }
        }

        const s4c = widthInInches > heightInInches ? heightInInches : widthInInches;
        const adjustedBorder = (borderInInches / heightInInches) * adjustedHeight;
        const adjustedMat = ((s4c * bII) / heightInInches) * adjustedHeight;
        const PXwidthRatio = adjustedWidth / parseFloat(frame.style.width);

        const parsedFramedData = this?.frames.find(f => (f && f?.id) && f?.id === frame.dataset.frameId);
        const frameId = frame.dataset.frameId;

        if(isPersist && parsedFramedData) {
            let widthPx = adjustedWidth, heightPx = adjustedHeight, scp;
            if (this.dType == "D") {
                heightPx = maxHeight;
                widthPx = (maxHeight / heightInInches) * widthInInches;

                if (widthPx > maxWidth) {
                    widthPx = maxWidth;
                    heightPx = (maxWidth / widthInInches) * heightInInches;
                }


                } else {
                const ratio = widthInInches / heightInInches;
                if (maxWidth / maxHeight > ratio) {
                    heightPx = maxHeight;
                    widthPx = maxHeight * ratio;
                } else {
                    widthPx = maxWidth;
                    heightPx = maxWidth / ratio;
                }
            } 
            
            scp = parseInt(heightPx) / parseInt(parsedFramedData.cssStyles.height);
            // const scpW = widthPx / parseInt(parsedFramedData.cssStyles.width);
            // const scpH = heightPx / parseInt(parsedFramedData.cssStyles.height);
            // scp = Math.min(scpW, scpH); 

            await this?.renderItemFromData({
                    frame: frame,
                    parsedMainFrame: {
                        frameHeight: parseFloat(parsedFramedData.cssStyles.height),
                        frameWidth: parseFloat(parsedFramedData.cssStyles.width),
                        borderWidth: parseFloat(0),
                        padding: parseFloat(0),
                        scale: parseFloat(parsedFramedData.image.imgStyles.scale),
                        rotate: parseFloat(parsedFramedData.image.imgStyles.rotation),
                        top: parseFloat(parsedFramedData.image.imgStyles.top),
                        left: parseFloat(parsedFramedData.image.imgStyles.left),
                        bW: parsedFramedData.image.imgStyles.filter
                    },
                    widthPx,
                    heightPx,
                    scaleCorrection: scp,
                    applyImgBoxTransform: true,
                    Ra4Sc,
                    oldWdiFC,
                    oldHdiFC,
                    action
            });

        }else{
            // frame.style.height = `${adjustedHeight}px`;
            // frame.style.width = `${adjustedWidth}px`;
            // frame.style.borderWidth = `${adjustedBorder}px`;
            // frame.style.padding = `${adjustedMat}px`;
            this.updateCollageState({
                "cssStyles.width": parseFloat(adjustedWidth),
                "cssStyles.height": parseFloat(adjustedHeight),
            }, null, frameId)

            if (frame.querySelectorAll(".img-box").length > 0) {
                await this.sizeAdjustPosition({
                    frame,
                    Ra4Sc :PXwidthRatio,
                    action,
                    oldWdiFC,
                    oldHdiFC
                });
            }
        }

        this.removeLoadingClass(null, frameId);
        this.checkAllImagesUploaded();

        await new Promise(requestAnimationFrame);

        setTimeout(() => this.checkPPI(frame), 200);

        let finished = false;

        const runUpdate = () => {
            if (finished) return;
            finished = true;

            const { scale: s, rotate: r } = this.getScaleAndRotation(ceI);

            this.updateCollageState({
                "image.imgStyles.width": parseFloat(ceB.style.width),
                "image.imgStyles.height": parseFloat(ceB.style.height),
                "image.imgStyles.left": parseFloat(ceI.style.left),
                "image.imgStyles.top": parseFloat(ceI.style.top),
                "image.imgStyles.scale": parseFloat(s),
                "image.imgStyles.rotation": parseFloat(r),
                "image.imgStyles.filter": ceI.style.filter,
                "image.scale": ceI.dataset.scale,
                "cssStyles.width": parseFloat(frame.style.width),
                "cssStyles.height": parseFloat(frame.style.height),
            }, null, frameId);
        };

        const onEnd = (e) => {
            if (e.target !== ceI) return;
            if (e.propertyName !== "transform") return;
            ceI.removeEventListener("transitionend", onEnd);
            runUpdate();
        };

        ceI.addEventListener("transitionend", onEnd);

        // fallback if transition never fires
        setTimeout(runUpdate, 350);
        
        return true;
    }

    // Helper: get rotated bounding box size
    getRotatedSize(width, height, angleDeg) {
        const angle = (angleDeg * Math.PI) / 180;
        const cos = Math.abs(Math.cos(angle));
        const sin = Math.abs(Math.sin(angle));
        return {
            width: width * cos + height * sin,
            height: width * sin + height * cos
        };
    }

    createMeasureClone(frame) {
      const clone = frame.cloneNode(true);
      clone.classList.remove("frame");
      clone.classList.remove("framefh");
      clone.classList.add("clone-f", "clone-f-measure", "no-transition");
      
      clone.style.boxSizing = getComputedStyle(frame).boxSizing;

      frame.parentNode.insertBefore(clone, frame.nextSibling);
      
      // Force reflow to ensure styles are applied
      clone.offsetHeight;
      
      return clone;
    }

    async calculateImageLayout(frame, ife, bfe, scale, left, top, frameData) {
      let {width, height, borderWidth, padding, rotate } = frameData;
      
      frame.style.width = width + "px";
      frame.style.height = height + "px";
      frame.style.borderWidth = borderWidth + "px";
      frame.style.padding = padding + "px";
      
      bfe.style.width = `100%`;
      bfe.style.height = `100%`;

      ife.style.transform = `rotate(${rotate}deg) scale(${scale})`;
      ife.style.left = `${left}px`;
      ife.style.top = `${top}px`;

      // Wait for DOM update
      await new Promise(requestAnimationFrame);
      
      const imgRect = ife.getBoundingClientRect();
      const frameRect = bfe.getBoundingClientRect();
      
      const safeWMargin = bfe.clientWidth * 0.01;
      const safeHMargin = bfe.clientHeight * 0.01;
      
      let bigLeft = left;
      let bigTop = top;
      
      // Adjust if image doesn't cover frame
      if (imgRect.left > frameRect.left - safeWMargin) {
        bigLeft = frameRect.left - imgRect.left - safeWMargin + parseFloat(ife.style.left);
      }
      if (imgRect.top > frameRect.top - safeHMargin) {
        bigTop = frameRect.top - imgRect.top - safeHMargin + parseFloat(ife.style.top);
      }
      if (imgRect.right < frameRect.right + safeWMargin) {
        bigLeft = frameRect.right - imgRect.right + safeWMargin + parseFloat(ife.style.left);
      }
      if (imgRect.bottom < frameRect.bottom + safeHMargin) {
        bigTop = frameRect.bottom - imgRect.bottom + safeHMargin + parseFloat(ife.style.top);
      }

      ife.style.left = `${bigLeft}px`;
      ife.style.top = `${bigTop}px`;

      return { left: bigLeft, top: bigTop, scale };
    }

    async smoothSizeAdjust({frame, scale, left, top, frameData}) {
      const clone = this.createMeasureClone(frame);

      const cloneImg = clone.querySelector(".img-box img");
      const cloneBox = clone.querySelector(".img-box");

      const layout = await this.calculateImageLayout(
        clone, 
        cloneImg, 
        cloneBox, 
        scale, 
        left, 
        top, 
        frameData
      );

      // Clean up clone after measurement
      clone.remove();

      this.applyFinalLayout(frame, layout, frameData);

      frame.offsetHeight;

      return true;
    }

    applyFinalLayout(frame, layout, frameData) {
      const img = frame.querySelector(".img-box img");
      const imgBox = frame.querySelector(".img-box");
      frame.offsetHeight;
      let {width, height, borderWidth, padding, rotate } = frameData;
      
      frame.style.width = width + "px";
      frame.style.height = height + "px";
      frame.style.borderWidth = borderWidth + "px";
      frame.style.padding = padding + "px";

      img.dataset.scaleVal = layout.scale;
      img.style.left = layout.left + "px";
      img.style.top  = layout.top + "px";
      img.style.transform = `rotate(${rotate}deg) scale(${layout.scale})`;

      frame.offsetHeight;
    }

    pendingFrameOperations = new Map()

    async sizeAdjustPosition({frame, Ra4Sc, action, oldWdiFC, oldHdiFC, newLeft, newTop, newScale, rotate}) {
        const frameId = frame.dataset.frameId;
      
        // Cancel any pending operation for this frame
        if (this.pendingFrameOperations.has(frameId)) {
            console.log(`Canceling pending operation for frame ${frameId}`);
            const pending = this.pendingFrameOperations.get(frameId);
            
            // Clear timeout if exists
            if (pending.cleanupTimer) {
            clearTimeout(pending.cleanupTimer);
            }
            
            // Remove event listener if exists
            if (pending.onFrameEnd) {
            pending.frame.removeEventListener("transitionend", pending.onFrameEnd);
            }
            
            // Remove from map
            this.pendingFrameOperations.delete(frameId);
        }
        // document.querySelectorAll(".clone-f").forEach(f=> f.remove());
        var ife = frame.querySelector(".img-box img");
        if (!ife || !ife.complete || ife.naturalWidth === 0) {
            return new Promise((resolve) => {
                ife.addEventListener(
                    "load",
                    async () => {
                        await this.sizeAdjustPosition({ frame, Ra4Sc, action, oldWdiFC, oldHdiFC, newLeft, newTop, newScale });
                        resolve();
                    },
                    { once: true }
                );
            });
        }
        if (!ife || !ife.complete || ife.naturalWidth === 0) return;

        const frames = window.Clg.State.Collage.frames;
        const sF = frames.find(f => f?.id == frame?.dataset?.frameId);

        const css = sF?.cssStyles;
        const width = css?.width ?? frame.style.width;
        const height = css?.height ?? frame.style.height;
        const borderWidth = css?.borderWidth ?? frame.style.borderWidth;
        const padding = css?.padding ?? frame.style.padding;

        const FWidthPx = this.toNumberPx(width);
        const FHeightPx = this.toNumberPx(height);
        const FBorderPx = this.toNumberPx(borderWidth);
        const FPaddingPx = this.toNumberPx(padding);

        const boxw = Math.ceil(FWidthPx - ((FBorderPx * 2) + (FPaddingPx * 2)));
        const boxh = Math.ceil(FHeightPx - ((FBorderPx * 2) + (FPaddingPx * 2)));

        var bfe = frame.querySelector(".img-box");
        const natW = ife.naturalWidth;
        const natH = ife.naturalHeight;

        // Only use them if they're explicitly passed (for border changes)
        const useProvidedValues = (newLeft !== undefined && newTop !== undefined && newScale !== undefined);
        let { scale: crSc, rotate: cRotate } = this.getScaleAndRotation(ife);
        rotate = rotate ?? cRotate ?? 0;
        var oldLeft = useProvidedValues ? parseFloat(newLeft) : (parseFloat(ife.style.left) || parseFloat(ife.offsetLeft));
        var oldTop = useProvidedValues ? parseFloat(newTop) : (parseFloat(ife.style.top) || parseFloat(ife.offsetTop));
        crSc = useProvidedValues ? parseFloat(newScale) : (crSc || 1);

        console.log("------------crSc", crSc);

        Ra4Sc = Ra4Sc || 1;

        let curentScales = !crSc ? 0 : crSc * Ra4Sc;

        const rot = Math.abs(rotate % 180);
        const vertical = rot === 90;
        const imgW = vertical ? natH : natW;
        const imgH = vertical ? natW : natH;

        let posrotation = "h";
        if (posrotation == "v") {
            var minScaleX = (boxw * 1.02) / imgH;
            var minScaleY = (boxh * 1.02) / imgW;
        } else {
            var minScaleX = (boxw * 1.02) / imgW;
            var minScaleY = (boxh * 1.02) / imgH;
        }

        curentScales = ife.dataset.scale === "more" ? Math.max(curentScales, Math.max(minScaleX, minScaleY)) : Math.max(minScaleX, minScaleY);

        // Pg.Popup.current.ceScale = Math.max(Pg.Popup.current.ceScale,minScaleX,minScaleY);

        let bigLeft = oldLeft;
        let bigTop = oldTop;
        if (crSc > 0 && action != "PageLoad") {
            if (action === "shape") {
                const NEWelWCe = (natW - boxw) / 2;
                const NEWelHCe = (natH - boxh) / 2;

                const WdiFC = (oldWdiFC / crSc) * curentScales;
                const HdiFC = (oldHdiFC / crSc) * curentScales;

                bigLeft = -NEWelWCe + WdiFC;
                bigTop = -NEWelHCe + HdiFC;
                // ife.style.left = `${bigLeft}px`;
                // ife.style.top = `${bigTop}px`;
            } else {
                var newScale = parseFloat(curentScales);
                var curentScale = parseFloat(crSc);
                var newScaleDifrence = 1 - newScale;
                var mnwXsd = (ife.naturalWidth * newScaleDifrence) / 2;
                var mnhXsd = (ife.naturalHeight * newScaleDifrence) / 2;
                var curentScaleDifrence = 1 - curentScale;
                var pnwXsd = (ife.naturalWidth * curentScaleDifrence) / 2;
                var pnhXsd = (ife.naturalHeight * curentScaleDifrence) / 2;
                var pwdis = pnwXsd + oldLeft;
                var phdis = pnhXsd + oldTop;
                var mwdis = (pwdis / curentScale) * newScale;
                var mhdis = (phdis / curentScale) * newScale;
                bigLeft = -mnwXsd + mwdis;
                bigTop = -mnhXsd + mhdis;
                // ife.style.left = `${bigLeft}px`;
                // ife.style.top = `${bigTop}px`;
            }
        }
        const frameData = {
            width: FWidthPx,
            height: FHeightPx,
            borderWidth: FBorderPx,
            padding: FPaddingPx,
            rotate,
        }
        await this.smoothSizeAdjust({ frame, scale: curentScales, left: bigLeft, top: bigTop, action, frameData });

        //   frame.style.setProperty('--frame-size', `${FBorderPx}px`);

        let cleanupTimer = null;
        let finished = false;
        const cleanup = () => {
            if (finished) return;
            finished = true;
            // Clear the timeout if it hasn't executed yet
            if (cleanupTimer) {
            clearTimeout(cleanupTimer);
            cleanupTimer = null;
            }
            frame.removeEventListener("transitionend", onFrameEnd);
            
            // Remove the stored reference
            if (frame._onFrameEnd === onFrameEnd) {
            frame._onFrameEnd = null;
            }
            // Remove from pending operations map
            if (this.pendingFrameOperations.get(frameId)?.onFrameEnd === onFrameEnd) {
            this.pendingFrameOperations.delete(frameId);
            }

            this.sizeAdjuster(ife, bfe, frame);
            ife.style.opacity = "1";
            ife.style.pointerEvents = "auto";
        };

        const onFrameEnd = (e) => {
            const FRAME_PROPS = ["width","height","padding","border"];
            if (!FRAME_PROPS.some(p => e.propertyName.startsWith(p))) return;
            cleanup();
        };

        // Clean up any existing listener on the frame itself
        if (frame._onFrameEnd) {
            frame.removeEventListener("transitionend", frame._onFrameEnd);
        }
        
        // Set up new listener
        frame._onFrameEnd = onFrameEnd;
        frame.addEventListener("transitionend", onFrameEnd);

        const MAX_TRANSITION_TIME = 350;
        cleanupTimer = setTimeout(cleanup, MAX_TRANSITION_TIME);
        
        // Store this operation in the pending map
        this.pendingFrameOperations.set(frameId, {
            cleanupTimer,
            onFrameEnd,
            frame
        });
        
        return true;
    }  

    async sizeAdjuster(ife, bfe, frame) {
      await new Promise(requestAnimationFrame);
      frame.classList.add('no-transition-adjust');
      const imgRect = ife.getBoundingClientRect();
      const frameRect = bfe.getBoundingClientRect();
      var safeWMargin = bfe.clientWidth * 0.01;
      var safeHMargin = bfe.clientHeight * 0.01;
      let bigLeft = parseFloat(ife.style.left) || ife.offsetLeft;
      let bigTop = parseFloat(ife.style.top) || ife.offsetTop;
      if (imgRect.left > frameRect.left - safeWMargin) {
        bigLeft =
          frameRect.left - imgRect.left - safeWMargin + ife.offsetLeft;
      }
      if (imgRect.top > frameRect.top - safeHMargin) {
        bigTop = frameRect.top - imgRect.top - safeHMargin + ife.offsetTop;
      }
      if (imgRect.right < frameRect.right + safeWMargin) {
        bigLeft =
          frameRect.right - imgRect.right + safeWMargin + ife.offsetLeft;
      }
      if (imgRect.bottom < frameRect.bottom + safeHMargin) {
        bigTop =
          frameRect.bottom - imgRect.bottom + safeHMargin + ife.offsetTop;
      }

      ife.style.left = `${bigLeft}px`;
      ife.style.top = `${bigTop}px`;
      frame.classList.remove('no-transition-adjust');
    }

    toNumberPx(value, fallback = 0) {
      if (value === null || value === undefined) return fallback;

      if (typeof value === "number") return value;

      
      if (typeof value === "string") {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? fallback : parsed;
      }
      return fallback;
    }

    //  Extracts the current scale and rotation (in degrees) from a transformed element.
    getScale(element) {
        const computedStyle = window.getComputedStyle(element).transform;

        if (computedStyle === "none") return 1;

        const matrixMatch = computedStyle.match(/matrix\(([^)]+)\)/);
        if (!matrixMatch) {
            console.warn("Transform not in expected matrix format:", computedStyle);
            return 1;
        }

        const matrixValues = matrixMatch[1].split(',').map(v => parseFloat(v.trim()));
        const scaleX = matrixValues[0];
        const scaleY = matrixValues[3];
        return scaleX;
    }

    //  Extracts the current scale from a transformed element.
    getScaleAndRotation(element) {
        const computedStyle = window.getComputedStyle(element).transform;

        if (computedStyle === "none") {
            return { scale: 1, rotate: 0 };
        }

        const matrixMatch = computedStyle.match(/matrix\(([^)]+)\)/);
        if (!matrixMatch) {
            console.warn("Transform not in expected 2D matrix format:", computedStyle);
            return { scale: 1, rotate: 0 };
        }

        const values = matrixMatch[1].split(',').map(v => parseFloat(v.trim()));
        const [a, b, c, d] = values;

        // scaleX = sqrt(a² + b²)
        const scaleX = Math.sqrt(a * a + b * b);
        // scaleY = sqrt(c² + d²)
        const scaleY = Math.sqrt(c * c + d * d);

        // rotation in radians = atan2(b, a)
        const rotationRad = Math.atan2(b, a);
        const rotationDeg = rotationRad * (180 / Math.PI);

        return { scale: scaleX, rotate: rotationDeg };
    }

    // Popup Editor Methods
    editpu(e) {
        this.pu = this.getDefaultPu();
        this.pu.isOpen = true;
        const ci = e.target.classList.contains("frame") ? e.target : e.target.closest(".frame");
        if (!ci) {
            console.warn("Frame not found for edit");
            return;
        };

        const el = this.S$Q('.cl_epu-body .frame');
        if (el) {
            el.remove();
        }

        this.S$Q(".cfp").classList.add("body-lock");
        const popupState = this.pu;
        const edi = ci.parentElement.getAttribute("data-index");

        popupState.cuF = ci;
        popupState.cuB = ci.querySelector(".img-box");
        popupState.cuI = ci.querySelector(".img-box img");
        popupState.cuHeight = parseInt(ci.dataset.heightInInches, 10);
        popupState.cuWidth = parseInt(ci.dataset.widthInInches, 10);
        popupState.cuSize = `${popupState.cuWidth}x${popupState.cuHeight}`;
        popupState.cuBorder = ci.dataset.frameBorder;
        popupState.cuStyle = ci.dataset.frameStyle;
        popupState.cuAcrylic = ci.dataset.frameAcrylic;
        const { scale, rotate } = this.getScaleAndRotation(popupState.cuI)
        popupState.cuScale = scale || 1;
        popupState.zmSlider = this.S$G('SCRzoomSlider');
        popupState.image = popupState.cuI?.getAttribute("src");

        let sci;
        try {
            sci = ci.cloneNode(true);
            sci.classList.add("no-transition");
            popupState.ceF = sci;
            popupState.ceF.classList.remove("absolute");
            popupState.ceF.style.position = "unset";
            popupState.ceB = sci.querySelector(".img-box");
            popupState.ceI = sci.querySelector(".img-box img");
            popupState.ceNH = popupState.ceI.naturalHeight;
            popupState.ceNW = popupState.ceI.naturalWidth;
            popupState.ceWidth = popupState.cuWidth;
            popupState.ceHeight = popupState.cuHeight;
            popupState.ceSize = popupState.cuSize;
            popupState.ceStyle = sci.dataset.frameStyle;
            popupState.ceBorder = sci.dataset.frameBorder;
            popupState.ceAcrylic = sci.dataset.frameAcrylic;
            popupState.ceScale = popupState.ceHeight / parseFloat(ci.style.height);

            for (const img of sci.querySelectorAll("img")) {
                if (!img.complete || img.naturalWidth === 0) throw new Error();
            }
        } catch (err) {
            console.warn(err.message);
            return;
        }

        const heightInInches = parseInt(sci.getAttribute("data-height-in-inches"), 10);
        const widthInInches = parseInt(sci.getAttribute("data-width-in-inches"), 10);
        let widthPx, heightPx, scp, maxW, maxH;

        if (this.dType == "D") {
            maxW = 320;
            maxH = 320;
            scp = 320 / parseInt(sci.style.height);
            widthPx = (320 / heightInInches) * widthInInches;
            heightPx = 320;
            // sci.style.width = widthPx + "px";
            // sci.style.height = "320px";
            
        } else {
            maxW = window.innerWidth * 0.8;
            // maxH = window.innerHeight * 0.5;
            maxH = this.ui.editMidAreaAvail; 

            // let widthPx, heightPx;
            const ratio = widthInInches / heightInInches;

            if (maxW / maxH > ratio) {
                heightPx = maxH;
                widthPx = maxH * ratio;
            } else {
                widthPx = maxW;
                heightPx = maxW / ratio;
            }

            scp = heightPx / parseInt(sci.style.height);
            // sci.style.width = widthPx + "px";
            // sci.style.height = heightPx + "px";
        }

        const sciborder = parseFloat(sci.style.borderWidth) * scp;
        const scipadding = parseFloat(sci.style.padding) * scp;
        const varSize = widthInInches < heightInInches ?
            `${widthInInches}x${heightInInches}` :
            `${heightInInches}x${widthInInches}`;

        sci.style.borderWidth = sciborder + "px";
        sci.style.padding = scipadding + "px";
        sci.classList.add("frame");

        this.S$Q(".cl_epu-body").appendChild(sci);
        this.S$Q(".cl_epu").style.display = "block";
        this.S$Q(".cl_epu").setAttribute("data-edit-i", edi);

        const pu = popupState;
        const { scale: popupScale, rotate: popupRotate } = this.getScaleAndRotation(pu.ceI);
        this.updatePopupState({
            ceScale: popupScale * scp,
            ceSize: `${widthInInches}x${heightInInches}`,
            cuScale: popupScale,
            rotation: popupRotate
        });

        this.renderItemFromData({
                    frame: sci,
                    parsedMainFrame: {
                        frameHeight: parseFloat(sci.style.height),
                        frameWidth: parseFloat(sci.style.width),
                        borderWidth: parseFloat(0),
                        padding: parseFloat(0),
                        scale: parseFloat(popupScale),
                        rotate: parseFloat(popupRotate),
                        top: parseFloat(pu.ceI.style.top),
                        left: parseFloat(pu.ceI.style.left),
                        bW: pu.ceI.style.filter
                    },
                    widthPx,
                    heightPx,
                    scaleCorrection: scp,
                    applyImgBoxTransform: true,
                    Ra4Sc: 1,
        })
        
        this.updatePopupState({
            ceLeft: pu.ceI.style.left,
            ceTop: pu.ceI.style.top,
        });

        if (!this.handlersInitialized) {
            this.initHandlers();
        }

        if (popupState.zmSlider) {
            const zoomButtons = this.S$$(".cl_epu-zoom-container button");

           popupState.zmSlider.addEventListener("input", this.boundHandlers.zoomInput, this.dType === "D" ? true : { passive: true });

            const eventType = this.dType === "D" ? "click" : "touchstart";
          
            zoomButtons.forEach(button => {
                const zmSlider = popupState.zmSlider;
                const handler = (e) => this.boundHandlers.zoomButton(e, zmSlider, button);
                this.boundHandlers.zoomButtonHandlers.set(button, handler);
                button.addEventListener(eventType, handler);
            });
        }

        this.initPopupEventListeners();
        this.loadImageForEditing();

        this.updatePopupState({
            ceLeft: pu.ceI.style.left,
            ceTop: pu.ceI.style.top,
        });
        sci.classList.remove("no-transition");
        
        this.openPopupAnimation();
    }

    // Initializes the image editing popup (Sets zoom slider range)
    async loadImageForEditing() {
        const pu = this.pu;
        const ceF = pu.ceF;
        const ceB = pu.ceB;
        const ceI = pu.ceI;
        const zmSlider = pu.zmSlider;
        const { ceScale } = pu;
        
        if (!ceF || !ceB || !ceI) throw new Error('Required editing elements not found in popup state');  
        
        ceF.removeEventListener('mousedown', this.boundHandlers.onStartMouse);
        ceF.removeEventListener('touchstart', this.boundHandlers.onStartTouch);
        ceF.removeEventListener('wheel', this.boundHandlers.onWheel);
        if (zmSlider) zmSlider.removeEventListener('wheel', this.boundHandlers.onWheel);

        ceF.addEventListener('mousedown', this.boundHandlers.onStartMouse);
        ceF.addEventListener('wheel', this.boundHandlers.onWheel);
        if (this.dType === "M") ceF.addEventListener('touchstart', this.boundHandlers.onStartTouch, { passive: true });
        if (zmSlider) zmSlider.addEventListener('wheel', this.boundHandlers.onWheel);

        let minScaleX, minScaleY;
        const nextFrame = () => new Promise(res => requestAnimationFrame(res));

        // usage
        await nextFrame();
        await nextFrame();
        const rotatedSize = this.getRotatedSize(pu.ceNW, pu.ceNH, pu.rotation || 0);
        minScaleX = (ceB.clientWidth * 1.02) / rotatedSize.width;
        minScaleY = (ceB.clientHeight * 1.02) / rotatedSize.height;

        const ceMiS = Math.max(minScaleX, minScaleY);

        const firstMedium = variantsWithMetafields.find(v => v.title.startsWith("Medium /"));
        const { width, height } = firstMedium.collage_windows[0];
        const printingAreaW = width.value;
        const printingAreaH = height.value;
        const paperDiagonalInches = Math.sqrt(printingAreaW ** 2 + printingAreaH ** 2);
        const imageDiagonal = Math.sqrt(((parseFloat(window.getComputedStyle(ceB).width)) * (1 / ceMiS)) ** 2 + ((parseFloat(window.getComputedStyle(ceB).height)) * (1 / ceMiS)) ** 2);
        const currentPPI = imageDiagonal / paperDiagonalInches;
        
        if (currentPPI <= 100) {
            console.log("currentPPI <= 100", currentPPI);
            const maxZoomOutScale = ceMiS * 1.33;
            this.setSliderRange(ceMiS * 10000, maxZoomOutScale * 10000, ceScale * 10000);
        } else {
            console.log("currentPPI > 100", currentPPI);
            const maxZoomOutScale = ceMiS * ((currentPPI * 0.98) / 100);
            const maxZoomOutScaleBU = ceMiS * 1.33;
            const ceMaS = Math.max(ceMiS, maxZoomOutScale, maxZoomOutScaleBU);
            this.setSliderRange(ceMiS * 10000, ceMaS * 10000, ceScale * 10000);
        }

        return {
            frame: ceF,
            box: ceB,
            img: ceI,
            slider: zmSlider,
            currentPPI: currentPPI,
            minScale: ceMiS,
            currentScale: pu.ceScale
        };
    }

    // Updates the zoom slider range and visual background.
    setSliderRange(min, max, val) {
        const zmSlider = this.S$G('SCRzoomSlider');
        val = Math.max(min, Math.min(val, max));
        zmSlider.min = min;
        zmSlider.max = max;
        zmSlider.value = val;
        const percent = Math.floor(((val - min) / (max - min)) * 100);
        zmSlider.style.background = `linear-gradient(to right, #4A2014 0%, #4A2014 ${percent}%, #ddd ${percent}%, #ddd 100%)`;
    }

    // Handles manual slider changes
    zoomSliderChange(value) {
        const zmSlider = this.S$G('SCRzoomSlider');
        if (!zmSlider) return;

        const min = parseFloat(zmSlider.min);
        const max = parseFloat(zmSlider.max);
        const val = Math.max(min, Math.min(parseFloat(value), max));
        const percent = Math.floor(((val - min) / (max - min)) * 100);

        zmSlider.style.background = `linear-gradient(to right, #4A2014 0%, #4A2014 ${percent}%, #ddd ${percent}%, #ddd 100%)`;

        // (heavy logic)
        this.debouncedZoomProcess(value, percent);
    }

    // debouncedZoomProcess = this.debounce(this.zoomProcess.bind(this), 50);
    debouncedZoomProcess = this.throttleWithRaf(this.zoomProcess.bind(this));

    // Applies zoom to the image in the popup based on slider value or pinch gestures
    zoomProcess(value, percent) {
        const pu = this.pu;
        const ceB = pu.ceB;
        const ceI = pu.ceI;
        const EFC = document.querySelector('.cl_epu');
        const EFrame = document.querySelector('.cl_epu-body .frame');

        if (!ceI || !ceB) {
            console.warn('Required editing elements not found for zoom slider');
            return;
        }

        if (ceB) {
          const rect = ceB.getBoundingClientRect();
          const fRect = EFrame.getBoundingClientRect();
          const root = document.documentElement;
          root.style.setProperty('--b-left', `${rect.left}px`);
          root.style.setProperty('--b-top', `${rect.top}px`);
          root.style.setProperty('--p-hinches', `${pu.ceHeight}px`);
          root.style.setProperty('--p-winches', `${pu.ceWidth}px`);
          root.style.setProperty('--b-width', `${rect.width}px`);
          root.style.setProperty('--b-height', `${rect.height}px`);
          root.style.setProperty('--f-width', `${fRect.width}px`);
          root.style.setProperty('--f-height', `${fRect.height}px`);
          const zmrect = this.pu.zmSlider.getBoundingClientRect();
          root.style.setProperty('--zm-left', `${zmrect.left}px`);
          root.style.setProperty('--zm-top', `${zmrect.top}px`);
          root.style.setProperty('--zm-width', `${zmrect.width}px`);
          root.style.setProperty('--zm-height', `${zmrect.height}px`);
          this.updateThumbMask(this.pu.zmSlider);
        }

        EFrame.classList.add("no-transition");

        let ceSc = value / 10000;
        const posrotation = pu.posrotation || "h";

        let minScaleX, minScaleY;
        if (posrotation == "v") {
            minScaleX = ceB.clientWidth * 1.02 / pu.ceNH;
            minScaleY = ceB.clientHeight * 1.02 / pu.ceNW;
        } else {
            minScaleX = ceB.clientWidth * 1.02 / pu.ceNW;
            minScaleY = ceB.clientHeight * 1.02 / pu.ceNH;
        }

        const minScale = Math.max(minScaleX, minScaleY);
        const scaleType = percent < 1 ? "min" : "more";
        ceI.dataset.scale = scaleType;

        const { scale, rotate } = this.getScaleAndRotation(ceI);
        const oldScale = scale || 1;

        ceSc = Math.max(ceSc, minScale);
        let newScale = parseFloat(ceSc);

        const boxRect = ceB.getBoundingClientRect();
        const boxCX = boxRect.left + boxRect.width / 2;
        const boxCY = boxRect.top + boxRect.height / 2;

        const imgRect = ceI.getBoundingClientRect();
        const imgCX = imgRect.left + imgRect.width / 2;
        const imgCY = imgRect.top + imgRect.height / 2;

        // Distance from image center to visible center
        const dx = boxCX - imgCX;
        const dy = boxCY - imgCY;

        ceI.style.transform = `rotate(${pu.rotation || 0}deg) scale(${newScale})`;
        const scaleFactor = newScale / oldScale;
        const newLeft = parseFloat(ceI.style.left || 0) - dx * (scaleFactor - 1);
        const newTop = parseFloat(ceI.style.top || 0) - dy * (scaleFactor - 1);
        

        ceI.style.left = `${newLeft}px`;
        ceI.style.top = `${newTop}px`;
    
        this.adjustPosition(ceI, ceB);
        
        if (EFrame._removeEditingImgTimeout) {
          clearTimeout(EFrame._removeEditingImgTimeout);
        }

        EFrame._removeEditingImgTimeout = setTimeout(() => {
          EFC.classList.remove('editing-img-container');
          EFrame.classList.remove('editing-img');
          EFrame.classList.remove("no-transition");
          EFrame._removeEditingImgTimeout = null;
        }, 500);

        this.updatePopupState({
            SoPchanged: true,
            ceScale: ceSc,
            ceLeft: newLeft,
            ceTop: newTop
        });
    }

    // Ensures image stays within frame boundaries after zoom or drag
    adjustPosition(ceI, ceB) {
        const imgRect = ceI.getBoundingClientRect();
        const frameRect = ceB.getBoundingClientRect();
        const safeWMargin = ceB.clientWidth * 0.01;
        const safeHMargin = ceB.clientHeight * 0.01;

        let parsedLeft = parseFloat(ceI.style.left);
        let parsedTop = parseFloat(ceI.style.top);

        let newLeft = Number.isNaN(parsedLeft) ? ceI.offsetLeft : parsedLeft;
        let newTop = Number.isNaN(parsedTop) ? ceI.offsetTop : parsedTop;

        if (imgRect.left > (frameRect.left - safeWMargin)) {
            newLeft = (frameRect.left - imgRect.left - safeWMargin) + ceI.offsetLeft;
        }
        if (imgRect.top > (frameRect.top - safeHMargin)) {
            newTop = (frameRect.top - imgRect.top - safeHMargin) + ceI.offsetTop;
        }
        if (imgRect.right < (frameRect.right + safeWMargin)) {
            newLeft = frameRect.right - imgRect.right + safeWMargin + ceI.offsetLeft;
        }
        if (imgRect.bottom < (frameRect.bottom + safeHMargin)) {
            newTop = frameRect.bottom - imgRect.bottom + safeHMargin + ceI.offsetTop;
        }

        ceI.style.left = `${newLeft}px`;
        ceI.style.top = `${newTop}px`;

        this.updatePopupState({
            ceLeft: newLeft,
            ceTop: newTop
        });
    }

    // Global click handler for popup actions using data-action attributes
    _handleDocumentClick(e) {
        const actionElement = e.target.hasAttribute('data-action') ?
            e.target :
            e.target.closest('[data-action]');
        if (!actionElement) return;

        const action = actionElement.getAttribute('data-action');
        if (action === 'popup-menu') {
            this.handlePopupMenuClick(e, actionElement);
        } else if (action === 'popup-selection') {
            this.handlePopupSelectionClick(e, actionElement);
        } else if (action === 'popup-selection-done') {
            this.handlePopupSelectionDone();
        } else if (action === 'popup-done') {
            this.endSEdit();
        } else if (action === 'popup-cancel') {
            this.handlePopupCancel();
        } else if (action === "edit") {
            const value = actionElement.getAttribute('data-value');
            if (value == "rotate-right") {
                //    this.rotateImage(-90)
            } else if (value == "rotate-left") {
                // this.rotateImage(90)
            } else if (value == "black-white") {

            }
        }
    }

    // Handles actions from the popup menu (delete, crop, size, etc.)
    handlePopupMenuClick(e, actionElement) {
        const target = e.target.closest('[data-value]');
        const value = target.getAttribute('data-value');

        if (value === "delete") {
            const epopup = this.S$Q('.cl_epu');
            const eframe = this.S$Q('.cl_epu-body .frame');
            const cartItem = this.pu.cuF.closest?.("[data-cart-item]");
            cartItem.querySelector("a.cart-remove-link").click();
            setTimeout(() => {
                this.S$Q('.cl_epu-fcurrent')?.classList.remove('cl_epu-fcurrent');
                this.S$Q('.cl_epu-fmain')?.classList.add('cl_epu-fcurrent');
                // this.S$Q('.cl_epu').style.display = "none";
                // this.S$Q('.cl_epu-body .frame')?.remove();
                this.closePopupAnimation();
            }, 300);
        } else {
            const p = ".cl_epu-f" + value;
            if (value === "size") {
                this.renderSizeOptions(".cl_epu-fsize");
            }
            if (p == ".cl_epu-fcrop") this.loadImageForEditing();

            const current = actionElement.closest('.cl_epu-fcurrent');
            if (current) current.classList.remove('cl_epu-fcurrent');

            this.S$Q('.cl_epu-footer').dataset.active = p;
            actionElement.closest('.cl_epu')?.querySelector(p)?.classList.add('cl_epu-fcurrent');
            this.setupDefaultValue(value, p, actionElement);
        }
    }

    // Handles selection clicks inside a popup 
    handlePopupSelectionClick(e, actionElement) {
        const target = e.target.closest('[data-value]');
        const container = e.target.closest('[data-category]');
        if (!target || !container) return;

        const category = container.getAttribute('data-category');
        const value = target.getAttribute('data-value');
        // this.updateSelectedValuePopup(container, target, category, value);
    }

    // Handles the "Done" action for popup selections
    handlePopupSelectionDone() {
        this.S$Q('.cl_epu-fcurrent')?.classList.remove('cl_epu-fcurrent');
        this.S$Q('.cl_epu-fmain')?.classList.add('cl_epu-fcurrent');
        this.S$Q('.cl_epu-footer').dataset.active = "cl_epu-fmain";
        this.loadImageForEditing();
    }

    // Handles cancel action for popup
    handlePopupCancel() {
        this.S$Q('.cl_epu-fcurrent')?.classList.remove('cl_epu-fcurrent');
        this.S$Q('.cl_epu-fmain')?.classList.add('cl_epu-fcurrent');
        this.S$Q('.cl_epu-footer').dataset.active = "cl_epu-fmain";

        // this.S$Q('.cl_epu').style.display = "none";
        // this.S$Q('.cl_epu-body .frame')?.remove();
        this.removePopupListeners();
        this.closePopupAnimation();
    }

    frameClickHandler = (e) => {
        if (this.addToCartInProcess) {
            console.warn("add to cart is in process");
            return;
        }
        if (e.target == null || e.target.closest(".cl_eb, .cl_cb, .cl_rb, .cl_lr, .img-upload.hidden")) { e.stopPropagation(); return; };
        if (!e.target.classList.contains("frame") && !e.target.closest(".frame")) return; 
        
        this.editpu(e); 
        // const popupToOpen = document.querySelector('.cl_eupu'); 
        // if(popupToOpen){ 
        // 
        // this.uploadIndex = containerDiv.parentElement.dataset.index; 
        // 
        // popupToOpen?.classList.add(cl_eupu-open); 
        // 
        // }
    };

    // Initializes all event handlers (mouse, touch, zoom, rotation, filters) for the popup editor
    initHandlers() {
        if (this.handlersInitialized) return;
        this.boundHandlers.onStartMouse = (e) => this.onStart(e),
        this.boundHandlers.onStartTouch = (e) => this.onStart(e),
        this.boundHandlers.onWheel = (e) => {
            e.preventDefault();
            if (e.deltaY < 0) {
                this.boundHandlers.zoomButton(e, this.pu.zmSlider, this.S$Q(".cl_epu .cl_epu-zoom-plus"), true)
            } else {
                this.boundHandlers.zoomButton(e, this.pu.zmSlider, this.S$Q(".cl_epu .cl_epu-zoom-minus"), true)
            } 
        },

        this.boundHandlers.move = this.onMove.bind(this);
        this.boundHandlers.end = this.onEnd.bind(this);
        this.boundHandlers.touchStart = this.handlePinchStart.bind(this);
        this.boundHandlers.touchMove = this.onMove.bind(this);
        this.boundHandlers.touchEnd = this.onEnd.bind(this);
        this.boundHandlers.zoomButton = this.onZoomButtonClick.bind(this);
        this.boundHandlers.zoomInput = this.onZoomInput.bind(this);
        this.boundHandlers.rotateLeft = (e) => {
            e.stopPropagation();
            this.rotateImage(-90);
        };

        this.boundHandlers.rotateRight = (e) => {
            e.stopPropagation();
            this.rotateImage(90);
        };

        this.boundHandlers.blackWhite = (e) => {
            e.stopPropagation();
            this.applyBlackWhite();
        };

        this.handlersInitialized = true;
    }

    // Handles start of drag (mouse or touch) for moving image inside the popup
    onStart(event) {
        if(this.dType == "D") event.preventDefault();
        if (!this.handlersInitialized) {
            this.initHandlers();
        }

        const EFimg = document.querySelector('.cl_epu-body img');
        const EFbox = document.querySelector('.cl_epu-body .img-box');
        const EFC = document.querySelector('.cl_epu');
        const EFrame = document.querySelector('.cl_epu-body .frame');
        const zmSlider = this.S$G('SCRzoomSlider');

        if (!EFimg || !EFbox || !EFrame) {
            console.warn('Required editing elements not found for drag start');
            return;
        }
        
        // Only clear the timeout if zoomSliderChange is running, otherwise don't remove editing-img class here
        if (EFrame._removeEditingImgTimeout) {
          clearTimeout(EFrame._removeEditingImgTimeout);
          EFrame._removeEditingImgTimeout = null;
        } 
        EFC.classList.add('editing-img-container');
        EFrame.classList.add('editing-img');

        // Use popup state if available, fallback to DOM queries
        const pu = this.pu;

        if (EFbox) {
          const rect = EFbox.getBoundingClientRect();
          const fRect = EFrame.getBoundingClientRect();
          const root = document.documentElement;
          root.style.setProperty('--b-left', `${rect.left}px`);
          root.style.setProperty('--b-top', `${rect.top}px`);
          root.style.setProperty('--p-hinches', `${pu.ceHeight}px`);
          root.style.setProperty('--p-winches', `${pu.ceWidth}px`);
          root.style.setProperty('--b-width', `${rect.width}px`);
          root.style.setProperty('--b-height', `${rect.height}px`);
          root.style.setProperty('--f-width', `${fRect.width}px`);
          root.style.setProperty('--f-height', `${fRect.height}px`);
          const zmrect = this.pu.zmSlider.getBoundingClientRect();
          root.style.setProperty('--zm-left', `${zmrect.left}px`);
          root.style.setProperty('--zm-top', `${zmrect.top}px`);
          root.style.setProperty('--zm-width', `${zmrect.width}px`);
          root.style.setProperty('--zm-height', `${zmrect.height}px`);
          this.updateThumbMask(this.pu.zmSlider);
        }

        const clientX = event?.clientX || event?.touches[0]?.clientX;
        const clientY = event?.clientY || event?.touches[0]?.clientY;

        this.dragState = {
            startX: clientX,
            startY: clientY,
            initialX: EFimg.offsetLeft,
            initialY: EFimg.offsetTop,
            isDragging: true
        };

        EFimg.style.cursor = 'grabbing';

        // document.addEventListener('mousemove', this.boundHandlers.move);
        // document.addEventListener('mouseup', this.boundHandlers.end);
        // document.addEventListener('mouseleave', this.boundHandlers.end);
        // document.addEventListener('touchstart', this.boundHandlers.touchStart);
        // document.addEventListener('touchmove', this.boundHandlers.touchMove);
        // document.addEventListener('touchend', this.boundHandlers.touchEnd);
        // document.addEventListener('touchcancel', this.boundHandlers.touchEnd);
        // onStart
        document.addEventListener('mousemove', this.boundHandlers.move);
        document.addEventListener('mouseup', this.boundHandlers.end);
        document.addEventListener('mouseleave', this.boundHandlers.end);

        // Touch events → explicitly mark them
        document.addEventListener('touchstart', this.boundHandlers.touchStart, { passive: true });
        document.addEventListener('touchmove', this.boundHandlers.touchMove, { passive: true });
        document.addEventListener('touchend', this.boundHandlers.touchEnd, { passive: true });
        document.addEventListener('touchcancel', this.boundHandlers.touchEnd, { passive: true });

    }

    // Handles end of drag (mouse or touch)
    onEnd() {
        this.dragState = { isDragging: false };
        const EFimg = document.querySelector('.cl_epu-body img');
        const EFC = document.querySelector('.cl_epu');
        const EFrame = document.querySelector('.cl_epu-body .frame');
        if(EFC) EFC.classList.remove('editing-img-container');
        if (EFrame) {
            EFrame.classList.remove('editing-img');
            EFrame.classList.remove('no-transition');
        }
        if (EFimg) EFimg.style.cursor = 'grab';

        // document.removeEventListener('mousemove', this.boundHandlers.move);
        // document.removeEventListener('mouseup', this.boundHandlers.end);
        // document.removeEventListener('mouseleave', this.boundHandlers.end);
        // document.removeEventListener('touchstart', this.boundHandlers.touchStart);
        // document.removeEventListener('touchmove', this.boundHandlers.touchMove);
        // document.removeEventListener('touchend', this.boundHandlers.touchEnd);
        // document.removeEventListener('touchcancel', this.boundHandlers.touchEnd);
        document.removeEventListener('mousemove', this.boundHandlers.move);
        document.removeEventListener('mouseup', this.boundHandlers.end);
        document.removeEventListener('mouseleave', this.boundHandlers.end);

        document.removeEventListener('touchstart', this.boundHandlers.touchStart, { passive: false });
        document.removeEventListener('touchmove', this.boundHandlers.touchMove, { passive: false });
        document.removeEventListener('touchend', this.boundHandlers.touchEnd, { passive: false });
        document.removeEventListener('touchcancel', this.boundHandlers.touchEnd, { passive: false });
    }

    // Handles movement of image during drag or pinch zoom
    onMove(event) {
        if (this.dType == "D")  event.preventDefault();
        event.stopPropagation();
        const pu = this.pu;
        const ceI = pu.isOpen ? pu.ceI : document.querySelector('.cl_epu-body img');
        const ceB = pu.isOpen ? pu.ceB : document.querySelector('.cl_epu-body .img-box');
        const zmSlider = this.S$G('SCRzoomSlider');

        if (!ceI || !ceB) return;

        if (event.touches && event.touches.length === 2) {
            this.handlePinchZoom(event, zmSlider);
        } else if (this.dragState?.isDragging) {
            // this.handleDragMovement(event, ceI, ceB);
            // this.debouncedHandleDragMovement(event, ceI, ceB);
            this.throttledHandleDragMovement(event, ceI, ceB);
        }
    }

    // debouncedHandleDragMovement = this.debounce(this.handleDragMovement.bind(this), 10);
    throttledHandleDragMovement = this.throttleWithRaf(this.handleDragMovement.bind(this));

    // Handles pinch-to-zoom gestures on touch devices
    handlePinchZoom(event, zmSlider) {
        if (event.touches.length !== 2) return;
        
        if(this.dType == "D") event.preventDefault();
        event.stopPropagation();
        const newDistance = this.getTouchDistance(event.touches);

        if (window.initialDistance) {
            const scaleChange = newDistance / window.initialDistance;
            if (typeof window.pinchScale !== 'undefined') window.pinchScale *= scaleChange;
            window.initialDistance = newDistance;

            if (zmSlider) {
                const sliderMin = parseFloat(zmSlider.min);
                const sliderMax = parseFloat(zmSlider.max);
                let newSliderValue = (window.pinchScale - 1) * (sliderMax - sliderMin) + sliderMin;
                newSliderValue = Math.max(sliderMin, Math.min(sliderMax, newSliderValue));

                zmSlider.value = newSliderValue;
                zmSlider.dispatchEvent(new Event('input'));
                this.updatePopupState({ SoPchanged: true });
            }
        }
    }

    // Moves the image based on mouse/touch drag
    handleDragMovement(event, ceI, ceB) {
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        const dx = clientX - this.dragState.startX;
        const dy = clientY - this.dragState.startY;
        let newLeft = this.dragState.initialX + dx;
        let newTop = this.dragState.initialY + dy;

        ceI.style.left = `${newLeft}px`;
        ceI.style.top = `${newTop}px`;

        this.updatePopupState({
            SoPchanged: true,
            ceLeft: newLeft,
            ceTop: newTop
        });

        const imgRect = ceI.getBoundingClientRect();
        const frameRect = ceB.getBoundingClientRect();

        let offsetX = 0;
        let offsetY = 0;

        const addedWPercent = frameRect.width * 0.01;
        const addedHPercent = frameRect.height * 0.01;

        if (imgRect.left > (frameRect.left - addedWPercent)) {
            offsetX = frameRect.left - (imgRect.left + addedWPercent);
        } else if (imgRect.right < (frameRect.right + addedWPercent)) {
            offsetX = frameRect.right - (imgRect.right - addedWPercent);
        }

        if (imgRect.top > (frameRect.top - addedHPercent)) {
            offsetY = frameRect.top - (imgRect.top + addedHPercent);
        } else if (imgRect.bottom < (frameRect.bottom + addedHPercent)) {
            offsetY = frameRect.bottom - (imgRect.bottom - addedHPercent);
        }

        if (offsetX !== 0 || offsetY !== 0) {
            newLeft += offsetX;
            newTop += offsetY;
            ceI.style.left = `${newLeft}px`;
            ceI.style.top = `${newTop}px`;

            this.updatePopupState({
                ceLeft: newLeft,
                ceTop: newTop
            });
        }
    }

    // Handles the start of a pinch gesture on touch devices
    handlePinchStart(event) {
        if (event.touches.length === 2) {
            if(this.dType == "D") event.preventDefault();
            event.stopPropagation();
            window.initialDistance = this.getTouchDistance(event.touches);
            if (typeof window.pinchScale === 'undefined') window.pinchScale = 1;
        }
    }

    // Calculates the distance between two touch points
    getTouchDistance(touches) {
        if (touches.length < 2) return 0;
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    // Handles zoom in/out button clicks
    onZoomButtonClick(e, zmSlider, button, editClass = false) {
        e.preventDefault();
        const min = parseFloat(zmSlider.min);
        const max = parseFloat(zmSlider.max);
        const currentValue = parseFloat(zmSlider.value);
        const isZoomIn = button.classList.contains("cl_epu-zoom-plus");

        const step = (max - min) * 0.05;
        let newValue = isZoomIn ? currentValue + step : currentValue - step;

        if (newValue <= min + 0.1) {
            newValue = min;
        } else if (newValue >= max - 0.1) {
            newValue = max;
        }

        newValue = parseFloat(Math.max(min, Math.min(newValue, max)).toFixed(2));
        if (Math.abs(newValue - currentValue) < 0.01) return;

        zmSlider.value = newValue;

        if(editClass){
            const EFC = document.querySelector('.cl_epu');
            const EFrame = document.querySelector('.cl_epu-body .frame');
            EFC.classList.add('editing-img-container');
            EFrame.classList.add('editing-img');
        }
        this.zoomSliderChange(newValue);
    }

    // Handles direct input changes on the zoom slider
    onZoomInput(e) {
        if(this.dType == "D") e.preventDefault();
        const value = parseFloat(this.pu.zmSlider.value);
        const EFC = document.querySelector('.cl_epu');
        const EFrame = document.querySelector('.cl_epu-body .frame');
        EFC.classList.add('editing-img-container');
        EFrame.classList.add('editing-img');
        this.zoomSliderChange(value);
    }

    // Utility Methods
    showToast(message) {
        const toast = document.createElement('div');
        toast.className = 'toast';
        toast.textContent = message;
        document.body.appendChild(toast);

        setTimeout(() => {
            toast.style.opacity = '0';
            setTimeout(() => {
                document.body.removeChild(toast);
            }, 300);
        }, 3000);
    }

    // Ends the editing session and applies any pending changes
    endSEdit() {
        console.log("🔚 Ending single frame edit");
        try {
            S$$(".frame").forEach(f => f.classList.add("no-transition-end"));
            const pu = this.pu;
            const epopup = this.S$Q(".cl_epu");
            if (!pu.ceI.style.left) {
                pu.ceI.style.left = pu.ceI.offsetLeft + "px";
            }
            if (!pu.ceI.style.top) {
                pu.ceI.style.top = pu.ceI.offsetTop + "px";
            }

            epopup.querySelector(".cl_epu-box").style.overflow = "visible";
            this.createCloneForAnimation();

            pu.ceLeft = parseFloat(pu.ceI.style.left || pu.ceI.offsetLeft);
            pu.ceTop = parseFloat(pu.ceI.style.top || pu.ceI.offsetTop);
            const { scale, rotate } = this.getScaleAndRotation(pu.ceI);
            pu.ceScale = parseFloat(scale);

            this.S$Q(".cl_epu-body .frame .img-box")?.classList.add('cimg-loading');

            document.querySelector(".cl_epu .cl_epu-zoom-container")?.style.setProperty("pointer-events", "none");
            // Check if scale or position was changed using popup state
            if (pu.SoPchanged === true || pu.SoRchanged === true || pu.SoCchanged === true) {
                this.AESnP();
                this.updatePopupState({ SoPchanged: false });
            }

            this.S$Q(".cl_epu-body .frame .img-box")?.classList.remove('cimg-loading');
            // this.S$Q(".cl_epu").style.display = "none";
            // this.S$Q(".cl_epu-body").innerHTML = "";

            const frameId = pu.cuF.dataset.frameId;
            this.updateCollageState({
                "cssStyles.width": parseFloat(pu.cuF.style.width),
                "cssStyles.height": parseFloat(pu.cuF.style.height),
            }, null, frameId)

            document.querySelector(".cl_epu .cl_epu-zoom-container")?.style.setProperty("pointer-events", "all");
            this.removePopupListeners();

            S$$(".frame").forEach(f => f.classList.remove("no-transition-end"));
            this.closePopupAnimation();

        } catch (error) {
            console.error("❌ Error in endSEdit:", error);
            this.S$Q(".cl_epu-body .frame .img-box")?.classList.remove('cimg-loading');
            document.querySelector(".cl_epu .cl_epu-zoom-container")?.style.setProperty("pointer-events", "all");
            this.removePopupListeners();
            return false;
        }
    }

    // Apply edits made in the popup to the main preview
    AESnP() {
        console.log("🔄 Frames: Applying edit settings to main preview");

        try {
            // Get popup state
            const pu = this.pu;
            if (!pu.isOpen || !pu.ceF || !pu.cuF) {
                console.warn("⚠️ Popup state not available, using fallback");
                return this.AESnPFallback();
            }

            // Handle border changes
            if (pu.ceF?.dataset.frameBorder != pu.cuF?.dataset.frameBorder) {
                pu.cuF.dataset.frameBorder = pu.ceF.dataset.frameBorder;
                let { widthInInches: fw, heightInInches: fh } = pu.cuF.dataset;
                fw = parseFloat(fw);
                fh = parseFloat(fh);

                const iw = parseFloat(getComputedStyle(pu.cuF).width),
                    ra = iw / fw,
                    ss = Math.min(fw, fh),
                    bs =
                        pu.ceF.dataset.frameBorder == "No Mat"
                            ? ss * 0
                            : pu.ceF.dataset.frameBorder == "Standard"
                                ? ss * 0.1
                                : ss * 0.2,
                    ab = bs * ra;

                pu.cuF.style.padding = ab + "px";

                // Update cssStyles when padding changes
                const frameId = pu.cuF.dataset.frameId;
                // if (frameId) {
                //     this.updateFrameCssStyles(frameId, {
                //         padding: ab + "px"
                //     });
                // }
            }

            // Use popup state values
            var mw = parseFloat(window.getComputedStyle(pu.cuB).width);
            var pw = parseFloat(window.getComputedStyle(pu.ceB).width);
            var ms = pu.ceScale * (mw / pw);
            pu.cuI.style.transform = `rotate(${pu.rotation}deg) scale(${ms})`;
            pu.cuI.style.filter = pu.ceI.style.filter;
            pu.cuI.dataset.scale = pu.ceI.dataset.scale;

            var newLeft = parseFloat(pu.ceI.style.left);
            var newTop = parseFloat(pu.ceI.style.top);
            var currentMainScale = ms;
            var currentPopupScale = pu.ceScale;
            var msd = 1 - currentMainScale;
            var mnwXsd = (pu.ceNW * msd) / 2;
            var mnhXsd = (pu.ceNH * msd) / 2;
            var psd = 1 - currentPopupScale;
            var pnwXsd = (pu.ceNW * psd) / 2;
            var pnhXsd = (pu.ceNH * psd) / 2;
            var pwdis = pnwXsd + newLeft;
            var phdis = pnhXsd + newTop;
            var mwdis = (pwdis / currentPopupScale) * currentMainScale;
            var mhdis = (phdis / currentPopupScale) * currentMainScale;
            var bigLeft = -mnwXsd + mwdis;
            var bigTop = -mnhXsd + mhdis;

            pu.cuI.style.left = `${bigLeft}px`;
            pu.cuI.style.top = `${bigTop}px`;

            // Update popup state with new main image position
            this.updatePopupState({
                cuLeft: bigLeft,
                cuTop: bigTop,
            });

            const frameId = pu.ceF.dataset.frameId;

            this.updateCollageState({
                "image.imgStyles.filter": pu.ceI.style.filter,
                "image.imgStyles.scale": ms,
                "image.imgStyles.rotation": pu.rotation,
                "image.imgStyles.left": bigLeft,
                "image.imgStyles.top": bigTop,
                "image.scale": pu.ceI.dataset.scale,
            }, null, frameId);

            console.log(`📐 Scale: ${currentPopupScale} → ${currentMainScale}`);
            console.log(`🎯 Position: (${newLeft}, ${newTop}) → (${bigLeft}, ${bigTop})`);
            return {
                currentPopupScale,
                currentMainScale,
                currentpopupLeft: newLeft,
                currentpopupTop: newTop,
                currentMainLeft: bigLeft,
                currentMainTop: bigTop,
            }
        } catch (error) {
            console.error("❌ Error in Pg.Frames.AESnP:", error);
            this.AESnPFallback();
        }
    }

    // Fallback method for when popup state is not available
    AESnPFallback() {
        try {
            // Fallback: just apply basic scale using global variables
            const mw = parseFloat(window.getComputedStyle(window.cuB).width);
            const pw = parseFloat(window.getComputedStyle(window.ceB).width);
            const ms = this.pu.ceScale * (mw / pw);
            window.cuI.style.transform = `scale(${ms})`;
        } catch (error) {
            console.error("❌ Error in fallback AESnP:", error);
        }
    }

    // Placeholder method to set default value for popup selections
    setupDefaultValue(value, p, actionElement) {
    }

    // updateSelectedValuePopup(container, target, category, value) {
    // }

    /**
     * Generates a high-resolution SVG that matches the on-screen appearance
     */
    async renderItemFromData({
        frame,
        parsedMainFrame,
        widthPx,
        heightPx,
        scaleCorrection,
        applyImgBoxTransform = true,
        Ra4Sc,
        oldWdiFC,
        oldHdiFC,
        action = "PageLoad"
    }) {

        const {
            borderWidth,
            padding,
            scale,
            left,
            top,
            rotate = 0,
            dataScale, 
            bW,
        } = parsedMainFrame;

        frame.style.width = `${widthPx}px`;
        frame.style.height = `${heightPx}px`;
        frame.style.padding = `${padding * scaleCorrection}px`;
        frame.style.borderWidth = `${borderWidth * scaleCorrection}px`;

        const img = frame.querySelector(".img-box img");
        if (applyImgBoxTransform) {
            // img.style.transform = `scale(${scale * scaleCorrection}) rotate(${rotate}deg)`;
        }
        const pu = {}
        //   const pu = Pg.Popup.current;
        pu.ceNW = img.naturalWidth;
        pu.ceNH = img.naturalHeight;

        const mainScaleDifference = 1 - scale;
        const mainNaturalWidthXScaleDifference = (pu.ceNW * mainScaleDifference) / 2;
        const mainNaturalHeightXScaleDifference = (pu.ceNH * mainScaleDifference) / 2;

        const newScale = scale * scaleCorrection;
        const popupScaleDifference = 1 - newScale;
        const popupNaturalWidthXScaleDifference = (pu.ceNW * popupScaleDifference) / 2;
        const popupNaturalHeightXScaleDifference = (pu.ceNH * popupScaleDifference) / 2;

        const popupwdis = mainNaturalWidthXScaleDifference + parseFloat(left);
        const popuphdis = mainNaturalHeightXScaleDifference + parseFloat(top);

        const mainwdis = (popupwdis / scale) * newScale;
        const mainhdis = (popuphdis / scale) * newScale;

        const bigLeft = -popupNaturalWidthXScaleDifference + mainwdis;
        const bigTop = -popupNaturalHeightXScaleDifference + mainhdis;

        // img.style.left = `${bigLeft}px`;
        // img.style.top = `${bigTop}px`;
        img.style.filter = bW;
        const frameId = frame.dataset.frameId;
        this.updateCollageState({
            "cssStyles.width": parseFloat(widthPx),
            "cssStyles.height": parseFloat(heightPx),
        }, null, frameId)

        await this.sizeAdjustPosition({frame: frame, Ra4Sc: 1, action: action, oldWdiFC, oldHdiFC , newLeft: bigLeft, newTop: bigTop, newScale: newScale, rotate});

        return true;
    }

    renderFrameFromData({
        frame,
        parsedMainFrame,
        widthPx,
        heightPx,
        scaleCorrection,
        applyImgBoxTransform = true
    }) {

        const {
            borderWidth,
            padding,
            scale,
            left,
            top,
            rotate = 0,
            dataScale, 
            bW,
        } = parsedMainFrame;

        frame.style.width = `${widthPx}px`;
        frame.style.height = `${heightPx}px`;
        frame.style.padding = `${padding * scaleCorrection}px`;
        frame.style.borderWidth = `${borderWidth * scaleCorrection}px`;

        const img = frame.querySelector(".img-box img");
        if (applyImgBoxTransform) {
            img.style.transform = `scale(${scale * scaleCorrection}) rotate(${rotate}deg)`;
        }
        const pu = {}
        //   const pu = Pg.Popup.current;
        pu.ceNW = img.naturalWidth;
        pu.ceNH = img.naturalHeight;

        const mainScaleDifference = 1 - scale;
        const mainNaturalWidthXScaleDifference = (pu.ceNW * mainScaleDifference) / 2;
        const mainNaturalHeightXScaleDifference = (pu.ceNH * mainScaleDifference) / 2;

        const newScale = scale * scaleCorrection;
        const popupScaleDifference = 1 - newScale;
        const popupNaturalWidthXScaleDifference = (pu.ceNW * popupScaleDifference) / 2;
        const popupNaturalHeightXScaleDifference = (pu.ceNH * popupScaleDifference) / 2;

        const popupwdis = mainNaturalWidthXScaleDifference + parseFloat(left);
        const popuphdis = mainNaturalHeightXScaleDifference + parseFloat(top);

        const mainwdis = (popupwdis / scale) * newScale;
        const mainhdis = (popuphdis / scale) * newScale;

        const bigLeft = -popupNaturalWidthXScaleDifference + mainwdis;
        const bigTop = -popupNaturalHeightXScaleDifference + mainhdis;

        img.style.left = `${bigLeft}px`;
        img.style.top = `${bigTop}px`;
        img.style.filter = bW;
        // this.sizeAdjustPosition(frame, 1, "pageLoad")
    }

    // ================================================================
    // IMAGE PREVIEW & PROCESSING
    // ================================================================
    // Create tracked blob URL
    createBlob(blob, id = null) {
        try {
            if (!blob || typeof blob.size === 'undefined') {
                throw new Error('Invalid blob provided');
            }

            const url = URL.createObjectURL(blob);
            const blobId = id || this._generateBlobId();

            // Track the blob
            const blobInfo = {
                id: blobId,
                blob: blob,
                url: url,
                size: blob.size,
                type: blob.type,
                created: Date.now(),
                accessed: Date.now(),
                accessCount: 0
            };

            this.blobs.set(url, blobInfo);

            // Update metrics
            this.metrics.totalBlobsCreated++;
            this.metrics.totalMemoryUsed += blob.size;
            this.metrics.peakMemoryUsage = Math.max(
                this.metrics.peakMemoryUsage,
                this.metrics.totalMemoryUsed
            );

            // Check memory limits
            // this._checkMemoryLimits();

            console.log(`🔗 Created blob: ${blobId} ${blob.size}`);

            return url;

        } catch (error) {
            console.error('❌ Failed to create blob URL:', error);
            return null;
        }
    }

    // Uploads a single frame's image (original file or preview URL) to Filestack
    async uploadFrameToFilestack(frame) {
        if (!frame.image?.file && !frame.image?.previewURL) {
          throw new Error('No file or preview URL available for upload');
        }

        const client = this.fileStack;
        if (!client) {
          throw new Error('Filestack not available');
        }

        let blob;
        
        if (frame.image.file) {
          // Use original file if available
          blob = frame.image.file;
        } else if (frame.image.previewURL) {
          // Convert preview URL to blob
          const response = await fetch(frame.image.previewURL);
          if (!response.ok) {
            throw new Error(`Failed to fetch preview image: ${response.statusText}`);
          }
          blob = await response.blob();
        } else {
          throw new Error('No usable image source found');
        }

        // Generate filename
        const timestamp = Date.now().toString(36);
        const randomId = this?.makeId?.(8) || Math.random().toString(36).substr(2, 8);
        const filename = `f_f-${new Date().getMonth() + 1}_${new Date().getFullYear()}-${timestamp}${randomId}`;
        
        // Create file with proper name
        const fileToUpload = new File([blob], filename, { type: blob.type });
        
        // Upload to Filestack
        const uploadResult = await client.upload(fileToUpload);
        
        if (!uploadResult || !uploadResult.url) {
          throw new Error('Upload result invalid');
        }

        return uploadResult.url;
    }

    // General-purpose uploader for Blob/File or URL string
    async uploadToFilestack(urlOrBlob) {
        const client = this.fileStack;
        if (!client) {
            throw new Error('Filestack client not available');
        }

        let blob;

        // Case 1: Direct Blob/File
        if (urlOrBlob instanceof Blob || urlOrBlob instanceof File) {
            blob = urlOrBlob;
        }
        // Case 2: URL string
        else if (typeof urlOrBlob === "string") {
            const response = await fetch(urlOrBlob);
            if (!response.ok) {
                throw new Error(`Failed to fetch image from URL: ${response.statusText}`);
            }
            blob = await response.blob();
        }
        else {
            throw new Error("Invalid input. Expected a Blob/File or URL string.");
        }

        // Generate filename
        const timestamp = Date.now().toString(36);
        const randomId = this?.makeId?.(8) || Math.random().toString(36).substr(2, 8);
        const ext = blob.type.split("/")[1] || "bin";
        const filename = `upload-${new Date().getMonth() + 1}_${new Date().getFullYear()}-${timestamp}${randomId}.${ext}`;

        // Create file with proper name
        const fileToUpload = new File([blob], filename, { type: blob.type });

        // Upload to Filestack
        const uploadResult = await client.upload(fileToUpload);

        if (!uploadResult || !uploadResult.url) {
            throw new Error("Upload failed or returned invalid response");
        }

        return uploadResult.url;
    }

    // Simple async delay utility
    delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
    }

    // Stops a running process (e.g., upload sequence)
    stop() {
    this.isRunning = false;
    console.log('🛑 Upload process stop requested');
    }

    // Generate a unique S3 URL for uploading
    generateS3Url() {
        const baseUrl = "https://ffpf.s3.us-west-1.amazonaws.com/tp/";

        const now = new Date();

        const yy = String(now.getFullYear()).slice(2); 
        const mm = String(now.getMonth() + 1).padStart(2, '0'); 
        const dd = String(now.getDate()).padStart(2, '0');
        const hh = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0'); 

        const random = this.generateRandomAlphaNumeric(8); 

        const yymm = `${yy}${mm}`;
        const timestamp = `${dd}_${hh}${min}`;
        const fileName = `${timestamp}_${random}`;

        return `${baseUrl}${yymm}/${fileName}`;
    }

    // Generate a random alphanumeric string of given length
    generateRandomAlphaNumeric(length) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }

    // Calculate crop rectangle and visible area for a frame image
    getCropPoints(frame) {
        const ceB = frame.querySelector('.img-box');
        const ceI = frame.querySelector('.img-box img');
        const borderRect = ceB.getBoundingClientRect();
        const imgRect = ceI.getBoundingClientRect();
        const ceNW = ceI.naturalWidth;
        const ceNH = ceI.naturalHeight;
        const fpd = parseFloat(frame.style.padding);

        let {rotate: rotation} = this.getScaleAndRotation(ceI);
        rotation = Math.round(rotation / 90) * 90 % 360;
        
        // Calculate aspect ratios
        const naturalAspect = ceNW / ceNH;
        const displayedAspect = imgRect.width / imgRect.height;
        
        let scaleX = ceNW / imgRect.width;
        let scaleY = ceNH / imgRect.height;
        
        // For rotated cases, we need to swap the scaling factors
        const isRotated90or270 = Math.abs(rotation) === 90 || Math.abs(rotation) === 270;
        
        if (isRotated90or270) {
            // When rotated 90/270, the displayed width corresponds to natural height
            // and displayed height corresponds to natural width
            scaleX = ceNH / imgRect.width;
            scaleY = ceNW / imgRect.height;
        }

        let x, y, width, height;
        let nx, ny, nwidth, nheight;

        switch (Math.abs(rotation)) {
            case 0:
                x = (borderRect.left - imgRect.left) * scaleX;
                y = (borderRect.top - imgRect.top) * scaleY;
                width = borderRect.width * scaleX;
                height = borderRect.height * scaleY;
                
                nx = Math.max(0, ((borderRect.left - imgRect.left) - (ceB.clientWidth * 0.01)) * scaleX);
                ny = Math.max(0, ((borderRect.top - imgRect.top) - (ceB.clientHeight * 0.01)) * scaleY);
                nwidth = borderRect.width * scaleX * 1.01;
                nheight = borderRect.height * scaleY * 1.01;
                break;
                
            case 90:
                x = (borderRect.left - imgRect.left) * scaleX;
                y = (borderRect.top - imgRect.top) * scaleY;
                width = borderRect.width * scaleX;  
                height = borderRect.height * scaleY;  
                
                nx = Math.max(0, (borderRect.left - imgRect.left - (ceB.clientWidth * 0.01)) * scaleX);
                ny = Math.max(0, (borderRect.top - imgRect.top - (ceB.clientHeight * 0.01)) * scaleY);
                nwidth = borderRect.width * scaleX * 1.01;
                nheight = borderRect.height * scaleY * 1.01;
                break;
                
            case 180:
                x = -(imgRect.left - borderRect.left) * scaleX;
                y = -(imgRect.top - borderRect.top) * scaleY;
                width = borderRect.width * scaleX;
                height = borderRect.height * scaleY;
                
                nx = Math.max(0, (-(imgRect.left - borderRect.left) - (ceB.clientWidth * 0.01)) * scaleX);
                ny = Math.max(0, (-(imgRect.top - borderRect.top) - (ceB.clientHeight * 0.01)) * scaleY);
                nwidth = borderRect.width * scaleX * 1.01;
                nheight = borderRect.height * scaleY * 1.01;
                break;
                
            case 270:
                x = (borderRect.top - imgRect.top) * scaleX;
                y = (imgRect.right - borderRect.right) * scaleY;
                width = borderRect.height * scaleX;  // height becomes width after rotation
                height = borderRect.width * scaleY;  // width becomes height after rotation
                
                nx = Math.max(0, (borderRect.top - imgRect.top - (ceB.clientHeight * 0.01)) * scaleX);
                ny = Math.max(0, (imgRect.right - borderRect.right - (ceB.clientWidth * 0.01)) * scaleY);
                nwidth = borderRect.height * scaleX * 1.01;
                nheight = borderRect.width * scaleY * 1.01;
                break;
        }

        let borderScale;
        if (isRotated90or270) {
            borderScale = Math.sqrt(scaleX * scaleY);
        } else {
            borderScale = scaleX;
        }

        frame.dataset.visableCrop = [Math.round(x), Math.round(y), Math.round(width), Math.round(height)].join(',');
        frame.dataset.borderPx = Math.round(fpd * borderScale);
        frame.dataset.crop = [Math.round(nx), Math.round(ny), Math.round(nwidth), Math.round(nheight)].join(',');
        
        return {
            visibleCrop: [Math.round(x), Math.round(y), Math.round(width), Math.round(height)].join(','),
            borderPx: Math.round(fpd * borderScale),
            crop: [Math.round(nx), Math.round(ny), Math.round(nwidth), Math.round(nheight)].join(',')
        };
    }

    // Add crop parameters to Filestack URL
    addCropToFilestackUrl(url, cor, bpx,rot=0) {
      let bpxr = Math.round(bpx);
      let coordinates = cor.split(",");
      let parts = url.split("/");
      let handle = parts.pop();
      let baseUrl = parts.join("/");
      rot = ((rot % 360) + 360) % 360;
      let border = bpxr > 0 ? `border=width:${bpxr},color:white/` : '';
      let newUrl = `${baseUrl}/rotate=deg:${rot}/crop=d:[${coordinates[0]},${coordinates[1]},${coordinates[2]},${coordinates[3]}]/${border}${handle}`;
      return newUrl;
    }

    getCollagePropertiesById() {
        try {
            const collageEl = document.querySelector(`#collageFrame`);
            if (!collageEl) return {};

            const {id, width,height, size, style } = this.state.Collage;
            // Frames inside this collage
            const frameEls = collageEl.querySelectorAll("[data-frame-id]");

            const frames = Array.from(frameEls).map(frameEl => {
            const frameHeight = parseFloat(getComputedStyle(frameEl).height);
            const frameWidth = parseFloat(getComputedStyle(frameEl).width);
            const padding = parseFloat(getComputedStyle(frameEl).padding);

            const imgEl = frameEl.querySelector(".img-box img");
            let scale = 1, top = 0, left = 0, rotation = 0, dataScale = "min";

            if (imgEl) {
                const {scale: s, rotate } = this.getScaleAndRotation(imgEl);
                rotation = rotate;
                scale = s;
                top = parseFloat(getComputedStyle(imgEl).top) || imgEl.offsetTop || 0;
                left = parseFloat(getComputedStyle(imgEl).left) || imgEl.offsetLeft || 0;
                dataScale = imgEl.dataset.scale || "min";
            }

            return {
                frameId: frameEl.dataset.frameId,
                frameHeight,
                frameWidth,
                padding,
                scale,
                rotation,
                top,
                left,
                dataScale
            };
            });

            return {
                collageId: id,
                collageWidth: width,
                collageHeight: height,
                collageWidthPx: parseFloat(collageEl.style.width),
                collageHeightPx:parseFloat(collageEl.style.height),
                borderWidth:parseFloat(collageEl.style.borderWidth),
                style: style,
                size: size,
                frames
            };
        } catch (err) {
            console.warn("⚠️ Could not extract collageProperties:", err);
            return {};
        }
        }

      /**
     * Build frames summary for cart display
     * @returns {boolean} - Success status
     */
    buildFramesSummary() {
        console.log('📊 Building frames summary');
        
        try {
            // Get all frames and prepare counters
            const collages = document.querySelectorAll('#collageFrame');

            let totalPrice = 0;
            let frameCount = 0;
            // Calculate totals and group by style
            collages.forEach(collage => {
                if (!collage) return;
                
                frameCount++;
                
                
                // Get frame details
                const style = collage.getAttribute('data-frame-style') || 'Unknown';
                const size = collage.getAttribute('data-frame-size') || 'Unknown';
                
                const sortedSize = `${size} / ${style}`;
                this.collageVariantData = this.getVariantData(sortedSize);
            
                const border = collage.getAttribute('data-frame-border') || 'No Mat';
                const collagePrice = parseFloat(this.collageVariantData.price || 0);
                const hasAcrylic = collage.getAttribute('data-frame-acrylic') === 'true';
                const acrylicPrice = hasAcrylic ? 8 : 0; // Hardcoded price for now
                
                // Create frame identifier for grouping
                const frameKey = `${style}-${size}-${border}-${hasAcrylic ? 'acrylic' : 'no-acrylic'}`;
                
                // Add to total price
                totalPrice += collagePrice + acrylicPrice;
            });
            
            if(this.collage.variantID != this.collageVariantData.id)  this.updateCollageState("variantID", this.collageVariantData.id);

            // Check for bulk discounts
            const discountPercent = window.discountP || 0;
            const discountThreshold = window.discountTH || 0;
            let discountAmount = 0;
            
            let discountedPrice = totalPrice;
            if (totalPrice >= discountThreshold && discountPercent > 0) {
                discountedPrice = totalPrice * (1 - (discountPercent / 100));
                discountAmount = totalPrice - discountedPrice;
            }
            
            // Update summary UI
            const subtotalElement = this.S$Q('.cl_st .cl_st__item');
            const elementAndPrice = this.S$Q('.cl_st_p');
            const headerBox = this.S$Q('.cl_vp__heder-box');

            if (subtotalElement) {
                subtotalElement.innerHTML = '';
                const subtotalEl = `
                    <div class="subtotal-box fl_s_bet">
                    <div>
                        <p>SUBTOTAL</p>
                    </div>
                    <div>
                        ${discountAmount > 0 ? `<span class="st_cprice">$${totalPrice.toFixed(0)}</span>` : ''}
                        <span class="st_fprice">$${discountedPrice.toFixed(2)}</span>
                    </div>
                    </div>
                    ${discountAmount > 0 ? `<div class="inc_save">Includes $${discountAmount.toFixed(2)} deal saving</div>` : ''}
                `;
            
                subtotalElement.insertAdjacentHTML('beforeend', subtotalEl);
                
                // if(this.dType === "M") this.S$Q(".cl_st__atc-btn").innerHTML = `$${discountedPrice.toFixed(1)} - Add to Cart`;
            }

            if (elementAndPrice) {
                elementAndPrice.innerHTML = '';

                const name = `${this.collageVariantData.collageConfig.windows.length} ${this.collageVariantData.Size} Frames`;  
                const price = totalPrice;

                const productEl = `
                    <div class="">
                        <p class="cl_st_p name">${name}</p>
                    </div>
                    <div class="">
                        <span class="st_fprice">$${price.toFixed(2)}</span>
                    </div>
                `;

                elementAndPrice.insertAdjacentHTML('beforeend', productEl);
            }
            
            if(headerBox){
                headerBox.innerHTML = '';

                let title = this.collageVariantData.name || '';
                let parts = title.split('–'); 
                if (parts.length === 1) {
                    parts = title.split('-'); 
                }

                const mainTitle = parts[0].trim();  

                const description = (this.collageVariantData.description || '').trim();

                const html = `
                    <div class="cl_vp__heder-box-1">
                    <div class="header-top">
                        <p class="f16 title">${mainTitle}</p>
                    </div>
                    <div class="sub-title">
                        ${description ? `${description}` : ''}
                    </div>
                    </div>
                    <div class="cl_vp__heder-box-2">
                    <div class="price-top-box">
                        <span>$${totalPrice.toFixed(2)}</span>
                    </div>
                    <div class="reviews-container">
                        <div class="5star-box">⭐⭐⭐⭐⭐</div>
                        <div class="reviews-box">546 Reviews</div>
                    </div>
                    </div>
                `;

                headerBox.insertAdjacentHTML('beforeend', html);
            }
            return true;
        } catch (error) {
            console.error('❌ Error building frames summary:', error);
            return false;
        }
    }

    // Handles the "Add To Cart" button click
    // Prepares all frames, generates cropped URLs, uploads if needed, and adds items to the Shopify cart   
    async performAddToCart(e) {
        try {
            e.stopPropagation();
            // Verify all frames have filestack URLs
            const framesWithoutUrls = this.images.filter(image => !image?.filestackUrl);
            if (framesWithoutUrls.length > 0) {
                console.warn(`⚠️ ${framesWithoutUrls.length} frame(s) missing filestack URLs`);
                return false;
            }

            this.addToCartInProcess = true;
            if(this.sortable) this.sortable.option("disabled", true);

            // Show loading state
            const a2cbtn = document.querySelector('.cl_st__atc-btn');
            if (a2cbtn) {
                a2cbtn.classList.add('loading');
                a2cbtn.innerText = 'Processing...';
            }

            // Create items array for cart
            const items = [];

            const {  id: variantID, collageConfig } = this.collageVariantData;
            const {acrylic, acrylicPrice, size, style, id, width, height } = this.state.Collage;

            // const { blob, url } = await this.getCollageImageUrl();
            // const { blob: vizBlob, url:vizUrl } = await this.getCollageImageUrl(false);
            
            // const fileStackUrlCollage = await this.uploadToFilestack(blob);
            // const fileStackUrlCollageViz = await this.uploadToFilestack(vizBlob);

            // console.log(fileStackUrlCollage,fileStackUrlCollageViz )

            const {frames} = this.state.Collage;
            // Process each frame (using the same logic as addToCartWithProducts)
            const frameProperties = {};
            for (let i = 0; i < frames.length; i++) {
                const frame = frames[i];
                const { image, id: frameId } = frame;

                let croppedUrl = image?.filestackUrl || null;

                try {
                    if (image?.filestackUrl) {
                        const frameElm = document.querySelector(`.frame[data-frame-id=${frameId}]`);
                        const { crop } = this.getCropPoints(frameElm);
                        image.crop = crop;
                        croppedUrl = this.addCropToFilestackUrl(image.filestackUrl, image.crop, 0, image.imgStyles.rotation);
                    }
                } catch (err) {
                    console.warn('⚠️ Error generating cropped URL:', err);
                }

                // Build keys like _img1croppedImg_, _img1orgImg_
                const idx = i + 1;
                frameProperties[`_img${idx}croppedImg_`] = croppedUrl;
                frameProperties[`_img${idx}orgImg_`] = image?.filestackUrl || null;
                this.updateCollageState({ "image.croppedUrl": croppedUrl }, null, frameId);
            }

            // Generate collage images
            let fileStackUrlCollage, fileStackUrlCollageViz;
            let cutSizeResult, vizResult;
            
            try {
                console.log('Generating collage images...');
                
                // Generate both collage images
                cutSizeResult = await this.getCollageImageUrl(true);
                vizResult = await this.getCollageImageUrl(false);
                
                console.log('Generated collage results', {
                    cutSizeSize: `${(cutSizeResult.blob.size / 1024 / 1024).toFixed(2)}MB`,
                    vizSize: `${(vizResult.blob.size / 1024 / 1024).toFixed(2)}MB`
                });
                
                // Upload to Filestack with retry logic (DON'T revoke until after upload)
                console.log('☁️ Uploading to Filestack...');
                fileStackUrlCollage = await this.uploadToFilestackWithRetry(cutSizeResult.blob, 'cutsize');
                fileStackUrlCollageViz = await this.uploadToFilestackWithRetry(vizResult.blob, 'viz');
                
                console.log('Filestack uploads successful:', {
                    cutSize: fileStackUrlCollage,
                    viz: fileStackUrlCollageViz
                });
                
                cutSizeResult.revoke();
                vizResult.revoke();
                
            } catch (uploadError) {
                console.error('❌ Upload failed:', uploadError);
                
                if (cutSizeResult?.revoke) cutSizeResult.revoke();
                if (vizResult?.revoke) vizResult.revoke();
                
                if (a2cbtn) {
                    a2cbtn.classList.remove('loading');
                    a2cbtn.innerText = 'Upload Failed - Try Again';
                    
                    setTimeout(() => {
                        this.addToCartInProcess = false;
                        if(this.sortable) this.sortable.option("disabled", false);
                        a2cbtn.innerText = 'Add To Cart';
                    }, 3000);
                }
                return false;
            }
            console.log('Collage images ready for cart addition');

            // Verify uploads succeeded
            if (!fileStackUrlCollage || !fileStackUrlCollageViz) {
                console.error('Missing Filestack URLs after upload');
                if (a2cbtn) {
                    a2cbtn.classList.remove('loading');
                    a2cbtn.innerText = 'Upload Failed - Try Again';
                    
                    setTimeout(() => {
                        this.addToCartInProcess = false;
                        if(this.sortable) this.sortable.option("disabled", false);
                        a2cbtn.innerText = 'Add To Cart';
                    }, 3000);
                }
                return false;
            }

            const s3Img = this.generateS3Url();
            const gcsImg = s3Img.replace('https://ffpf.s3.us-west-1.amazonaws.com/', 'https://storage.googleapis.com/pf4ff/');
            let mainCollageProperties = this?.getCollagePropertiesById();

            items.push({
                id: variantID.toString(),
                quantity: 1,
                properties: {
                    "_collageid_": id,
                    "_acrylic_": "true",
                    "_border_":"Collage1",
                    "_style_": style,
                    "_size_": size,
                    "_width_": width,
                    "_height_": height,
                    "_varId_": variantID.toString(),
                    "_cutSizeCollageImg_": fileStackUrlCollage,
                    "_visCollageImg_": fileStackUrlCollageViz,
                    ...frameProperties,
                    "_s3Img_": s3Img + ".png",
                    "_s3Pdf_": s3Img + ".pdf",
                    "_gcsImg_": gcsImg + ".png",
                    "_gcsPdf_": gcsImg + ".pdf",
                    "_mainCollage_":  JSON.stringify(mainCollageProperties),
                }  
            });

            // Check if we have items to add
            if (!items.length) {
                console.warn('⚠️ No valid items found to add to cart');
                // Reset button state on error
                if (a2cbtn) {
                    a2cbtn.classList.remove('loading');
                    a2cbtn.innerText = 'Try Again';
                    
                    setTimeout(() => {
                        this.addToCartInProcess = false;
                        if(this.sortable) this.sortable.option("disabled", false);
                        a2cbtn.innerText = 'Add To Cart';
                    }, 3000);
                }
                return false;
            }
            console.log('🛒 Adding to cart with items:', items);
            // Add items to cart via AJAX
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
                },
                body: JSON.stringify({ items })
            })
            .then(response => response.json())
            .then(data => {
                console.log('✅ Items added to cart:', data);
                
                // Clear all frames from state/database before redirecting
                // this.clearAllFrames();
                this.clearSavedState();
                
                // Reset button state
                if (a2cbtn) {
                    a2cbtn.classList.remove('loading');
                    a2cbtn.innerText = 'Added To Cart';
                }
                window.location.href = '/cart';
            })
            .catch(error => {
                console.error('❌ Error adding items to cart:', error);
                
                // Reset button state on error
                if (a2cbtn) {
                    a2cbtn.classList.remove('loading');
                    a2cbtn.innerText = 'Try Again';
                    
                    setTimeout(() => {
                        this.addToCartInProcess = false;
                        if(this.sortable) this.sortable.option("disabled", false);
                        a2cbtn.innerText = 'Add To Cart';
                    }, 3000);
                }
            });
            
            return true;
      
            
        } catch (error) {
            const a2cbtn = document.querySelector('.cl_st__atc-btn');
            if (a2cbtn) {
                a2cbtn.classList.remove('loading');
                a2cbtn.innerText = 'Error - Try Again';
            
                setTimeout(() => {
                    this.addToCartInProcess = false;
                    if(this.sortable) this.sortable.option("disabled", false);
                    a2cbtn.innerText = 'Add To Cart';
                }, 3000);
            }
            console.error(error)
        }
    }

    // Helper method: Upload to Filestack with retry logic
    async uploadToFilestackWithRetry(blob, type = 'collage', maxRetries = 3) {
        let lastError;
        
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
                console.log(`⏳ Upload attempt ${attempt}/${maxRetries} for ${type} (${(blob.size / 1024 / 1024).toFixed(2)}MB)...`);
                
                if (!blob || !(blob instanceof Blob) || blob.size === 0) {
                    throw new Error('Invalid blob: empty or null');
                }
                
                // Upload with 60s timeout
                const uploadPromise = this.uploadToFilestack(blob);
                const timeoutPromise = new Promise((_, reject) => 
                    setTimeout(() => reject(new Error('Upload timeout')), 60000)
                );
                
                const url = await Promise.race([uploadPromise, timeoutPromise]);
                
                if (!url || typeof url !== 'string' || url === 'undefined' || url === '' || url === 'null') {
                    throw new Error(`Upload returned invalid URL: ${url}`);
                }
                
                console.log(`Upload successful for ${type} on attempt ${attempt}`);
                return url;
                
            } catch (error) {
                lastError = error;
                console.error(`❌ Upload attempt ${attempt} failed for ${type}:`, error.message || error);
                
                if (attempt < maxRetries) {
                    const delay = Math.pow(2, attempt - 1) * 1000;
                    await new Promise(r => setTimeout(r, delay));
                }
            }
        }
        
        throw new Error(`Failed to upload ${type} after ${maxRetries} attempts: ${lastError?.message || lastError}`);
    }

    // Dynamically updates the Add To Cart button text and state based on upload progress
    updateAddToCartButton() {
      const atcBtn = document.querySelector('.cl_st__atc-btn');
      if (!atcBtn) return;

      let atcBtnText;

      if(atcBtn.innerText.indexOf("$") > -1){
        atcBtnText = atcBtn.innerText;
      }else{
        atcBtnText = "Add To Cart";
      }
      ;

      const state = Pg.State?.data;
      if (!state) return;

      const { computed } = state;
      const { uploadProgress, canAddToCart } = computed;

      // Remove existing classes
      atcBtn.classList.remove('loading', 'uploading', 'disa');

      if (!computed.hasFrames) {
        // No frames
        atcBtn.classList.add('disa');
        atcBtn.innerText = atcBtnText;
        return;
      }

      // Only show uploading state if user has clicked add to cart
      if (this.userTriedAddToCart && (uploadProgress.hasUploading || (uploadProgress.total > 0 && !uploadProgress.isComplete))) {
        // Uploads in progress and user tried to add to cart - keep button enabled
        atcBtn.classList.add('uploading');
        const completed = uploadProgress.completed;
        const total = uploadProgress.total;
        atcBtn.innerText = `Uploading ${completed}/${total}...`;
        return;
      }

      if (uploadProgress.hasFailures) {
        // Has failed uploads
        atcBtn.classList.add('disa');
        atcBtn.innerText = 'Upload Failed - Try Again';
        return;
      }

      if (canAddToCart) {
        // Ready to add to cart - reset flag if uploads are complete
        if (this.userTriedAddToCart && uploadProgress.isComplete) {
          this.userTriedAddToCart = false;
        }
        atcBtn.innerText = atcBtnText;
        return;
      }

      // If we have frames, always keep button enabled (uploads happen in background)
      if (computed.hasFrames) {
        atcBtn.innerText = atcBtnText;
        return;
      }

      // Only disable if no frames at all
      atcBtn.classList.add('disa');
      atcBtn.innerText = atcBtnText;
      
    }

    // Detects if browser is Safari
    isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    frameState = {
      scale: 1,
      startDist: 0,
      originX: 50,
      originY: 50,
      MIN: 1,
      MAX: 4,
      activeFrame: null,
      
      translateX: 0,
      translateY: 0,
      startMidX: 0,
      startMidY: 0,
    }

    setTransform(el) {
      el.style.transform = `translate(${this.frameState.translateX}px,${this.frameState.translateY}px)
        scale(${this.frameState.scale})`;
      el.style.transformOrigin = `${this.frameState.originX}% ${this.frameState.originY}%`;
    }

    getFrameElement(target) {
      // dynamically find the frame element
      if (target.classList.contains("collage-frame")) return target;
      return target.closest(".collage-frame");
    }

    pinchZoom = (e) => {
    if (e.touches.length !== 2) return;

      if (e.cancelable) e.preventDefault();

    //   S$Q(".frames_swiper").style.overflow = "unset";
      S$Q(".cl_main").style.zIndex = "999999";

      const frame = this.getFrameElement(e.target);
      if (!frame) return;

      // Disable ALL transitions during pinch
      frame.classList.add("no-transition", "zooming");
      frame.closest(".collage-frame").classList.add("zooming");
      S$Q("body").classList.add("body-lock");
      S$Q(".cl_wrapper").style.zIndex = 1;
      S$Q(".cl_fub.mo").style.display = "none";
      const finfo = frame.closest(".collage-frame")?.querySelector(".finfo");
      if (finfo) finfo.style.display = "none";

      const clEb = frame.querySelector(".cl_eb");
      if (clEb) clEb.style.display = "none";
      
      const container = frame.closest(".collage-frame");
      if (container) container.style.zIndex = "2";

      const cfp = frame.closest(".cfp");
      if (cfp) cfp.style.overflowY = "unset";

      // store frame reference ONCE
      this.frameState.activeFrame = frame;

      this.frameState.startDist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );

      const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;

      this.frameState.startMidX = midX;
      this.frameState.startMidY = midY;

      const rect = frame.getBoundingClientRect();
      this.frameState.originX =
        (((e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left) / rect.width) * 100;
      this.frameState.originY =
        (((e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top) / rect.height) * 100;

      // Attach move & end globally
      document.addEventListener("touchmove", this.touchMove, { passive: false });
      document.addEventListener("touchend", this.touchEnd);
      document.addEventListener("touchcancel", this.touchEnd);
    }

    touchMove = (e) => {
      if (e.touches.length !== 2) return;
      if (e.cancelable) e.preventDefault();

      const frame = this.frameState.activeFrame;
      if (!frame) return;

      const newDist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );

      this.frameState.scale *= newDist / this.frameState.startDist;
      this.frameState.scale = Math.min(
        this.frameState.MAX,
        Math.max(this.frameState.MIN, this.frameState.scale)
      );

      this.frameState.startDist = newDist;

      const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;

      // delta movement
      const dx = midX - this.frameState.startMidX;
      const dy = midY - this.frameState.startMidY;

      // accumulate translation
      this.frameState.translateX += dx;
      this.frameState.translateY += dy;

      // update start midpoint
      this.frameState.startMidX = midX;
      this.frameState.startMidY = midY;

      if (!this._raf) {
        this._raf = requestAnimationFrame(() => {
          this.setTransform(frame);
          this._raf = null;
        });
      }
    }

    touchEnd = (e) => {
      const frame = this.frameState.activeFrame;
      if (!frame) return;
      
      // Use setTimeout to ensure DOM is ready
      requestAnimationFrame(() => {
        void frame.offsetWidth;
        
        // Reset state
        this.frameState.scale = 1;
        this.frameState.originX = 50;
        this.frameState.originY = 50;
        this.frameState.startDist = 0;
        this.frameState.translateX = 0;
        this.frameState.translateY = 0;

        frame.style.transition = "transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
        this.setTransform(frame);

        setTimeout(() => {
          frame.style.transition = "";
          void frame.offsetWidth;
        }, 200);

        this.frameState.activeFrame = null;

        setTimeout(() => {
            frame.classList.remove("no-transition");
            frame.classList.remove("zooming");
            frame.closest(".collage-frame").classList.remove("zooming");
            S$Q("body").classList.remove("body-lock");
            S$Q(".cl_wrapper")?.style.removeProperty("z-index");

            const finfo = frame.closest(".collage-frame")?.querySelector(".finfo");
            finfo?.style.removeProperty("display");

            // S$Q(".frames_swiper")?.style.removeProperty("overflow");
            const cfp = frame.closest(".cfp");
            if (cfp) cfp.style.removeProperty("overflow-y");

            S$Q(".cl_fub.mo")?.style.removeProperty("display");

            const dpEb = frame.querySelector(".cl_eb");
            dpEb?.style.removeProperty("display");

            const container = frame.closest(".collage-frame");
            container?.style.removeProperty("z-index");

            S$Q(".cl_main").style.removeProperty("z-index");
        }, 50);

        document.removeEventListener("touchmove", this.touchMove);
        document.removeEventListener("touchend", this.touchEnd);
        document.removeEventListener("touchcancel", this.touchEnd);
      });
    }

    updateThumbMask(slider) {
        const rect = slider.getBoundingClientRect();
        const min = parseFloat(slider.min) || 0;
        const max = parseFloat(slider.max) || 100;
        const val = parseFloat(slider.value);
        const percent = (val - min) / (max - min);
        const thumbWidth = 20;
        const thumbBorder = 0;
        const thumbSize = thumbWidth + (thumbBorder * 2);

        // Calculate accurate thumb center position
        const trackWidth = rect.width;
        const thumbHalfSize = thumbSize / 2;
        
        // Account for thumb size in position calculation
        const thumbX = rect.left + thumbHalfSize + (percent * (trackWidth - thumbSize));
        const thumbY = rect.top + rect.height / 2;

        const root = document.documentElement;
        root.style.setProperty('--thumb-center-x', `${thumbX}px`);
        root.style.setProperty('--thumb-center-y', `${thumbY}px`);
        root.style.setProperty('--thumb-radius', `${thumbHalfSize}px`);
    }
    
    openPopupAnimation() {
      const pu = this.pu;
      const popupFrame = pu.ceF;
      const targetFrame = pu.cuF;
      popupFrame.classList.remove('is-animating');
      
      // Get FIRST position (original frame)
      const firstRect = targetFrame.getBoundingClientRect();

      // Make popup frame invisible temporarily
      popupFrame.style.opacity = "0";
      popupFrame.style.transition = "none";
      popupFrame.style.transform = "none";
      popupFrame.style.pointerEvents = "none"
      
      // Force reflow
      popupFrame.offsetHeight;
      
      // Force DOM update
      requestAnimationFrame(() => {
        // Get LAST position
        const lastRect = popupFrame.getBoundingClientRect();

        // Calculate differences
        const deltaX = firstRect.left - lastRect.left;
        const deltaY = firstRect.top - lastRect.top;
        const deltaScaleX = firstRect.width / lastRect.width;
        const deltaScaleY = firstRect.height / lastRect.height;
        
        popupFrame.style.transformOrigin = "top left";
        popupFrame.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${deltaScaleX}, ${deltaScaleY})`;

        popupFrame.style.opacity = "1";

        popupFrame.offsetHeight;
        
        popupFrame.style.transition = "";
        popupFrame.classList.add('is-animating');
        
        popupFrame.style.transform = "translate(0px, 0px) scale(1, 1)";
        
        S$Q(".cl_epu-box").classList.add("show");
        S$Q(".cl_epu").classList.add("show");
      });

      let cleanupTimer;
      let finished = false;
      // Handle transition end
      const onTransitionEnd = () => {
        if (finished) return;
        finished = true;

        if (cleanupTimer) {
            clearTimeout(cleanupTimer);
            cleanupTimer = null;
        }
        
        popupFrame.removeEventListener('transitionend', onTransitionEnd);
        popupFrame.classList.remove('is-animating');
        popupFrame.style.removeProperty("transform");
        popupFrame.style.removeProperty("transform-origin");
        popupFrame.style.removeProperty("pointer-events");
        S$Q(".cl_epu-box").classList.add("epu-ready");
      };
      
      popupFrame.addEventListener('transitionend', onTransitionEnd, { once: true });

      const MAX_TRANSITION_TIME = 350;
      cleanupTimer = setTimeout(onTransitionEnd, MAX_TRANSITION_TIME);

      setTimeout(() => {
        S$Q(".cl_epu-box").classList.add("epu-ready");
      }, MAX_TRANSITION_TIME);
    }

    createCloneForAnimation() {
        const pu = this.pu;
        const targetFrame = pu.cuF;
        const clone = targetFrame.cloneNode(true);
        clone.classList.add("clone-f");
        const rect = targetFrame.getBoundingClientRect();

        clone.style.position = "fixed";
        clone.style.left = rect.left + "px";
        clone.style.top = rect.top + "px";
        clone.style.width = rect.width + "px";
        clone.style.height = rect.height + "px";
        clone.style.margin = "0";
        clone.style.transform = "none";
        clone.style.zIndex = "9999";

        document.body.appendChild(clone);

        // Hide original
        targetFrame.style.opacity = "0";
        targetFrame.style.visibility = "hidden";
    }

    closePopupAnimation(close = false) {
        const pu = this.pu;
        const popupFrame = pu.ceF;
        const targetFrame = pu.cuF;
        
        if (!popupFrame || !targetFrame) return;
        
        S$Q(".cl_epu-box").classList.remove("epu-ready");
        
        const MAX_TIME = 400;
        const useReplica = close === true;
        
        // Determine which element to animate
        const sourceElement = useReplica ? targetFrame.cloneNode(true) : popupFrame;
        const isReplica = useReplica;
        
        if (isReplica) {
            // Setup replica
            sourceElement.classList.add('frame-replica');
            Object.assign(sourceElement.style, {
                position: 'fixed',
                margin: '0',
                zIndex: '9999',
                pointerEvents: 'none',
                transform: 'none',
                transition: 'none'
            });
            
            // Position replica exactly where popup is
            const popupRect = popupFrame.getBoundingClientRect();
            sourceElement.style.top = popupRect.top + 'px';
            sourceElement.style.left = popupRect.left + 'px';
            
            // Hide original popup
            popupFrame.style.opacity = '0';
            popupFrame.style.pointerEvents = 'none';
            
            // Add replica to DOM
            document.body.appendChild(sourceElement);
        } else {
            // Setup original popup for animation
            sourceElement.style.transition = "none";
            sourceElement.style.transformOrigin = "top left";
            sourceElement.style.transform = "translate(0px, 0px) scale(1, 1)";
            sourceElement.offsetHeight;
            sourceElement.style.transition = "";
            sourceElement.classList.add('is-animating');
        }
        
        // Get positions and calculate transforms
        const fromRect = isReplica ? popupFrame.getBoundingClientRect() : popupFrame.getBoundingClientRect();
        const toRect = targetFrame.getBoundingClientRect();
        
        const deltaX = toRect.left - fromRect.left;
        const deltaY = toRect.top - fromRect.top;
        let deltaScaleX = toRect.width / fromRect.width;
        let deltaScaleY = toRect.height / fromRect.height;
        
        // Force reflow for replica
        if (isReplica) {
            sourceElement.offsetHeight;
            sourceElement.style.transition = 'all 0.3s ease-in-out';
            sourceElement.style.transformOrigin = 'top left';
            deltaScaleX = 1;
            deltaScaleY = 1;
        }
        
        // Apply transform
        sourceElement.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${deltaScaleX}, ${deltaScaleY})`;
        
        S$Q(".cl_epu-box").style.backgroundColor = "rgba(255, 255, 255, 0)";
        if (this.dType === "M") {
            S$Q(".cl_epu").style.backgroundColor = "#11111190";
        }
        
        S$Q(".cl_epu-box").classList.remove("epu-ready");
        S$Q(".cl_epu").classList.remove("show");
        
        // Remove any existing clone
        const existingClone = document.querySelector(".frame.clone-f");
        if (existingClone) existingClone.remove();
        
        // Setup cleanup
        let finished = false;
        
        const cleanup = () => {
            if (finished) return;
            finished = true;
            
            if (isReplica) {
                if (sourceElement?.parentNode) {
                    sourceElement.remove();
                }
                // Reset popup styles
                popupFrame.style.removeProperty('opacity');
                popupFrame.style.removeProperty('pointer-events');
            } else {
                popupFrame.removeEventListener("transitionend", onEnd);
                popupFrame.classList.remove('is-animating');
            }
            
            // Common cleanup
            S$Q(".cl_epu-box").style.removeProperty("background-color");
            S$Q(".cl_epu").style.removeProperty("background-color");
            S$Q(".cl_epu").style.removeProperty("display");
            S$Q(".cl_epu-box").style.removeProperty("overflow");
            S$Q(".cl_epu").classList.remove("show");
            S$Q(".cl_epu-box").classList.remove("show");
            S$Q(".cl_epu").style.removeProperty("opacity");
            S$Q(".cl_epu-body").innerHTML = "";
            
            // Show target frame
            targetFrame.style.opacity = "1";
            targetFrame.style.removeProperty("visibility");
        };
        
        const onEnd = (e) => {
            if (e.target !== sourceElement) return;
            if (!isReplica && e.propertyName !== "transform") return;
            cleanup();
        };
        
        sourceElement.addEventListener("transitionend", onEnd, {once: true});
        setTimeout(cleanup, MAX_TIME);
    }

    // Generates a high-resolution PNG collage and returns a blob + object URL.
    async getCollageImageUrl(border = true) {
        const fullWidth = border ? this.full.frameOuterWidth : this.full.canvasWidth;
        const fullHeight = border ? this.full.frameOuterHeight : this.full.canvasHeight;
        const fullBorder = border ? this.full.border : 0;

        // ===== SAFE SCALING =====
        const MAX_PIXELS = 16_000_000;
        let renderWidth = fullWidth;
        let renderHeight = fullHeight;

        if (fullWidth * fullHeight > MAX_PIXELS) {
            const scale = Math.sqrt(MAX_PIXELS / (fullWidth * fullHeight));
            renderWidth = Math.floor(fullWidth * scale);
            renderHeight = Math.floor(fullHeight * scale);
        }

        // Generate SVG
        const svg = await this.generateSVG(border);
        const svgData = new XMLSerializer().serializeToString(svg);
        const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });

        const drawImage = async (url) => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            if (!ctx) throw new Error("Canvas 2D context unavailable");

            canvas.width = renderWidth;
            canvas.height = renderHeight;

            ctx.scale(renderWidth / fullWidth, renderHeight / fullHeight);
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, fullWidth, fullHeight);

            const img = new Image();
            img.crossOrigin = "anonymous";
            img.src = url;

            // Ensure the image is loaded before drawing
            await new Promise((resolve, reject) => {
                img.onload = () => resolve();
                img.onerror = (e) => reject(e);
            });

            if (img.decode) await img.decode().catch(() => {});
            
            if (!img.naturalWidth || !img.naturalHeight) throw new Error("Blank render");

            if (this.isSafari())  await new Promise(r => setTimeout(r, 100));

            ctx.drawImage(img, fullBorder, fullBorder);

            const blob = await this.safeToBlob(canvas);
            if (!blob || !blob.size) throw new Error("Empty PNG");

            return blob;
        };

        let blob;

        try {
            const objectUrl = URL.createObjectURL(svgBlob);
            blob = await drawImage(objectUrl);
            URL.revokeObjectURL(objectUrl);

        } catch {
            const base64Url = await this.toBase64(svgBlob);
            blob = await drawImage(base64Url);
        }

        const pngUrl = URL.createObjectURL(blob);

        return {
            blob,
            url: pngUrl,
            revoke: () => { if(pngUrl) URL.revokeObjectURL(pngUrl)}
        };
    }
    
    // Safe toBlob with fallback for Safari
    safeToBlob(canvas) {
        return new Promise((resolve, reject) => {
            canvas.toBlob(b => {
                if (b && b.size > 0) return resolve(b);

                try {
                    const dataUrl = canvas.toDataURL('image/png');
                    if (!dataUrl || dataUrl === 'data:,') {
                        return reject(new Error("toDataURL returned empty"));
                    }
                    const bin = atob(dataUrl.split(',')[1]);
                    const arr = new Uint8Array(bin.length);
                    for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
                    const blob = new Blob([arr], { type: 'image/png' });
                    if (!blob.size) return reject(new Error("Fallback blob empty"));
                    resolve(blob);
                } catch (e) {
                    reject(e);
                }
            }, 'image/png');
        });
    }

    // Builds the SVG version of the collage using base64 images
    async generateSVG(border) {
        const fullWidth = this.full.canvasWidth;
        const fullHeight = this.full.canvasHeight;

        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", fullWidth);
        svg.setAttribute("height", fullHeight);
        svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        svg.style.backgroundColor = "#fff";

        const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
        defs.innerHTML = `
            <filter id="grayscale">
                <feColorMatrix type="matrix"
                    values="0.33 0.33 0.33 0 0
                            0.33 0.33 0.33 0 0
                            0.33 0.33 0.33 0 0
                            0    0    0    1 0"/>
            </filter>
        `;
        svg.appendChild(defs);

        const scale = this.scaled.scaleToCal;
        const keys = Object.keys(this.posToIndex);

         // Step 1: preload all base64 images first
        const imagePromises = keys.map(async (key, index) => {
            try {
                const frame = this.frames.find(f => f?.editPos === index);
                if (frame?.image?.croppedUrl) {
                    const base64 = await this.urlToBase64(frame.image.croppedUrl);
                    if (!base64 || base64 === 'data:,') {
                        console.warn(`Failed to convert image ${index} to base64`);
                        return { index, base64: null };
                    }
                    return { index, base64 };
                }
                return { index, base64: null };
            } catch (error) {
                console.error(`Error processing image ${index}:`, error);
                return { index, base64: null };
            }
        });

        const imagesData = await Promise.all(imagePromises);
        console.log(`Preloaded ${imagesData.filter(img => img.base64).length} images`);

        for (let index = 0; index < keys.length; index++) {
            const frame = this.frames.find(f => f?.editPos === index);
            const foreignObject = document.querySelector(`foreignObject[data-index="${index}"]`);
            if (!foreignObject) {
                console.warn(`No foreignObject found for index ${index}`);
                continue;
            }

            const x = parseFloat(foreignObject.getAttribute("x")) / scale;
            const y = parseFloat(foreignObject.getAttribute("y")) / scale;
            const width = parseFloat(foreignObject.getAttribute("width")) / scale;
            const height = parseFloat(foreignObject.getAttribute("height")) / scale;

            const imageData = imagesData[index];
            
            if (imageData?.base64) {
                const svgImg = document.createElementNS("http://www.w3.org/2000/svg", "image");
                svgImg.setAttribute("x", x);
                svgImg.setAttribute("y", y);
                svgImg.setAttribute("width", width);
                svgImg.setAttribute("height", height);
                svgImg.setAttributeNS("http://www.w3.org/1999/xlink", "href", imageData.base64);
                svgImg.setAttribute("preserveAspectRatio", "none");

                if (frame?.image?.imgStyles?.filter?.includes("grayscale")) {
                    svgImg.setAttribute("filter", "url(#grayscale)");
                }

                svg.appendChild(svgImg);
            } else {
                console.log(`Adding placeholder for index ${index}`);
                const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                rect.setAttribute("x", x);
                rect.setAttribute("y", y);
                rect.setAttribute("width", width);
                rect.setAttribute("height", height);
                rect.setAttribute("fill", "#ccc");
                svg.appendChild(rect);
            }
        }

        console.log(`SVG created with ${keys.length} children`);
        return svg;
    }

    // Downloads the high-resolution SVG
    async previewSVG(border) {
        const fullWidth = border ? this.full.frameOuterWidth : this.full.canvasWidth;
        const fullHeight = border ? this.full.frameOuterHeight : this.full.canvasHeight;
        const fullBorder = border ? this.full.border : 0;

        // Generate SVG string
        const svg = await this.generateSVG(border); 

        let existingPreview = this.S$G("svg-preview");
        if (existingPreview) existingPreview.remove();

        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Set canvas dimensions
        canvas.width = fullWidth;
        canvas.height = fullHeight;

        const img = new Image();
        img.crossOrigin = "anonymous";
        const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
        const url = await this.toBase64(svgBlob)

        img.onload = async () => {
            try {
                await img.decode(); 
            } catch {}

            if (img.naturalWidth === 0 || img.naturalHeight === 0) {
                console.warn("Safari blank render, retrying...");
                setTimeout(() => (img.src = url), 50);
                return;
            }

            if (this.isSafari()) {
                await new Promise(r => setTimeout(r, 50)); 
            }
            
            // Fill background with white
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            ctx.drawImage(img, fullBorder, fullBorder);

            canvas.toBlob(function (pngBlob) {
                const pngUrl = URL.createObjectURL(pngBlob);
                const a = document.createElement('a');
                a.href = pngUrl;
                a.download = 'collage.png';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                setTimeout(() => {
                    URL.revokeObjectURL(pngUrl);
                    if (svg && svg.parentElement) {
                        svg.parentElement.removeChild(svg);
                    }
                }, 100);
            }, 'image/png');
        };

        setTimeout(() => {
            img.src = url;
        }, 0);

        // Clean up SVG element
        // if (svg && svg.parentElement) {
        //     svg.parentElement.removeChild(svg);
        // }

        // const wrapper = document.createElement("div");
        // wrapper.id = "svg-preview";
        // wrapper.style.marginTop = "20px";
        // wrapper.style.scale = "0.08";
        // wrapper.appendChild(svg);
        //      // wrapper.appendChild(canvas);
        // document.body.appendChild(wrapper);
        // document.body.style.overflow = "scroll"
    }
    
    // download collage as a image
    downloadSVG(border = true) {
        const {frames} = this.state.Collage;
        const images = this.images;
        // for (let i = 0; i < images.length; i++) {
        //     const img = images[i];

        //     if (!img || !img.filestackUrl) {
        //         alert(`Please upload all ${images.length} images. Image ${img?.originalPos
        //         + 1} is missing or still uploading.`);
        //         return false; 
        //     }
        // }
        
        for (let i = 0; i < frames.length; i++) {
            const frame = frames[i];
            if(!frame) continue;
            const { image, id: frameId } = frame;

            let croppedUrl = image?.filestackUrl || null;

            try {
                if (image?.filestackUrl) {
                    const frameElm = document.querySelector(`.frame[data-frame-id=${frameId}]`);
                    const { crop, visibleCrop } = this.getCropPoints(frameElm);
                    image.crop = crop;
                    croppedUrl = this.addCropToFilestackUrl(image.filestackUrl, crop, 0, image.imgStyles.rotation);
                    // console.log(croppedUrl, "-- cropped Url", crop, visibleCrop)
                }
            } catch (err) {
                console.warn('⚠️ Error generating cropped URL:', err);
            }
            this.updateCollageState({ "image.croppedUrl": croppedUrl }, null, frameId);
        }
        this.previewSVG(border);
    }

    // Convert url to base64
    async urlToBase64(url) {
        const res = await fetch(url, { mode: 'cors' });
        if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
        const blob = await res.blob();
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
    
    // Convert base64 to File/Blob 
    dataURLtoBlob(dataUrl) {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime }); 
    }

    // Convert File/Blob to base64
    toBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }
}


document.addEventListener("DOMContentLoaded", () => {
    let layoutId = 5
    new FrameForestApp(layoutId);
});